/* eslint-disable */
// ============================================================
// GridProof — ENGINE (verbatim faithful port of the proven
// single-file reference build, adapted to an ES module).
//
// WHAT CHANGED vs the original <script> blocks:
//   1. The two original <script> blocks (DATA seed + APP) are
//      concatenated here unchanged.
//   2. The top-level bootstrap (theme restore, load, render,
//      showLogin) is moved into an exported boot() so it runs
//      AFTER React has mounted the #app container.
//   3. saveToStorage also pings window.__gpPersist so the
//      Supabase layer can sync on every mutation.
//
// Everything else is identical to GridProof_Platform_final_v2.html.
// ============================================================

/* ====================================================================
   BALLYROE SOLAR FARM — real project data
   Sources: ZIM 26057 Ramming Plan V09, Conecon BV741 Piling Layout C100,
   ILOS100-BAL-202 Inverter Mounting, Ballyroe Alignment Measurements,
   Ballyroe Table Overview, ILOS1001-BAL-120 Stringing Layout.
   ==================================================================== */
window.BALLYROE = {

  project: {
    name: "Ballyroe Solar Farm",
    location: "Ballyhea, Charleville, Co. Cork, Ireland",
    gps: "52.302861° N, −8.684714° W",
    client: "ILOS Projects GmbH",
    epc: "Conecon GmbH",
    structure: "ZIMMERMANN PV-Steel — Sigma65 Fixed Tilt",
    inverterEng: "Detra Solar",
    system: "ZIM 26057",
    modules: 71388,
    moduleSpec: "2382 × 1134 × 30 mm",
    tilt: "17° ± 1°",
    fields: 13,
    drawingRev: "Ramming Plan V09 · Piling C100 Rev B · Inverter Rev 02"
  },

  // Bill of materials — verbatim from ZIM 26057 Ramming Plan V09 legend
  bom: [
    { grp:"Ramming piles (Sigma65)", color:"#6E8CA0", items:[
      { code:"Sigma65 — 3.5 m", qty:4748 },
      { code:"Sigma65 — 4.0 m", qty:4172 },
      { code:"Sigma65 — 4.3 m", qty:4151 },
      { code:"Sigma65 — 4.5 m", qty:1066 },
      { code:"Sigma65 — 4.8 m", qty:696 },   /* 556 + 140 */
      { code:"Sigma65 — 5.0 m", qty:3436 },
      { code:"Sigma65 — 5.1 m", qty:165 },
      { code:"Sigma65 — 5.4 m", qty:716 },
    ]},
    { grp:"Concrete piles (Sigma65)", color:"#9C7B4D", items:[
      { code:"Sigma65 concrete — 1.1 m", qty:244 },
      { code:"Sigma65 concrete — 1.7 m", qty:284 },
      { code:"Sigma65 concrete — 2.5 m", qty:244 },
      { code:"Sigma65 concrete — 3.2 m", qty:284 },
    ]},
    { grp:"Concrete foundations", color:"#7A6F5C", items:[
      { code:"6000×700×300 mm",  qty:64 },
      { code:"6000×800×300 mm",  qty:8 },
      { code:"6000×1000×300 mm", qty:0 },
      { code:"6000×1200×300 mm", qty:456 },
    ]},
    { grp:"C-Rail C120×60×2.0", color:"#C0563B", items:[
      { code:"9.471 m",  qty:126 },
      { code:"9.933 m",  qty:976 },
      { code:"10.395 m", qty:2010 },
      { code:"10.626 m", qty:1562 },
      { code:"11.550 m", qty:614 },
    ]},
    { grp:"Wind / shear bracing", color:"#E3B23C", items:[
      { code:"WBH Bracing — 3.500 m", qty:961 },
      { code:"WBH Bracing — 4.000 m", qty:395 },
      { code:"WBH Bracing — 4.500 m", qty:538 },
      { code:"WBH Bracing — 5.250 m", qty:282 },
      { code:"SBH Bracing — 3.500 m", qty:10 },
    ]},
  ],

  // Module geometry / tolerances from ramming plan + module install ITP
  geom: { dx:21, dy:20, overhang:125, tableGap:300, groundClear:999, invClear:669 },

  // 13 fields. Table counts derived from alignment workbook + ramming plan.
  // Progress / NCR figures reflect current construction status (Field 1 active per Conecon C100).
  fields: [
    { id:"Field 1",  tables:65, mwp:7.8,  done:46, ncr:2, x:62, y:6,  w:21, h:18 },
    { id:"Field 2",  tables:42, mwp:5.1,  done:28, ncr:1, x:46, y:18, w:17, h:15 },
    { id:"Field 3",  tables:38, mwp:4.6,  done:12, ncr:0, x:30, y:28, w:15, h:14 },
    { id:"Field 4",  tables:31, mwp:3.7,  done:0,  ncr:0, x:24, y:40, w:13, h:12 },
    { id:"Field 5",  tables:54, mwp:6.5,  done:0,  ncr:0, x:54, y:24, w:18, h:16 },
    { id:"Field 6",  tables:44, mwp:5.3,  done:0,  ncr:0, x:70, y:30, w:16, h:14 },
    { id:"Field 7",  tables:48, mwp:5.8,  done:0,  ncr:0, x:44, y:38, w:16, h:14 },
    { id:"Field 8",  tables:30, mwp:3.6,  done:0,  ncr:0, x:64, y:46, w:13, h:12 },
    { id:"Field 9",  tables:52, mwp:6.3,  done:0,  ncr:0, x:30, y:54, w:18, h:15 },
    { id:"Field 10", tables:49, mwp:5.9,  done:0,  ncr:0, x:48, y:52, w:17, h:14 },
    { id:"Field 11", tables:58, mwp:7.0,  done:0,  ncr:0, x:10, y:66, w:20, h:18 },
    { id:"Field 12", tables:61, mwp:7.3,  done:0,  ncr:0, x:32, y:72, w:21, h:18 },
    { id:"Field 13", tables:47, mwp:5.7,  done:0,  ncr:0, x:24, y:84, w:16, h:12 },
  ],

  // Table-type system (portrait layout) from piling layout legend + table overview
  tableTypes: {
    "3x27": { label:"3×27 portrait", color:"#2C9B73", piles:4, rows:3, cols:27, pilesPerRow:14 },
    "3x18": { label:"3×18 portrait", color:"#3A719E", piles:3, rows:3, cols:18, pilesPerRow:10 },
    "3x9":  { label:"3×9 portrait",  color:"#B8862B", piles:2, rows:3, cols:9,  pilesPerRow:5  },
  },

  // QC inspection test plan — split by what scope of work it actually belongs to.
  //  - tableItp:   mechanical + table-level electrical (DC dressing) — keyed by Field/Row/Table
  //  - stationItp: inverter + station-level electrical — keyed by Station/Inverter
  //  - siteItp:    civil + site-wide work that has no per-table location
  tableItp: [
    // Mechanical
    { scope:"mechanical", cat:"Table Mechanical Assembly", code:"MECH", item:"Installation Pile Extension", crit:"- Correct position and vertical alignment as per drawings.\n- Correct type of hardware and quantity used, with proper installation.\n  (nut, bolt, spring washer: M12×6, wide plain washer: M12×12)\n- Torque applied per manufacturer: M12 — 77 ± 3 Nm" },
    { scope:"mechanical", cat:"Table Mechanical Assembly", code:"MECH", item:"Girder Installation", crit:"- Girders mounted at 17° ± 1°.\n- Assembly aligned between the reference rope.\n- Correct hardware and quantity used.\n  (nut, bolt, spring washer: M16, wide plain washer: M16×2)\n- Torque applied per manufacturer: M16 — 180 ± 3 Nm" },
    { scope:"mechanical", cat:"Table Mechanical Assembly", code:"MECH", item:"C-Rail / Purlin Installation", crit:"- Purlins mounted on girders per drawing.\n- Purlin mounted at 90° to the pile.\n- Alignment verified using reference rope.\n- Correct rail lengths used based on table type (C120×60×2.0).\n- Proper spacing maintained.\n- Hardware: nut, bolt, spring washer M12, wide plain washer M12×2.\n- Torque: M12 — 77 ± 3 Nm" },
    { scope:"mechanical", cat:"Table Mechanical Assembly", code:"MECH", item:"Purlin Connector", crit:"- L-shaped connectors at correct location and orientation per drawing.\n- Proper engagement between purlins ensured.\n- Hardware: nut, bolt, spring washer M12×6, wide plain washer M12×12.\n- Torque: M12 — 77 ± 3 Nm" },
    { scope:"mechanical", cat:"Table Mechanical Assembly", code:"MECH", item:"Strut Installation", crit:"- Strut at correct position and orientation per manual.\n- Proper connection to girder and pile ensured.\n- Pile connection: nut, bolt, spring washer M12×2, plain washer M12×4.\n- Girder connection: nut, bolt, spring washer M10×4, plain washer M10×8.\n- Torque: M10 — 42 ± 2 Nm, M12 — 77 ± 3 Nm" },
    { scope:"mechanical", cat:"Ramming", code:"RAM", item:"Pile Embedment Depth", crit:"- Pile rammed to specified length class (Sigma65 3.5–5.4 m).\n- Embedment depth per geotech / ramming protocol.\n- No refusal or short-set without engineer sign-off." },
    { scope:"mechanical", cat:"Ramming", code:"RAM", item:"Pile Plumb & Head Level", crit:"- Verticality within ±1.5° tolerance.\n- Pile head level matches drawing value (e.g. 2.641 / 1.316 m).\n- Head undamaged after driving; galvanising intact at field cuts." },
    { scope:"mechanical", cat:"Modules", code:"MOD", item:"Module Installation", crit:"- Modules installed per approved layout and string plan.\n- Correct module type and rating (2382×1134×30 mm).\n- Frame seated properly on purlins.\n- Ground clearance per drawing: 999 mm.\n- Even spacing: 20 ± 1 mm between modules; 50 ± 20 mm from purlin end.\n- Torque: M8 — 15 ± 1 Nm" },
    // Table-level electrical (DC dressing on the table itself)
    { scope:"electrical", cat:"DC Cabling on Table", code:"CAB", item:"DC Cable Dressing", crit:"- DC string cables dressed on purlin and girder per table plan.\n- Cables protected from sharp edges.\n- Cables in conduit (≈60 cm) when crossing tables, fixed with 2 metal ties.\n- Connectors fully mated (audible click). DC connectors not exposed to water." },
    { scope:"electrical", cat:"DC Cabling on Table", code:"CAB", item:"Cable Ties", crit:"- Stainless ties at ≈40–50 cm intervals for conduits.\n- UV-resistant black ties at ≈40–50 cm for DC dressing on purlin." },
    { scope:"electrical", cat:"Table Earthing", code:"ERT", item:"Table Earth Bonding", crit:"- Flexible copper 16 mm² bridging expansion gap between tables.\n- All earth bolts torqued correctly and marked.\n- Hardware: nut, bolt, spring washer M10, plain washer M10×2." },
    { scope:"electrical", cat:"Labeling", code:"LBL", item:"Row/Table Label", crit:"- Row/table label on first pile from east (≈150 cm above ground), per naming convention." },
  ],

  // Station scope — per station, per inverter. 8 stations from civil drawings (T1–T8), each ~20 inverters.
  stationItp: [
    { cat:"Inverter Installation", code:"INV", item:"Inverter Mounting & Alignment", crit:"- Inverter vertically aligned and mounted on brackets.\n- Inverter earthing with 16 mm² cable.\n- Correct ground clearance per drawing ILOS100-BAL-202: 669 mm.\n- Flooded vs non-flooded mounting detail applied per area." },
    { cat:"Inverter Installation", code:"INV", item:"Inverter Structure Assembly", crit:"- Support structure installed between designated piles per approved drawings.\n- Spacing between inverter piles: 1500 mm.\n- Spacing between inverter purlins: 226 mm.\n- Correct hardware and torque per installation manual." },
    { cat:"Inverter Installation", code:"INV", item:"Inverter Protection Cage", crit:"- Cable tray per inverter assembly drawing (EXT-T1).\n- Geotextile layer fully laid, full coverage.\n- Adequate clearance for DC/AC cables, no bending stress.\n- HDPE pipe for AC/comms fixed with U-clamp to cage.\n- Sheep protection installed per detail." },
    { cat:"DC Termination", code:"DCT", item:"DC String Termination at Inverter", crit:"- DC strings terminated per stringing layout ILOS1001-BAL-120.\n- Polarity verified; torque per inverter manual.\n- Heat sleeves at conduit entry/exit." },
    { cat:"DC Termination", code:"DCT", item:"Conduit Fill at Inverter", crit:"- Ground-to-inverter cables in conduit, additionally in hard HDPE pipe.\n- Conduit fixed with metal ties to pile near inverter.\n- Conduit fill ratio < 40%.\n- HDPE pipes fixed with U-clamp, supported from inverter cage." },
    { cat:"AC / MV Termination", code:"MVT", item:"AC Cable to Transformer", crit:"- AC cable from inverter to transformer station per single-line diagram.\n- Cable type and CSA per spec; labelled at both ends.\n- Glands and seals fitted per IP rating." },
    { cat:"AC / MV Termination", code:"MVT", item:"MV Termination at Station", crit:"- MV cable termination kit per manufacturer instructions.\n- Earth screen continuity verified.\n- Phase identification correct and labelled.\n- Insulation resistance test recorded." },
    { cat:"Station Earthing", code:"ERT", item:"Station Earth Grid", crit:"- Earth rods installed to design depth.\n- Earth continuity ≤ 0.1 Ω across station.\n- Bonding to transformer tank, inverter cages, fence." },
    { cat:"Labeling", code:"LBL", item:"Inverter & Cable Labels", crit:"- Inverter label on top purlin of inverter structure (≈18–20 cm).\n- AC cable label on cable with black ties.\n- DC strings labelled per naming convention, at inverter entry." },
  ],

  // Site scope — site-wide civil and infrastructure work, NOT per-table.
  siteItp: [
    { cat:"Internal Roads", code:"RDW", item:"Road Type 1 Sub-base", crit:"- Compacted sub-base to design CBR per civil drawing 24278-MWP-06-00-DR-C-1000.\n- Width and edge profile per Road Type 1 section detail.\n- Crowning / cross-fall for drainage." },
    { cat:"Internal Roads", code:"RDW", item:"Road Surface & Drainage Falls", crit:"- Surface levels match drawing tolerances (±25 mm).\n- Cross-falls maintain runoff away from compound.\n- No standing water observed after rain events." },
    { cat:"Internal Roads", code:"RDW", item:"Passing Bays", crit:"- Passing bays located per road & panel layout drawings.\n- Adequate width for site vehicles.\n- Surface continuous with main road." },
    { cat:"Crossings & Culverts", code:"CRX", item:"Culvert Pipes & Headwalls", crit:"- Culverts at low points; pipe diameter per drawing.\n- Headwalls in place, no erosion at inlets / outlets.\n- Bedding and surround material per spec." },
    { cat:"Crossings & Culverts", code:"CRX", item:"Cable Crossings", crit:"- Cable crossings marked and protected with concrete slab/cover.\n- Warning tape laid above cables.\n- Crossing depth per spec." },
    { cat:"Perimeter Fence", code:"FNC", item:"Fence Line & Posts", crit:"- Posts plumb, set in concrete to drawing depth.\n- Spacing within tolerance, alignment within ±50 mm of survey line.\n- Mesh tensioned; no gaps at ground level (rabbit-proof bottom rail where specified)." },
    { cat:"Perimeter Fence", code:"FNC", item:"Gates", crit:"- Vehicle and pedestrian gates installed per layout (5 entrance gates per overall plan).\n- Padlock provision and signage in place.\n- Smooth swing, no fouling." },
    { cat:"Perimeter Fence", code:"FNC", item:"Fence Earthing", crit:"- Earthing strap continuous across gate hinges.\n- Fence bonded to site earth grid at specified intervals.\n- Continuity verified end-to-end." },
    { cat:"Site Drainage", code:"DRN", item:"Surface Water Drainage", crit:"- Drainage channels graded per civil drawings.\n- No ponding within compound or around stations.\n- Outfalls free-flowing, no erosion." },
    { cat:"Compound & Substation", code:"CMP", item:"Compound Hardstanding", crit:"- Compound area hardstanding compacted to spec.\n- Spare parts container area level and accessible.\n- Crane pad (11×11 m) per drawing 24278-MWP-06-00-DR-C-1003." },
    { cat:"Compound & Substation", code:"CMP", item:"Substation Boundary", crit:"- Substation fence and gate installed per layout.\n- Exclusion zone signage in place.\n- Security access controls operational." },
  ],

  // Transformer stations — derived from civil drawings (T1–T8). Each station hosts ~20 inverters.
  stations: [
    { id:"ST1", label:"Station T1", area:"Field 1 / South", invCount:20, padHeight:1.046, ref:"TRANSFORMER T01" },
    { id:"ST2", label:"Station T2", area:"Field 2 / South", invCount:20, padHeight:1.16,  ref:"TRANSFORMER T02" },
    { id:"ST3", label:"Station T3", area:"Field 3 / Mid",   invCount:20, padHeight:0.873, ref:"TRANSFORMER T03" },
    { id:"ST4", label:"Station T4", area:"Field 4 / Mid",   invCount:20, padHeight:0.731, ref:"TRANSFORMER T04" },
    { id:"ST5", label:"Station T5", area:"Field 7 / Mid",   invCount:20, padHeight:0.636, ref:"TRANSFORMER T05" },
    { id:"ST6", label:"Station T6", area:"Field 8 / North", invCount:20, padHeight:0.725, ref:"TRANSFORMER T06" },
    { id:"ST7", label:"Station T7", area:"Field 12 / North",invCount:20, padHeight:0.367, ref:"TRANSFORMER T07" },
    { id:"ST8", label:"Station T8", area:"Field 13 / North",invCount:20, padHeight:0.882, ref:"TRANSFORMER T08" },
  ],


  // Real alignment deviation samples (°) from the Field 1 alignment measurements
  deviations: [0.36,0.09,0.09,0.35,0.12,0.28,0.02,0.86,0.14,0.38,0.26,0.08,0.34,0.49,0.21,0.51,0.57,0.47,0.15,0.73,0.26,0.18,0.15,0.05,0.28,0.10,0.22,0.33,0.09,0.27,0.26,0.09,0.05,0.43,1.71,0.76,0.35,0.07,0.44,1.82,2.11,1.30,2.03,1.76,2.46,2.33,2.84,1.61,4.04,3.77,4.24,3.72,1.97,1.87,2.21,1.62,1.65,1.50,1.51],

  // Document register — every file in the project pack
  docs: [
    { type:"Ramming Plan", name:"ZIM 26057 Ballyroe Ramming Plan", rev:"V09", fmt:"PDF / DWG", color:"#6E8CA0", by:"Zimmermann PV-Steel", date:"21.01.2026", desc:"Full pile layout — Sigma65 fixed-tilt, ramming + concrete piles, foundations, wind bracing and C-rail schedule across all 13 fields." },
    { type:"Piling Layout", name:"BV741 Field 1 Piling Layout", rev:"Rev B (C100)", fmt:"PDF", color:"#E3B23C", by:"Conecon GmbH", date:"02.10.2025", desc:"Pile-by-pile setting-out for Field 1 (IDs 1–65) with rope-alignment detail and survey-mark offsets for rammed, concrete and inverter piles." },
    { type:"Inverter Mounting", name:"ILOS100-BAL-202 Inverter Mounting Details", rev:"Rev 02", fmt:"PDF", color:"#C0563B", by:"Detra Solar / ILOS", date:"28.11.2025", desc:"Flooded vs non-flooded mounting details, 669 mm ground clearance, sheep protection, DC/AC routing and minimum height tables." },
    { type:"Alignment Survey", name:"Ballyroe Alignment Measurements", rev:"—", fmt:"XLSX", color:"#5C8A4A", by:"Site survey", date:"Field log", desc:"Per-field table alignment deviations and C-rail span patterns (one sheet per field, 13 fields)." },
    { type:"Table Overview", name:"Ballyroe Table Overview", rev:"—", fmt:"XLSX", color:"#9C7B4D", by:"Engineering", date:"As-built ref", desc:"Table-by-table module-string composition and string colour coding for the full array." },
    { type:"Stringing Layout", name:"ILOS1001-BAL-120 Stringing Layout", rev:"Rev 02", fmt:"PDF", color:"#7FA8C9", by:"ILOS Projects", date:"Issued", desc:"Electrical stringing, transformer/inverter station positions (TR1–TR8, 4.3 MVA), MV/LV layout and cable entry." },
    { type:"Structure Source", name:"SP-TEG OneSolar Planning File", rev:"v02", fmt:"DWG", color:"#A99C84", by:"OneSolar", date:"2022-06-09", desc:"Source CAD planning file for the steel mounting system used as the structural basis for the array." },
  ],

  // Pile inspection test plan — per pile (ramming plan acceptance criteria)
  pileItp: [
    { cat:"Pile Setting-Out", code:"SET", item:"Position & Offset", crit:"- Pile set out to layout C100 with 0.5 m survey-mark offset.\n- Correct pile ID (A/B/C/D) for its position.\n- North/South row aligned to the reference rope." },
    { cat:"Ramming", code:"RAM", item:"Embedment Depth", crit:"- Pile rammed to specified length class (Sigma65 3.5–5.4 m).\n- Embedment depth per geotech / ramming protocol.\n- No refusal or short-set without engineer sign-off." },
    { cat:"Ramming", code:"RAM", item:"Plumb & Head Level", crit:"- Verticality within tolerance.\n- Pile head level matches drawing value (e.g. 2.641 / 1.316 m).\n- Head undamaged after driving." },
    { cat:"Pile Integrity", code:"INT", item:"Section & Coating", crit:"- Correct Sigma65 section, no buckling or splitting at head.\n- Galvanising intact; field-cut ends treated.\n- Concrete piles (where specified) to correct class." },
    { cat:"Structure Interface", code:"STR", item:"Bracket / Bolt Fit-up", crit:"- Bearing bracket fits without forcing.\n- Hardware and torque to manual (M12 — 77 ± 3 Nm).\n- Wind-bracing connection where applicable." },
  ],

  // QC seed records — current Field 1 mock-up acceptance
  seed: {
    0:["pass","All hardware to spec; torque marked and witnessed.","Catalin Radu","08:42",true,""],
    2:["fail","Purlin not at 90° to pile — reference-rope deviation beyond tolerance. Rework raised.","Catalin Radu","09:05",true,"NCR-BAL-014"],
    5:["pass","Pile embedment 4.2 m — within Sigma65 length class. No refusal.","Catalin Radu","09:12",false,""],
    7:["fail","Module spacing 24 mm, exceeds 20 ± 1 mm. Re-space required on east bay.","Catalin Radu","09:38",true,"NCR-BAL-015"],
    8:["pass","DC cables dressed correctly; conduit at table crossings; connectors clicked.","Catalin Radu","09:55",false,""],
    10:["pass","16 mm² copper bridge fitted across expansion gap; bolts marked.","Catalin Radu","10:15",false,""],
  },

  // -- CONTROLS: 6 electrical/civil QM disciplines from site QM reports ------
  disciplines: [
    { id:"ac-cables",    label:"AC Cables Trench",      code:"ACT", icon:"[AC]", color:"#E3A020",
      description:"AC low-voltage cable trench inspection — Station 2",
      drawingRef:"AC Trench Station No.2 · Bericht nr.: 01",
      itp:[
        {item:"Trench dimensions as per drawings",           crit:"Width, depth and profile match approved trench drawing."},
        {item:"Trench free of waste and stones",             crit:"No debris, soil clods or sharp objects present before laying."},
        {item:"Earthing conductor section/type (V4A)",       crit:"Cross-section and material (stainless V4A) match drawing specification."},
        {item:"Earthing branch clamps installed correctly",  crit:"Cross-connectors seated, bolted and torqued; no exposed conductor."},
        {item:"Sand bedding thickness as per design",        crit:"Minimum sand bed depth measured and confirmed per section drawing."},
        {item:"Number of AC cables per drawing",             crit:"Cable count in trench matches approved layout drawing."},
        {item:"Cable section 3×300 mm² / 1×300 mm²",        crit:"Cable size and type verified against specification."},
        {item:"Spacing between cables as per design",        crit:"Minimum separation between circuits maintained throughout run."},
        {item:"Sand bedding and warning tape installed",     crit:"Cover sand layer and red/yellow warning tape at correct depth."},
        {item:"No visual damage on cable insulation",        crit:"Full visual inspection — no cuts, abrasion or deformation."},
        {item:"Correct bending radius at branches/risers",  crit:"Radius ≥ manufacturer minimum at all bends and rise points."},
        {item:"Cables reach destination with spare length",  crit:"Sufficient tail length at inverter/transformer for termination."},
      ]},
    { id:"mv-cable",     label:"MV Cable Trench",        code:"MVT", icon:"[EL]", color:"#9B5DE5",
      description:"MV/LV electrical trench inspection — South field",
      drawingRef:"Trench layout South · P1DE0020-KLE-PSP-PH2-C-TRE-002.01",
      itp:[
        {item:"Trench depth and width",             crit:"Dimensions according to drawings for MV and data cable trench."},
        {item:"Trench visual inspection",           crit:"Trench free of waste, stone or any other debris before laying."},
        {item:"Sand bedding",                       crit:"Sand bedding thickness according to trench section drawing."},
        {item:"MV/Data cable depth verified",       crit:"Depth of MV and data cable layer checked and confirmed."},
        {item:"Cable ties at required spacing",     crit:"Cable tie installed at respective distances along run."},
        {item:"Cable section measurement in trench",crit:"MV/Data cables respect each section measurement per trench type."},
        {item:"Cable size, type and location",      crit:"Cable size, type and location per specifications and drawings."},
        {item:"Warning tape installed",             crit:"Warning tape at correct depth as per section drawing."},
        {item:"Backfilling compacted",              crit:"Backfill properly compacted in layers; no voids."},
      ]},
    { id:"road-works",   label:"Road Works",             code:"RDW", icon:"[RD]", color:"#888888",
      description:"Road construction QM inspection — South field",
      drawingRef:"P1DE0020-KLE-PSP-PH2-L-EAR-002.04-DR",
      itp:[
        {item:"Soil layer compacted properly",                  crit:"Compaction test results meet specification; no rutting."},
        {item:"Sub-base dimensions maintained",                 crit:"Width, depth and cross-fall of sub-base confirmed to drawings."},
        {item:"Sub-base placed and compacted to thickness",     crit:"Layer thickness and compaction level per specification."},
        {item:"Road surface material and finish",               crit:"Surface material type, grading and finish as specified."},
        {item:"Drainage channels clear and correctly graded",   crit:"Run-off channels formed; no ponding observed."},
        {item:"Turning areas and passing places formed",        crit:"Geometry matches site layout drawing; adequate width."},
      ]},
    { id:"transformer",  label:"Transformer Station",    code:"TST", icon:"[TS]", color:"#2C9B73",
      description:"Transformer station LV termination inspection — N-STS-01",
      drawingRef:"KLE_SCA.DRW.5.3_MON SLD_REV2 · Report CNC-BV748-E04-STS-01",
      itp:[
        {item:"LV cables terminated per approved drawings",     crit:"Termination points match SLD; cable IDs verified."},
        {item:"Correct lug type and size — LV",                 crit:"Lug cross-section and material match cable specification."},
        {item:"Heat shrink sleeves on all terminations",        crit:"Heat shrink applied, fully adhered, no exposed conductor."},
        {item:"No exposed conductor or loose strands",          crit:"Visual inspection confirms no strand fraying or bare copper."},
        {item:"Cables supported at entry; no sharp bends",      crit:"Cable trays/C-profile at transformer entry; min. bend radius observed."},
        {item:"Terminal tightening and torque applied",         crit:"Torque wrench used; values per specification recorded."},
        {item:"Clear labeling at AC breakers",                  crit:"All breakers labeled per as-built drawing; labels legible."},
      ]},
    { id:"mv-term",      label:"MV Termination",         code:"MVX", icon:"[MV]", color:"#E05C5C",
      description:"MV termination inspection at transformer station — N-STS-01",
      drawingRef:"KLE_SCA.DRW.5.3_MON SLD_REV2 · Report CNC-BV748-E06-STS-01",
      itp:[
        {item:"MV cables terminated per approved drawings",     crit:"Termination matches MV SLD; cable routing verified."},
        {item:"Correct lug type and size — MV",                 crit:"MV lug cross-section, material and compression verified."},
        {item:"Hot/cold shrink sleeves on all terminations",    crit:"Shrink sleeves fully seated; no air pockets or lifting."},
        {item:"No insulation defects at termination",           crit:"Visual and tactile check; no scoring, tracking or discolouration."},
        {item:"Terminal tightening and torque applied — MV",    crit:"Torque values recorded; bolts marked after tightening."},
      ]},
    { id:"dc-string",    label:"DC String Installation", code:"DCS", icon:"[DC]", color:"#F5A623",
      description:"DC string cable installation checklist — Station 1",
      drawingRef:"DC String Installation ST1 · Inverter checklist",
      itp:[
        {item:"DC string cables installed per table plan",      crit:"String routing matches table plan; polarity verified at inverter input."},
        {item:"Cable dressing on structure and at inverter",    crit:"Cables clipped/tied at required intervals; neat dressing at inverter glands."},
        {item:"Proper bending radius on all DC cables",         crit:"Minimum bend radius per cable manufacturer maintained throughout."},
        {item:"Cables free of damage and scratches",            crit:"Full visual inspection of insulation; no cuts, abrasion or UV damage."},
      ]},
  ],

  // -- TDD VAULT: document categories for technical due diligence -----------
  tddCategories: [
    { id:"design",    label:"Design & Drawings",    icon:"[DW]", color:"#3A719E" },
    { id:"test",      label:"Test Reports",         icon:"[TR]", color:"#2C9B73" },
    { id:"cert",      label:"Type Certificates",    icon:"[TC]", color:"#9B5DE5" },
    { id:"standard",  label:"IEC Standards",        icon:"[ST]", color:"#E3A020" },
    { id:"warranty",  label:"Warranties & O&M",     icon:"[WR]", color:"#E05C5C" },
    { id:"insurance", label:"Insurance & Legal",    icon:"[LG]", color:"#888888" },
    { id:"qm",        label:"QM Reports",           icon:"[QM]", color:"#1E7A57" },
  ],
  tddSeed: [
    // Design drawings
    {id:"tdd-1", cat:"design",   name:"Ramming Plan V09",                       ref:"ZIM-26057-BAL",        rev:"V09",        date:"2026-01", status:"approved", by:"Zimmermann PV-Steel", notes:"Full pile layout — Sigma65 fixed-tilt, ramming + concrete piles, foundations, wind bracing and C-rail schedule across all 13 fields"},
    {id:"tdd-2", cat:"design",   name:"Piling Layout Field 1 (C100)",           ref:"BV741-F1-C100",        rev:"B",          date:"2025-10", status:"approved", by:"Conecon GmbH",        notes:"Pile-by-pile setting-out for Field 1 (IDs 1-65) with rope-alignment detail and survey-mark offsets"},
    {id:"tdd-3", cat:"design",   name:"Inverter Mounting Details",              ref:"ILOS100-BAL-202",      rev:"02",         date:"2025-11", status:"approved", by:"Detra Solar / ILOS",  notes:"Flooded vs non-flooded mounting, 669 mm ground clearance, sheep protection, DC/AC routing"},
    {id:"tdd-4", cat:"design",   name:"Stringing Layout",                       ref:"ILOS1001-BAL-120",     rev:"02",         date:"2025-12", status:"approved", by:"ILOS Projects",       notes:"Electrical stringing, transformer/inverter station positions (TR1-TR8, 4.3 MVA), MV/LV layout"},
    {id:"tdd-5", cat:"design",   name:"Structure Source CAD",                   ref:"SP-TEG-OneSolar",      rev:"v02",        date:"2022-06", status:"approved", by:"OneSolar",            notes:"Source CAD planning file for the steel mounting system used as the structural basis for the array"},
    // Test reports / surveys
    {id:"tdd-6", cat:"test",     name:"Ballyroe Alignment Measurements",        ref:"ALIGN-BAL",            rev:"—",          date:"2026-02", status:"approved", by:"Site survey",         notes:"Per-field table alignment deviations and C-rail span patterns (one sheet per field, 13 fields)"},
    {id:"tdd-7", cat:"test",     name:"Ballyroe Table Overview",                ref:"TBL-BAL",              rev:"—",          date:"As-built", status:"approved", by:"Engineering",         notes:"Table-by-table module-string composition and string colour coding for the full array"},
    // QM reports
    {id:"tdd-8", cat:"qm",       name:"AC Cables Trench Report",                ref:"ACT-BAL-ST2-01",       rev:"1",          date:"2026-02", status:"approved", by:"Catalin Radu",          notes:"Station 2, all items accepted"},
    {id:"tdd-9", cat:"qm",       name:"MV Cable Trench Report",                 ref:"MVT-BAL-ST1-01",       rev:"1",          date:"2026-04", status:"approved", by:"Catalin Radu",            notes:"South field, Trench ST 1 & 2"},
    {id:"tdd-10",cat:"qm",       name:"Transformer Station Report",             ref:"CNC-BV748-E04",        rev:"1",          date:"2026-05", status:"approved", by:"Catalin Radu",            notes:"N-STS-01, LV terminations"},
    {id:"tdd-11",cat:"qm",       name:"MV Termination Report",                  ref:"CNC-BV748-E06",        rev:"1",          date:"2026-05", status:"approved", by:"Catalin Radu",            notes:"N-STS-01, MV terminations"},
    // Certificates / warranties
    {id:"tdd-12",cat:"cert",     name:"Sigma65 Type Certificate",               ref:"ZIMM-TC-SIG65",        rev:"—",          date:"2024-01", status:"approved", by:"TÜV Rheinland",       notes:"IEC 61215, IEC 61730"},
    {id:"tdd-13",cat:"warranty", name:"Module Warranty",                        ref:"MOD-WRN-BAL",          rev:"—",          date:"2025-06", status:"pending",  by:"Manufacturer",        notes:"30yr performance / 12yr product"},
  ],

  // -- ROLES ----------------------------------------------------------------
  roles: {
    inspector: { label:"Inspector",    operator:"Catalin Radu", color:"#2C9B73", canEdit:true,  canApprove:false, tddAccess:false, desc:"On-site QC inspector — full inspection access, pass/fail items." },
    qcmanager: { label:"QC Manager",   operator:"Catalin Radu", color:"#3A719E", canEdit:true,  canApprove:true,  tddAccess:true,  desc:"QC/QA Manager — approve reports, manage NCRs, full access." },
    auditor:   { label:"Auditor",      operator:"Catalin Radu", color:"#B8862B", canEdit:false, canApprove:true,  tddAccess:true,  desc:"Third-party auditor — read-only inspection view, can sign off." },
    tdd:       { label:"TDD Reviewer", operator:"Catalin Radu", color:"#9B5DE5", canEdit:false, canApprove:false, tddAccess:true,  desc:"Technical due diligence reviewer — Documents and QM reports only." },
    contractor:{ label:"Contractor",   operator:"Catalin Radu", color:"#C26B3E", canEdit:false, canApprove:false, tddAccess:false, canCloseout:true, desc:"EPC contractor — view assigned NCRs / RFIs and submit close-out evidence." },
    client:    { label:"Client",       operator:"Catalin Radu", color:"#6B7785", canEdit:false, canApprove:false, tddAccess:true,  desc:"Client / Owner — read-only dashboard and report downloads." },
  }
};

/* ===================== APP ===================== */
/* ===================== APP ===================== */
const D = window.BALLYROE;
// Back-compat alias: any legacy code path expecting D.itp gets the table-scope ITP.
D.itp = D.tableItp;
// Browser tab title: "GridProof · <project>" so each project's tab is
// distinguishable (multi-project ready) while still showing the brand.
try { document.title = "GridProof · " + (D.project && D.project.name ? D.project.name : "Solar Construction QC"); } catch(_){}
// Immutable copies of the original seed ITPs — used by "Reset to demo defaults"
// to restore the inspection plan if the user has edited it.
const _ORIGINAL_TABLE_ITP   = JSON.parse(JSON.stringify(D.tableItp));
const _ORIGINAL_STATION_ITP = JSON.parse(JSON.stringify(D.stationItp));
const _ORIGINAL_SITE_ITP    = JSON.parse(JSON.stringify(D.siteItp));
// C mirrors the active CSS theme variables so SVG/canvas drawing matches light/dark.
const C = { hiviz:"#2C9B73", steel:"#3A719E", grass:"#2C9B73", rust:"#B84545", peat:"#B8862B",
            amber:"#B8862B", dim:"#8C9DAD", dim2:"#637588", ink:"#E4EBF1", bg:"#0E141B", line:"#2A3744", sky:"#3A719E" };

/* -- Safe HTML escape for any user-provided text ------------------------- */
const _escMap = {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","`":"&#96;"};
function esc(s){ return String(s==null?"":s).replace(/[&<>"'`]/g, c=>_escMap[c]); }

/* -- Date/time formatters using user's locale and timezone --------------- */
function fmtDateTime(iso){
  if(!iso) return "—";
  try{ const d=new Date(iso); if(isNaN(d)) return iso;
    return new Intl.DateTimeFormat(undefined,{year:"numeric",month:"short",day:"2-digit",hour:"2-digit",minute:"2-digit"}).format(d);
  }catch(_){ return iso; }
}
function fmtTime(iso){
  if(!iso) return "";
  try{ const d=new Date(iso); if(isNaN(d)) return iso;
    return new Intl.DateTimeFormat(undefined,{hour:"2-digit",minute:"2-digit"}).format(d);
  }catch(_){ return iso; }
}
function fmtDate(iso){
  if(!iso) return "";
  try{ const d=new Date(iso); if(isNaN(d)) return iso;
    return new Intl.DateTimeFormat(undefined,{year:"numeric",month:"short",day:"2-digit"}).format(d);
  }catch(_){ return iso; }
}

/* -- Toast notifications ------------------------------------------------- */
function toast(msg, type){
  type = type || "info";
  let host = document.getElementById("toast-host");
  if(!host){
    host = document.createElement("div");
    host.id = "toast-host";
    document.body.appendChild(host);
  }
  const t = document.createElement("div");
  t.className = "toast toast-"+type;
  t.textContent = msg;
  host.appendChild(t);
  // Animate in next tick
  requestAnimationFrame(()=>t.classList.add("show"));
  setTimeout(()=>{
    t.classList.remove("show");
    setTimeout(()=>t.remove(), 200);
  }, 3200);
}

function refreshThemeColors(){
  const cs=getComputedStyle(document.documentElement);
  const g=v=>(cs.getPropertyValue(v)||"").trim();
  const map={hiviz:"--hiviz",steel:"--steel",grass:"--grass",rust:"--rust",peat:"--peat",
    amber:"--amber",dim:"--dim",dim2:"--dim2",ink:"--ink",bg:"--bg",line:"--line",sky:"--sky"};
  for(const k in map){ const val=g(map[k]); if(val) C[k]=val; }
  STATUS.pass.color=C.grass; STATUS.fail.color=C.rust; STATUS.pending.color=C.dim2;
}
const STATUS = {
  pass:{label:"Pass", color:C.grass, glyph:"✓"},
  fail:{label:"Fail", color:C.rust,  glyph:"✕"},
  pending:{label:"Open", color:C.dim2, glyph:""},
};
const fmt = n => n.toLocaleString("en-US");

// Build QC records from ITP
let records = D.itp.map((it,i)=>({
  id:i, cat:it.cat, code:it.code, item:it.item, crit:it.crit,
  itp:"BAL-"+it.code+"-"+String(i+1).padStart(3,"0"),
  x:[18,40,62,80,28,52,72,22,46,68,34,58,76][i%13],
  y:[24,24,24,24,44,44,44,64,64,64,82,82,82][i%13],
  status:"pending", note:"", photo:false, by:"", at:"", ncr:""
}));
Object.entries(D.seed).forEach(([id,[s,n,by,at,ph,ncr]])=>{
  const r=records[+id]; if(r){r.status=s;r.note=n;r.by=by;r.at=at;r.photo=ph;r.ncr=ncr;}
});

// Real per-(field,table) type map, installed by applyTopology() when the CAD
// topology is loaded from Supabase. When set, tableTypeFor() consults it first;
// otherwise the original deterministic pseudo-assignment is used (demo seed).
let realTypeByKey = null;

let currentRole = "inspector"; // inspector | qcmanager | auditor | tdd
let isLoggedIn = false;

let state = {
  view:"overview", selField:"Field 1", selQC:2, qcFilter:"all", placing:false, selTable:null,
  // QC drill-down
  qcField:"Field 1", qcRow:1, qcTable:1, qcItem:0, qcModule:null, showModules:false, qcPile:null, showPiles:false, mobileStep:"nav", qcPanelCollapsed:false, qcChecklistFilter:"all", qcMechFilter:"all", qcWorkScope:"table", qcStation:"ST1", qcInverter:0,
  // RFI register
  rfiFilter:"open",          // open | pending | scheduled | in_progress | closed | all
  rfiSelected:null,          // selected RFI id for detail
  rfiNew:false,              // show new RFI form
  // Controls
  ctrlDiscipline: D.disciplines[0].id,
  ctrlRecord: null,   // selected inspection record id
  ctrlItem: 0,
  // TDD Vault
  tddCat: "all",
  tddSearch: "",
  // Site map: show punch-item pins overlay (on by default — inspectors want to see issues)
  mapShowPins: true,
  // Site map: punch pin selected (for the popup); null when no popup is open
  mapPin: null,
};

/* -- localStorage persistence ------------------------------------------- */
const LS_KEY = "tt-ballyroe-data";
let _quotaWarned = false;
function saveToStorage(){
  try{
    const snap={
      inspections, tableStatus, stationInspections, siteInspection,
      rfis, rfiSeq, ncrSeq, tddDocs, currentRole, isLoggedIn, theme,
      // Inspection plan overrides — if user has added/edited/removed ITP items
      itp: { table:D.tableItp, station:D.stationItp, site:D.siteItp },
      ts:Date.now()
    };
    localStorage.setItem(LS_KEY, JSON.stringify(snap));
    _quotaWarned = false;
    // Supabase sync hook (added): the persistence layer debounces + pushes.
    try { if (typeof window !== "undefined" && window.__gpPersist) window.__gpPersist(snap); } catch (_) {}
  }catch(err){
    if(!_quotaWarned){
      _quotaWarned = true;
      toast("Storage full. Export a snapshot, then remove old photos.","error");
    }
  }
}
/* Walks all inspection records and rewrites legacy person names to the
   canonical operator (Catalin Radu). Idempotent and cheap. */
function migrateAuthorNames(){
  const LEGACY = /^(S\. Michaelis|G\. Surdu|N\. Erk|N\. Dahad|B\. Odeibat|M\. Brunner|C\. Radu)$/;
  const isLegacy = (s)=>typeof s==="string" && LEGACY.test(s.trim());
  let n=0;
  const fix = (rec)=>{
    if(!rec) return;
    if(isLegacy(rec.by)){ rec.by="Catalin Radu"; n++; }
    if(isLegacy(rec.resolvedBy)){ rec.resolvedBy="Catalin Radu"; n++; }
    (rec.comments||[]).forEach(c=>{ if(isLegacy(c.by)){ c.by="Catalin Radu"; n++; } });
    (rec.photos||[]).forEach(p=>{ if(isLegacy(p.by)){ p.by="Catalin Radu"; n++; } });
  };
  // Table-scope inspections (per fid::t and sub-keys)
  Object.values(inspections||{}).forEach(ins=>{
    (ins.comments||[]).forEach(c=>{ if(isLegacy(c.by)){ c.by="Catalin Radu"; n++; } });
    (ins.photos||[]).forEach(p=>{ if(isLegacy(p.by)){ p.by="Catalin Radu"; n++; } });
    Object.values(ins.items||{}).forEach(fix);
  });
  // Station-scope (per station, per inverter)
  Object.values(stationInspections||{}).forEach(byStation=>{
    Object.values(byStation||{}).forEach(inv=>{
      (inv.comments||[]).forEach(c=>{ if(isLegacy(c.by)){ c.by="Catalin Radu"; n++; } });
      (inv.photos||[]).forEach(p=>{ if(isLegacy(p.by)){ p.by="Catalin Radu"; n++; } });
      Object.values(inv.items||{}).forEach(fix);
    });
  });
  // Site-wide
  if(siteInspection){
    (siteInspection.comments||[]).forEach(c=>{ if(isLegacy(c.by)){ c.by="Catalin Radu"; n++; } });
    (siteInspection.photos||[]).forEach(p=>{ if(isLegacy(p.by)){ p.by="Catalin Radu"; n++; } });
    Object.values(siteInspection.items||{}).forEach(fix);
  }
  // RFIs
  Object.values(rfis||{}).forEach(r=>{
    if(isLegacy(r.requestedBy)) { r.requestedBy="Catalin Radu"; n++; }
    if(isLegacy(r.assignedTo))  { r.assignedTo="Catalin Radu"; n++; }
  });
  // TDD docs
  (tddDocs||[]).forEach(d=>{ if(isLegacy(d.by)) { d.by="Catalin Radu"; n++; } });
  return n;
}

function loadFromStorage(){
  try{
    const raw=localStorage.getItem(LS_KEY); if(!raw) return false;
    const snap=JSON.parse(raw);
    if(snap.inspections) inspections=snap.inspections;
    if(snap.tableStatus) tableStatus=snap.tableStatus;
    if(snap.stationInspections) stationInspections=snap.stationInspections;
    if(snap.siteInspection) siteInspection=snap.siteInspection;
    if(snap.rfis) rfis=snap.rfis;
    if(snap.rfiSeq!=null) rfiSeq=snap.rfiSeq;
    if(snap.ncrSeq!=null) ncrSeq=snap.ncrSeq;
    if(snap.tddDocs) tddDocs=snap.tddDocs;
    if(snap.currentRole) currentRole=snap.currentRole;
    if(snap.isLoggedIn) isLoggedIn=snap.isLoggedIn;
    if(snap.theme) applyTheme(snap.theme);
    // Restore any user-customized inspection plan
    if(snap.itp){
      if(Array.isArray(snap.itp.table))   { D.tableItp   = snap.itp.table;   D.itp = D.tableItp; }
      if(Array.isArray(snap.itp.station)) { D.stationItp = snap.itp.station; }
      if(Array.isArray(snap.itp.site))    { D.siteItp    = snap.itp.site;    }
    }
    // Rewrite legacy author names that may have been saved before the rename.
    const fixed = migrateAuthorNames();
    if(fixed>0){
      // Persist the cleaned state so subsequent loads don't re-migrate.
      try{ saveToStorage(); }catch(_){}
    }
    return true;
  }catch(_){ return false; }
}
function exportSnapshot(){
  try{
    const snap={
      inspections, tableStatus, stationInspections, siteInspection,
      rfis, rfiSeq, ncrSeq, tddDocs, currentRole,
      itp: { table:D.tableItp, station:D.stationItp, site:D.siteItp },
      ts:new Date().toISOString(), project:D.project.name
    };
    const blob=new Blob([JSON.stringify(snap,null,2)],{type:"application/json"});
    const u=URL.createObjectURL(blob),a=document.createElement("a");
    a.href=u; a.download=`GridProof_Snapshot_${new Date().toISOString().slice(0,10)}.json`; a.click(); URL.revokeObjectURL(u);
    toast("Snapshot exported","success");
  }catch(err){
    toast("Could not export snapshot","error");
  }
}
function importSnapshot(file){
  const r=new FileReader();
  r.onload=e=>{
    try{
      const snap=JSON.parse(e.target.result);
      if(snap.project && snap.project!==D.project.name){
        if(!confirm(`This snapshot is from "${snap.project}", not the current project. Import anyway?`)) return;
      }
      if(snap.inspections) inspections=snap.inspections;
      if(snap.tableStatus) tableStatus=snap.tableStatus;
      if(snap.stationInspections) stationInspections=snap.stationInspections;
      if(snap.siteInspection) siteInspection=snap.siteInspection;
      if(snap.rfis) rfis=snap.rfis;
      if(snap.rfiSeq!=null) rfiSeq=snap.rfiSeq;
      if(snap.ncrSeq!=null) ncrSeq=snap.ncrSeq;
      if(snap.tddDocs) tddDocs=snap.tddDocs;
      if(snap.itp){
        if(Array.isArray(snap.itp.table))   { D.tableItp   = snap.itp.table;   D.itp = D.tableItp; }
        if(Array.isArray(snap.itp.station)) { D.stationItp = snap.itp.station; }
        if(Array.isArray(snap.itp.site))    { D.siteItp    = snap.itp.site;    }
      }
      migrateAuthorNames();
      saveToStorage(); render();
      toast("Snapshot imported","success");
    }catch(_){ toast("Invalid snapshot file","error"); }
  };
  r.onerror=()=>toast("Could not read file","error");
  r.readAsText(file);
}

/* per-table acceptance status (Site Map quick accept/fail): key "Field 1::12" */
let tableStatus = {};
const tkey = (fid,t)=>`${fid}::${t}`;

/* -- Controls data store: key = disciplineId::recordId::itemIdx ----------- */
let controlsData = {};
function ctrlKey(discId, recId, itemIdx){ return `${discId}::${recId}::${itemIdx}`; }
function getCtrlItem(discId, recId, itemIdx){
  const k=ctrlKey(discId,recId,itemIdx);
  if(!controlsData[k]) controlsData[k]={status:"pending",by:"",at:"",ncr:"",comments:[],photos:[]};
  return controlsData[k];
}
function ctrlRecordRoll(discId, recId, disc){
  let pass=0,fail=0,done=0;
  disc.itp.forEach((_,i)=>{ const r=controlsData[ctrlKey(discId,recId,i)]; if(r){ if(r.status==="pass"){pass++;done++;} else if(r.status==="fail"){fail++;done++;}}});
  const overall=done===disc.itp.length&&done>0?(fail>0?"fail":"pass"):fail>0?"fail":done>0?"partial":"pending";
  return {pass,fail,done,total:disc.itp.length,overall};
}

/* -- TDD Vault document store --------------------------------------------- */
let tddDocs = D.tddSeed.map(d=>({...d}));
let tddDocSeq = tddDocs.length+1;

/* ----- QC inspection model: per (field, table) a checklist of ITP item results ----- */
const TABLES_PER_ROW = 8;
function rowsForField(f){ return Math.ceil(f.tables / TABLES_PER_ROW); }
function tablesInRow(f, row){
  const start=(row-1)*TABLES_PER_ROW+1;
  const end=Math.min(f.tables, row*TABLES_PER_ROW);
  const arr=[]; for(let t=start;t<=end;t++) arr.push(t); return arr;
}
const ikey = (fid,t)=>`${fid}::${t}`;
const mkey = (fid,t,m)=>`${fid}::${t}::M${m}`;   // module-level inspection key
// inspections[key] = { items:{ [itemId]:{...} }, status?, comments?, photos? }
let inspections = {};

/* -- Station inspections: per station, per inverter ----------------------- */
// stationInspections[stationId][invIdx] = { items:{ [itemId]:{...} }, comments, photos }
let stationInspections = {};
function getStationInv(stationId, invIdx){
  if(!stationInspections[stationId]) stationInspections[stationId] = {};
  if(!stationInspections[stationId][invIdx]) stationInspections[stationId][invIdx] = { items:{}, comments:[], photos:[] };
  return stationInspections[stationId][invIdx];
}
function stationInvItemResult(stationId, invIdx, itemId){
  const inv = getStationInv(stationId, invIdx);
  return inv.items[itemId] || { status:"pending", by:"", at:"", ncr:"", comments:[], photos:[] };
}
function setStationInvItem(stationId, invIdx, itemId, status){
  const inv = getStationInv(stationId, invIdx);
  if(status==="clear"){ delete inv.items[itemId]; return; }
  const cur = inv.items[itemId] || { status:"pending", by:"", at:"", ncr:"", comments:[], photos:[] };
  cur.status = status;
  cur.by = cur.by || (D.roles[currentRole]&&D.roles[currentRole].operator) || "Catalin Radu";
  cur.at = cur.at || nowHM();
  if(status==="fail" && !cur.ncr) cur.ncr = ncrRef(ncrSeq++);
  if(status==="pass") cur.ncr = "";
  inv.items[itemId] = cur;
}
// Roll-up of a single inverter across all stationItp items
function stationInvRoll(stationId, invIdx){
  const inv = getStationInv(stationId, invIdx);
  const total = D.stationItp.length;
  let pass=0, fail=0, done=0;
  D.stationItp.forEach((_,i)=>{
    const r = inv.items[i];
    if(r){ if(r.status==="pass"){pass++; done++;} else if(r.status==="fail"){fail++; done++;} }
  });
  let overall = "pending";
  if(done===total && total>0) overall = fail>0?"fail":"pass";
  else if(fail>0) overall = "fail";
  else if(done>0) overall = "partial";
  return {total, pass, fail, done, overall, rate: total?Math.round(done/total*100):0};
}
// Roll-up of an entire station across all its inverters
function stationRoll(station){
  const total = station.invCount * D.stationItp.length;
  let pass=0, fail=0, done=0;
  for(let i=0;i<station.invCount;i++){
    const r = stationInvRoll(station.id, i);
    pass += r.pass; fail += r.fail; done += r.done;
  }
  let overall = "pending";
  if(done===total && total>0) overall = fail>0?"fail":"pass";
  else if(fail>0) overall = "fail";
  else if(done>0) overall = "partial";
  return {total, pass, fail, done, overall, rate: total?Math.round(done/total*100):0};
}

/* -- Site-wide inspections: single record, no per-table key --------------- */
// siteInspection.items[itemId] = { status, by, at, ncr, comments, photos }
let siteInspection = { items:{}, comments:[], photos:[] };
function siteItemResult(itemId){
  return siteInspection.items[itemId] || { status:"pending", by:"", at:"", ncr:"", comments:[], photos:[] };
}
function setSiteItem(itemId, status){
  if(status==="clear"){ delete siteInspection.items[itemId]; return; }
  const cur = siteInspection.items[itemId] || { status:"pending", by:"", at:"", ncr:"", comments:[], photos:[] };
  cur.status = status;
  cur.by = cur.by || (D.roles[currentRole]&&D.roles[currentRole].operator) || "Catalin Radu";
  cur.at = cur.at || nowHM();
  if(status==="fail" && !cur.ncr) cur.ncr = ncrRef(ncrSeq++);
  if(status==="pass") cur.ncr = "";
  siteInspection.items[itemId] = cur;
}
function siteRoll(){
  const total = D.siteItp.length;
  let pass=0, fail=0, done=0;
  D.siteItp.forEach((_,i)=>{
    const r = siteInspection.items[i];
    if(r){ if(r.status==="pass"){pass++; done++;} else if(r.status==="fail"){fail++; done++;} }
  });
  let overall = "pending";
  if(done===total && total>0) overall = fail>0?"fail":"pass";
  else if(fail>0) overall = "fail";
  else if(done>0) overall = "partial";
  return {total, pass, fail, done, overall, rate: total?Math.round(done/total*100):0};
}

/* ----- RFI register: Requests for Inspection ------------------------------ */
// Each RFI is the *front door* to an inspection: contractor signals work is
// ready, QC schedules and assigns, inspector runs the existing checklist,
// then the RFI closes with an outcome derived from the inspection roll-up.
let rfiSeq = 4;  // next id after seeded RFIs
let rfis = {
  "RFI-BAL-001": {
    id:"RFI-BAL-001",
    scope:"table",
    target:{fid:"Field 1", row:1, t:1},
    title:"Field 1 · Row 01 · Table 1 — Mechanical complete",
    notes:"All Sigma65 hardware torqued, modules dressed, ready for handover walk.",
    requestedBy:"Conecon GmbH",
    requestedAt:"2026-05-26T07:40:00.000Z",
    requestedFor:"2026-05-28T09:00:00.000Z",
    status:"in_progress",
    assignedTo:"Catalin Radu",
    scheduledFor:"2026-05-28T09:00:00.000Z",
    closedAt:null, outcome:null,
  },
  "RFI-BAL-002": {
    id:"RFI-BAL-002",
    scope:"station",
    target:{stationId:"TR1", invIdx:[0,1,2,3]},
    title:"Station T1 — Inverters 1-4 ready for electrical inspection",
    notes:"DC strings landed, MV terminations torqued. Awaiting first acceptance walk.",
    requestedBy:"Conecon GmbH",
    requestedAt:"2026-05-27T11:15:00.000Z",
    requestedFor:"2026-05-29T10:00:00.000Z",
    status:"pending",
    assignedTo:null,
    scheduledFor:null,
    closedAt:null, outcome:null,
  },
  "RFI-BAL-003": {
    id:"RFI-BAL-003",
    scope:"site",
    target:null,
    title:"Site-wide — Road Type 1 sub-base, sections C-D",
    notes:"Sub-base compaction tests passed (CBR results attached separately). Ready for civil acceptance.",
    requestedBy:"Conecon GmbH",
    requestedAt:"2026-05-25T14:30:00.000Z",
    requestedFor:"2026-05-27T11:00:00.000Z",
    status:"closed",
    assignedTo:"Catalin Radu",
    scheduledFor:"2026-05-27T11:00:00.000Z",
    closedAt:"2026-05-27T13:15:00.000Z",
    outcome:"accepted_with_punch",
  },
};
const RFI_STATUS = {
  pending:     {label:"Pending",       color:"#B8862B", glyph:"⏱"},
  scheduled:   {label:"Scheduled",     color:"#3A719E", glyph:"📅"},
  in_progress: {label:"In progress",   color:"#2C9B73", glyph:"▶"},
  closed:      {label:"Closed",        color:"#637588", glyph:"✓"},
};
const RFI_OUTCOME = {
  accepted:            {label:"Accepted",            color:"#2C9B73"},
  accepted_with_punch: {label:"Accepted with punch", color:"#B8862B"},
  rejected:            {label:"Rejected",            color:"#B84545"},
};
function rfiNextId(){ return "RFI-BAL-"+String(rfiSeq++).padStart(3,"0"); }
function rfiList(){
  return Object.values(rfis).sort((a,b)=>{
    // Open RFIs first (pending > scheduled > in_progress > closed), then by requestedAt desc
    const order = {pending:0, scheduled:1, in_progress:2, closed:3};
    return (order[a.status]-order[b.status]) || (new Date(b.requestedAt) - new Date(a.requestedAt));
  });
}
function rfiCounts(){
  const c={pending:0, scheduled:0, in_progress:0, closed:0, all:0, open:0};
  Object.values(rfis).forEach(r=>{
    c[r.status]++; c.all++;
    if(r.status!=="closed") c.open++;
  });
  return c;
}
// Derive a target label (and a deeplink action) for an RFI
function rfiTargetLabel(rfi){
  if(rfi.scope==="table" && rfi.target){
    return `${rfi.target.fid} · Row ${String(rfi.target.row).padStart(2,"0")} · Table ${rfi.target.t}`;
  }
  if(rfi.scope==="station" && rfi.target){
    const st = D.stations.find(s=>s.id===rfi.target.stationId);
    const invs = rfi.target.invIdx||[];
    const range = invs.length>3 ? `INV ${invs[0]+1}-${invs[invs.length-1]+1}` : invs.map(i=>`INV${i+1}`).join(", ");
    return st ? `${st.label} · ${range}` : rfi.target.stationId;
  }
  if(rfi.scope==="site") return "Site-wide civil &amp; infrastructure";
  return "—";
}
// When an inspector starts an RFI, jump into the QC view at the right scope/target.
function rfiOpenInspection(id){
  const rfi = rfis[id]; if(!rfi) return;
  if(rfi.status==="pending"){ toast("Schedule this RFI first","warn"); return; }
  if(rfi.status==="scheduled"){
    pushHistory();
    rfis[id].status="in_progress";
  }
  // Navigate to QC at the correct scope
  state.qcWorkScope = rfi.scope;
  state.qcItem = 0;
  state.mobileStep = rfi.scope==="site" ? "checklist" : "nav";
  if(rfi.scope==="table" && rfi.target){
    state.qcField = rfi.target.fid;
    state.qcRow   = rfi.target.row;
    state.qcTable = rfi.target.t;
    state.qcModule=null; state.qcPile=null; state.showModules=false; state.showPiles=false;
  } else if(rfi.scope==="station" && rfi.target){
    // Resolve to a live station id — the station model is rebuilt from CAD
    // topology (TR ids) at boot, so a stale target must not orphan qcStation.
    const _st = D.stations.find(s=>s.id===rfi.target.stationId) || D.stations[0];
    state.qcStation = _st ? _st.id : rfi.target.stationId;
    state.qcInverter = (rfi.target.invIdx&&rfi.target.invIdx[0])|0;
  }
  setView("qc");
  toast(`Started inspection for ${id}`,"info");
}
// Compute a suggested outcome from the inspection roll-up
function rfiSuggestedOutcome(rfi){
  if(rfi.scope==="table" && rfi.target){
    const r = tableRoll(rfi.target.fid, rfi.target.t);
    if(r.overall==="pass") return "accepted";
    if(r.overall==="fail") return r.pass>0 ? "accepted_with_punch" : "rejected";
    return null;
  }
  if(rfi.scope==="station" && rfi.target){
    const invs = rfi.target.invIdx||[];
    let pass=0,fail=0;
    invs.forEach(i=>{ const r=stationInvRoll(rfi.target.stationId, i); if(r.overall==="pass")pass++; else if(r.overall==="fail")fail++; });
    if(fail===0 && pass===invs.length) return "accepted";
    if(fail>0 && pass>0) return "accepted_with_punch";
    if(fail>0) return "rejected";
    return null;
  }
  if(rfi.scope==="site"){
    const r = siteRoll();
    if(r.overall==="pass") return "accepted";
    if(r.overall==="fail") return r.pass>0 ? "accepted_with_punch" : "rejected";
    return null;
  }
  return null;
}

/* -- Undo/redo: snapshot inspections+tableStatus before each mutation ---- */
const HIST = { stack:[], future:[], max:30 };
function _snap(){ return { ins:JSON.stringify(inspections), tbl:JSON.stringify(tableStatus), sti:JSON.stringify(stationInspections), sit:JSON.stringify(siteInspection), rfi:JSON.stringify(rfis), rfiSeq:rfiSeq, ncr:ncrSeq }; }
function _restore(s){
  inspections = JSON.parse(s.ins);
  tableStatus = JSON.parse(s.tbl);
  if(s.sti) stationInspections = JSON.parse(s.sti);
  if(s.sit) siteInspection = JSON.parse(s.sit);
  if(s.rfi) rfis = JSON.parse(s.rfi);
  if(s.rfiSeq!=null) rfiSeq = s.rfiSeq;
  ncrSeq = s.ncr;
}
function pushHistory(){
  HIST.stack.push(_snap());
  if(HIST.stack.length>HIST.max) HIST.stack.shift();
  HIST.future.length=0; // any new edit clears the redo branch
  updateUndoUI();
}
function undo(){
  if(!HIST.stack.length){ toast("Nothing to undo","info"); return; }
  HIST.future.push(_snap());
  _restore(HIST.stack.pop());
  saveToStorage(); render();
  toast("Undone","info");
  updateUndoUI();
}
function redo(){
  if(!HIST.future.length){ toast("Nothing to redo","info"); return; }
  HIST.stack.push(_snap());
  _restore(HIST.future.pop());
  saveToStorage(); render();
  toast("Redone","info");
  updateUndoUI();
}
function updateUndoUI(){
  const u=document.getElementById("undobtn"), r=document.getElementById("redobtn");
  if(u) u.disabled=!HIST.stack.length;
  if(r) r.disabled=!HIST.future.length;
}
function getInsp(fid,t){
  const k=ikey(fid,t);
  if(!inspections[k]) inspections[k]={items:{}};
  return inspections[k];
}
function itemResult(fid,t,itemId){
  const ins=getInsp(fid,t);
  if(!ins.items[itemId]) ins.items[itemId]={status:"pending",note:"",photo:false,by:"",at:"",ncr:"",comments:[],photos:[]};
  const r=ins.items[itemId];
  if(!r.comments) r.comments=[];
  if(!r.photos) r.photos=[];
  return r;
}

/* ---- module-level QC: each module in a table holds status + its own ITP items + comments/photos ---- */
function getModule(fid,t,m){
  const k=mkey(fid,t,m);
  if(!inspections[k]) inspections[k]={status:"pending",comments:[],photos:[],items:{},by:"",at:""};
  const r=inspections[k];
  if(!r.comments) r.comments=[];
  if(!r.photos) r.photos=[];
  if(!r.items) r.items={};
  return r;
}
function modItemResult(fid,t,m,itemId){
  const mod=getModule(fid,t,m);
  if(!mod.items[itemId]) mod.items[itemId]={status:"pending",by:"",at:"",ncr:"",comments:[],photos:[]};
  const r=mod.items[itemId];
  if(!r.comments) r.comments=[];
  if(!r.photos) r.photos=[];
  return r;
}
// roll-up of one module from its own status (explicit) or its items
function moduleRoll(fid,t,m){
  const k=mkey(fid,t,m); const mod=inspections[k];
  if(!mod) return {overall:"pending",pass:0,fail:0,done:0,total:D.itp.length};
  // explicit module status wins; else derive from items
  let pass=0,fail=0,done=0;
  D.itp.forEach((_,i)=>{ const r=mod.items[i]; if(r){ if(r.status==="pass"){pass++;done++;} else if(r.status==="fail"){fail++;done++;} }});
  let overall=mod.status&&mod.status!=="pending" ? mod.status
    : (done===D.itp.length&&done>0 ? (fail>0?"fail":"pass") : fail>0?"fail":done>0?"partial":"pending");
  return {overall,pass,fail,done,total:D.itp.length};
}
// table roll-up across modules (how many modules accepted/failed)
function moduleTableRoll(fid,t,cols){
  let acc=0,fail=0,part=0,n=cols*3;
  for(let m=0;m<n;m++){ const r=moduleRoll(fid,t,m); if(r.overall==="pass")acc++; else if(r.overall==="fail")fail++; else if(r.overall==="partial")part++; }
  return {n,acc,fail,part,done:acc+fail};
}

/* ---- pile-level QC: each pile (North row + South row) holds status + ITP items + comments/photos ---- */
const pkey = (fid,t,p)=>`${fid}::${t}::P${p}`;   // pile-level inspection key
// pile index scheme: 0..pilesPerRow-1 = North row, pilesPerRow..2*pilesPerRow-1 = South row
function pileInfo(p,perRow){ const south=p>=perRow; return { side:south?"S":"N", col:(south?p-perRow:p)+1 }; }
function getPile(fid,t,p){
  const k=pkey(fid,t,p);
  if(!inspections[k]) inspections[k]={status:"pending",comments:[],photos:[],items:{},by:"",at:""};
  const r=inspections[k];
  if(!r.comments) r.comments=[];
  if(!r.photos) r.photos=[];
  if(!r.items) r.items={};
  return r;
}
function pileItemResult(fid,t,p,itemId){
  const pl=getPile(fid,t,p);
  if(!pl.items[itemId]) pl.items[itemId]={status:"pending",by:"",at:"",ncr:"",comments:[],photos:[]};
  const r=pl.items[itemId];
  if(!r.comments) r.comments=[];
  if(!r.photos) r.photos=[];
  return r;
}
function pileRoll(fid,t,p){
  const k=pkey(fid,t,p); const pl=inspections[k];
  if(!pl) return {overall:"pending",pass:0,fail:0,done:0,total:D.pileItp.length};
  let pass=0,fail=0,done=0;
  D.pileItp.forEach((_,i)=>{ const r=pl.items[i]; if(r){ if(r.status==="pass"){pass++;done++;} else if(r.status==="fail"){fail++;done++;} }});
  let overall=pl.status&&pl.status!=="pending" ? pl.status
    : (done===D.pileItp.length&&done>0 ? (fail>0?"fail":"pass") : fail>0?"fail":done>0?"partial":"pending");
  return {overall,pass,fail,done,total:D.pileItp.length};
}
function pileTableRoll(fid,t,perRow){
  let acc=0,fail=0,part=0,n=perRow*2;
  for(let p=0;p<n;p++){ const r=pileRoll(fid,t,p); if(r.overall==="pass")acc++; else if(r.overall==="fail")fail++; else if(r.overall==="partial")part++; }
  return {n,acc,fail,part,done:acc+fail};
}

/* ---- Effective table status for the site map ------------------------------
 * Combines the manager's manual signoff (tableStatus[k]) with the QC results
 * from inspections, modules, and piles. Rules:
 *   - If the manager has explicitly set "pass" or "fail", that wins.
 *   - Otherwise, derive from QC data:
 *       any item/module/pile failed  → "fail"
 *       every item/module/pile passed → "pass"
 *       partial progress              → "partial"
 *       nothing recorded yet          → undefined (the "not inspected" outline)
 *
 * Returns: "pass" | "fail" | "partial" | undefined
 * The `source` flag tells the caller which path produced the answer so the UI
 * can show a small "auto" hint vs "signed" hint if needed.
 */
/* A scope record (table-item / module / pile / inverter / site-item) counts as
   "started" ONLY when real inspection work exists — a definitive pass/fail, or a
   comment/photo. Merely OPENING a row lazily creates an empty pending record
   (itemResult/getModule/getPile/getStationInv), and those empty records must NOT
   count as progress on the map, in the QC counters, or in reports. (client issue) */
function _itemStarted(r){
  return !!r && (r.status==="pass" || r.status==="fail"
    || (r.comments && r.comments.length>0)
    || (r.photos && r.photos.length>0));
}
function recStarted(rec){
  if(!rec) return false;
  if(rec.status==="pass" || rec.status==="fail") return true;
  if(rec.comments && rec.comments.length>0) return true;
  if(rec.photos && rec.photos.length>0) return true;
  if(rec.items){ for(const k in rec.items){ if(_itemStarted(rec.items[k])) return true; } }
  return false;
}
function tableEffectiveStatus(fid, t){
  const manual = tableStatus[tkey(fid, t)];
  if(manual === "pass" || manual === "fail"){
    return { status: manual, source: "manual" };
  }
  // Look up the parent field to resolve table type (cols, pilesPerRow)
  const f = D.fields.find(x => x.id === fid);
  if(!f) return { status: undefined, source: "none" };
  const tt = D.tableTypes[tableTypeFor(f, t)];
  if(!tt) return { status: undefined, source: "none" };

  // 1. Table-level ITP items
  const ins = inspections[ikey(fid, t)];
  const itemsObj = ins && ins.items ? ins.items : {};
  let itemPass = 0, itemFail = 0, itemStartedN = 0;
  Object.keys(itemsObj).forEach(k => {
    const r = itemsObj[k];
    if(r.status === "pass") itemPass++;
    else if(r.status === "fail") itemFail++;
    if(_itemStarted(r)) itemStartedN++;
  });

  // 2. Module-level
  const modN = tt.rows * tt.cols;
  let modPass = 0, modFail = 0, modTouched = 0;
  for(let m=0; m<modN; m++){
    const mk = mkey(fid, t, m);
    const mod = inspections[mk];
    if(!recStarted(mod)) continue;   // empty record from merely opening a module → not progress
    modTouched++;
    const r = moduleRoll(fid, t, m);
    if(r.overall === "pass") modPass++;
    else if(r.overall === "fail") modFail++;
  }

  // 3. Pile-level
  const pileN = 2 * tt.pilesPerRow;
  let pilePass = 0, pileFail = 0, pileTouched = 0;
  for(let p=0; p<pileN; p++){
    const pk = pkey(fid, t, p);
    const pl = inspections[pk];
    if(!recStarted(pl)) continue;   // empty record from merely opening a pile → not progress
    pileTouched++;
    const r = pileRoll(fid, t, p);
    if(r.overall === "pass") pilePass++;
    else if(r.overall === "fail") pileFail++;
  }

  // ANY fail at any scope → red
  if(itemFail > 0 || modFail > 0 || pileFail > 0){
    return { status: "fail", source: "derived" };
  }
  // Fully green requires: all checklist items pass AND all modules pass AND all piles pass.
  // If module/pile data is empty (never inspected), require the checklist to be complete.
  const checklistAllPass = D.itp.length > 0 && itemPass === D.itp.length;
  const modulesAllPass   = modTouched === modN && modPass === modN;
  const pilesAllPass     = pileTouched === pileN && pilePass === pileN;

  if(checklistAllPass && modulesAllPass && pilesAllPass){
    return { status: "pass", source: "derived" };
  }
  // Some real work recorded but not fully complete
  if(itemStartedN > 0 || modTouched > 0 || pileTouched > 0){
    return { status: "partial", source: "derived" };
  }
  return { status: undefined, source: "none" };
}

/* ============================================================
   Store — single integration seam for a future backend.
   Today everything lives in memory. To wire a real API later,
   replace the bodies of these methods with fetch() calls; the
   rest of the app only ever talks to Store.* and re-renders.
   ============================================================ */
const Store = {
  _id(){ return Date.now().toString(36)+Math.random().toString(36).slice(2,6); },
  _author(){ return (D.roles[currentRole]&&D.roles[currentRole].operator) || "Catalin Radu"; },
  _now(){ const n=new Date(); return n.toISOString(); },
  _hm(d){ const n=new Date(d); return `${String(n.getHours()).padStart(2,"0")}:${String(n.getMinutes()).padStart(2,"0")}`; },
  _day(d){ return new Date(d).toLocaleDateString("en-IE",{day:"2-digit",month:"short"}); },

  addComment(fid,t,itemId,text){
    if(!text||!text.trim()) return;
    const r=itemResult(fid,t,itemId);
    r.comments.push({ id:this._id(), by:this._author(), at:this._now(), text:text.trim() });
    // TODO backend: POST /inspections/{fid}/{t}/items/{itemId}/comments
  },
  deleteComment(fid,t,itemId,cid){
    const r=itemResult(fid,t,itemId);
    r.comments=r.comments.filter(c=>c.id!==cid);
    // TODO backend: DELETE .../comments/{cid}
  },
  addPhotos(fid,t,itemId,photoObjs){
    const r=itemResult(fid,t,itemId);
    photoObjs.forEach(p=>r.photos.push({ id:this._id(), by:this._author(), at:this._now(), ...p }));
    r.photo = r.photos.length>0;
    // TODO backend: multipart POST .../photos  (send p.full)
  },
  deletePhoto(fid,t,itemId,pid){
    const r=itemResult(fid,t,itemId);
    r.photos=r.photos.filter(p=>p.id!==pid);
    r.photo = r.photos.length>0;
    // TODO backend: DELETE .../photos/{pid}
  },

  /* ---- module-level operations (field/table/module) ---- */
  setModuleStatus(fid,t,m,s){
    const mod=getModule(fid,t,m);
    if(s==="clear"){ mod.status="pending"; mod.items={}; mod.by=""; mod.at=""; return; }
    mod.status=s; mod.by=mod.by||this._author(); mod.at=mod.at||this._hm(this._now());
    // TODO backend: PUT /inspections/{fid}/{t}/modules/{m} {status}
  },
  setModuleItem(fid,t,m,itemId,s){
    const r=modItemResult(fid,t,m,itemId);
    if(s==="clear"){ delete getModule(fid,t,m).items[itemId]; return; }
    r.status=s; r.by=r.by||this._author(); r.at=r.at||this._hm(this._now());
    if(s==="fail"&&!r.ncr) r.ncr=ncrRef(ncrSeq++);
    if(s==="pass") r.ncr="";
    // TODO backend: PUT .../modules/{m}/items/{itemId} {status}
  },
  addModuleComment(fid,t,m,text){
    if(!text||!text.trim()) return;
    getModule(fid,t,m).comments.push({ id:this._id(), by:this._author(), at:this._now(), text:text.trim() });
  },
  deleteModuleComment(fid,t,m,cid){
    const mod=getModule(fid,t,m); mod.comments=mod.comments.filter(c=>c.id!==cid);
  },
  addModulePhotos(fid,t,m,photoObjs){
    const mod=getModule(fid,t,m);
    photoObjs.forEach(p=>mod.photos.push({ id:this._id(), by:this._author(), at:this._now(), ...p }));
  },
  deleteModulePhoto(fid,t,m,pid){
    const mod=getModule(fid,t,m); mod.photos=mod.photos.filter(p=>p.id!==pid);
  },

  /* ---- pile-level operations (field/table/pile) ---- */
  setPileStatus(fid,t,p,s){
    const pl=getPile(fid,t,p);
    if(s==="clear"){ pl.status="pending"; pl.items={}; pl.by=""; pl.at=""; return; }
    pl.status=s; pl.by=pl.by||this._author(); pl.at=pl.at||this._hm(this._now());
    // TODO backend: PUT /inspections/{fid}/{t}/piles/{p} {status}
  },
  setPileItem(fid,t,p,itemId,s){
    const r=pileItemResult(fid,t,p,itemId);
    if(s==="clear"){ delete getPile(fid,t,p).items[itemId]; return; }
    r.status=s; r.by=r.by||this._author(); r.at=r.at||this._hm(this._now());
    if(s==="fail"&&!r.ncr) r.ncr=ncrRef(ncrSeq++);
    if(s==="pass") r.ncr="";
    // TODO backend: PUT .../piles/{p}/items/{itemId} {status}
  },
  addPileComment(fid,t,p,text){
    if(!text||!text.trim()) return;
    getPile(fid,t,p).comments.push({ id:this._id(), by:this._author(), at:this._now(), text:text.trim() });
  },
  deletePileComment(fid,t,p,cid){
    const pl=getPile(fid,t,p); pl.comments=pl.comments.filter(c=>c.id!==cid);
  },
  addPilePhotos(fid,t,p,photoObjs){
    const pl=getPile(fid,t,p);
    photoObjs.forEach(o=>pl.photos.push({ id:this._id(), by:this._author(), at:this._now(), ...o }));
  },
  deletePilePhoto(fid,t,p,pid){
    const pl=getPile(fid,t,p); pl.photos=pl.photos.filter(x=>x.id!==pid);
  },

  /* ---- station-level operations (station/inverter) ---- */
  setStationInvItem(stationId, invIdx, itemId, s){
    const inv=getStationInv(stationId, invIdx);
    if(s==="clear"){ delete inv.items[itemId]; return; }
    const cur = inv.items[itemId] || { status:"pending", by:"", at:"", ncr:"", comments:[], photos:[] };
    cur.status=s; cur.by=cur.by||this._author(); cur.at=cur.at||this._hm(this._now());
    if(s==="fail"&&!cur.ncr) cur.ncr=ncrRef(ncrSeq++);
    if(s==="pass") cur.ncr="";
    inv.items[itemId]=cur;
    // TODO backend: PUT /stations/{stationId}/inverters/{invIdx}/items/{itemId} {status}
  },
  addStationInvComment(stationId, invIdx, itemId, text){
    if(!text||!text.trim()) return;
    const inv=getStationInv(stationId, invIdx);
    const item = inv.items[itemId] || (inv.items[itemId]={status:"pending",by:"",at:"",ncr:"",comments:[],photos:[]});
    item.comments=item.comments||[];
    item.comments.push({ id:this._id(), by:this._author(), at:this._now(), text:text.trim() });
    // TODO backend: POST /stations/{stationId}/inverters/{invIdx}/items/{itemId}/comments
  },
  deleteStationInvComment(stationId, invIdx, itemId, cid){
    const inv=getStationInv(stationId, invIdx);
    const item=inv.items[itemId]; if(!item) return;
    item.comments=(item.comments||[]).filter(c=>c.id!==cid);
    // TODO backend: DELETE .../comments/{cid}
  },
  addStationInvPhotos(stationId, invIdx, itemId, photoObjs){
    const inv=getStationInv(stationId, invIdx);
    const item = inv.items[itemId] || (inv.items[itemId]={status:"pending",by:"",at:"",ncr:"",comments:[],photos:[]});
    item.photos=item.photos||[];
    photoObjs.forEach(p=>item.photos.push({ id:this._id(), by:this._author(), at:this._now(), ...p }));
    // TODO backend: multipart POST .../photos
  },
  deleteStationInvPhoto(stationId, invIdx, itemId, pid){
    const inv=getStationInv(stationId, invIdx);
    const item=inv.items[itemId]; if(!item) return;
    item.photos=(item.photos||[]).filter(p=>p.id!==pid);
    // TODO backend: DELETE .../photos/{pid}
  },

  /* ---- site-wide operations (no per-table key) ---- */
  setSiteItem(itemId, s){
    if(s==="clear"){ delete siteInspection.items[itemId]; return; }
    const cur = siteInspection.items[itemId] || { status:"pending", by:"", at:"", ncr:"", comments:[], photos:[] };
    cur.status=s; cur.by=cur.by||this._author(); cur.at=cur.at||this._hm(this._now());
    if(s==="fail"&&!cur.ncr) cur.ncr=ncrRef(ncrSeq++);
    if(s==="pass") cur.ncr="";
    siteInspection.items[itemId]=cur;
    // TODO backend: PUT /site/items/{itemId} {status}
  },
  addSiteComment(itemId, text){
    if(!text||!text.trim()) return;
    const item = siteInspection.items[itemId] || (siteInspection.items[itemId]={status:"pending",by:"",at:"",ncr:"",comments:[],photos:[]});
    item.comments=item.comments||[];
    item.comments.push({ id:this._id(), by:this._author(), at:this._now(), text:text.trim() });
    // TODO backend: POST /site/items/{itemId}/comments
  },
  deleteSiteComment(itemId, cid){
    const item=siteInspection.items[itemId]; if(!item) return;
    item.comments=(item.comments||[]).filter(c=>c.id!==cid);
    // TODO backend: DELETE .../comments/{cid}
  },
  addSitePhotos(itemId, photoObjs){
    const item = siteInspection.items[itemId] || (siteInspection.items[itemId]={status:"pending",by:"",at:"",ncr:"",comments:[],photos:[]});
    item.photos=item.photos||[];
    photoObjs.forEach(p=>item.photos.push({ id:this._id(), by:this._author(), at:this._now(), ...p }));
    // TODO backend: multipart POST .../photos
  },
  deleteSitePhoto(itemId, pid){
    const item=siteInspection.items[itemId]; if(!item) return;
    item.photos=(item.photos||[]).filter(p=>p.id!==pid);
    // TODO backend: DELETE .../photos/{pid}
  },

  /* ---- RFI lifecycle (Request for Inspection) ---- */
  createRfi(payload){
    const id = rfiNextId();
    const now = this._now();
    rfis[id] = {
      id,
      scope: payload.scope,
      target: payload.target || null,
      title: payload.title || "",
      notes: payload.notes || "",
      requestedBy: payload.requestedBy || this._author(),
      requestedAt: now,
      requestedFor: payload.requestedFor || null,
      status: "pending",
      assignedTo: null,
      scheduledFor: null,
      closedAt: null,
      outcome: null,
    };
    // TODO backend: POST /rfis  {scope,target,title,notes,requestedFor}
    return id;
  },
  scheduleRfi(id, assignedTo, scheduledFor){
    const r = rfis[id]; if(!r) return;
    r.status = "scheduled";
    r.assignedTo = assignedTo || r.assignedTo || this._author();
    r.scheduledFor = scheduledFor || r.requestedFor || this._now();
    // TODO backend: PATCH /rfis/{id} {status:"scheduled", assignedTo, scheduledFor}
  },
  startRfi(id){
    const r = rfis[id]; if(!r) return;
    r.status = "in_progress";
    // TODO backend: PATCH /rfis/{id} {status:"in_progress"}
  },
  closeRfi(id, outcome){
    const r = rfis[id]; if(!r) return;
    r.status = "closed";
    r.closedAt = this._now();
    r.outcome = outcome;
    // TODO backend: PATCH /rfis/{id} {status:"closed", outcome, closedAt}
  },
  reopenRfi(id){
    const r = rfis[id]; if(!r) return;
    r.status = r.assignedTo ? "scheduled" : "pending";
    r.closedAt = null;
    r.outcome = null;
    // TODO backend: PATCH /rfis/{id} {status, closedAt:null, outcome:null}
  },
  deleteRfi(id){
    delete rfis[id];
    // TODO backend: DELETE /rfis/{id}
  },

  /* ---- punch-list resolution (works on any scope via the raw inspection key) ---- */
  setResolved(invKey,idx,val){
    const ins=inspections[invKey]; if(!ins||!ins.items||!ins.items[idx]) return;
    ins.items[idx].resolved=val;
    if(val){ ins.items[idx].resolvedBy=this._author(); ins.items[idx].resolvedAt=this._now(); }
    else { ins.items[idx].resolvedBy=""; ins.items[idx].resolvedAt=""; }
    // TODO backend: PATCH /inspections/{key}/items/{idx} {resolved}
  },

  /* ---- CAD/DWG topology ingest ----
   * Auto-populate the project topology (fields, tables, piles, stations,
   * inverters, roads, fence, drainage) by parsing CAD drawings on the backend.
   *
   * Backend contract:
   *
   *   POST /projects/{projectId}/topology/dwg-ingest
   *     Body:    multipart/form-data with one or more CAD files (.dwg/.dxf/.ifc)
   *     Returns: {
   *       extracted: TopologyPayload,
   *       warnings: [{ layer, message, severity:"info"|"warn"|"error" }],
   *       confidence: 0..1
   *     }
   *
   *   POST /projects/{projectId}/topology/commit
   *     Body:    TopologyPayload (after manual review & corrections)
   *     Returns: { projectId, version, ts }
   *
   * TopologyPayload shape (matches the in-memory D.* structure):
   *   {
   *     project:    { name, client, epc, location, gps },
   *     fields:     [{ id, tables, area_m2, ... }],
   *     tableTypes: { "3x27":{rows,cols,pilesPerRow,...}, "3x18":{...}, "3x9":{...} },
   *     stations:   [{ id, label, area, invCount, padHeight, ref, gps }],
   *     roads:      [{ id, type, length_m, polyline }],
   *     fence:      [{ id, length_m, polyline, gates:[{kind,gps}] }],
   *     drainage:   [{ id, kind, polyline }]
   *   }
   *
   * The ITPs (tableItp, stationItp, siteItp) are NOT part of the payload —
   * they're configured separately and apply to the extracted topology.
   *
   * Inspection records (inspections, stationInspections, siteInspection)
   * and RFIs are also independent and survive a topology commit.
   */
  async ingestTopology(files){
    // TODO backend: POST /projects/{D.project.id}/topology/dwg-ingest (multipart)
    return { ok:false, reason:"backend-not-connected",
      message:"CAD/DWG ingest requires the backend to be wired. The frontend contract is documented in this method's source." };
  },
  async commitTopology(payload){
    // TODO backend: POST /projects/{D.project.id}/topology/commit
    // On success: replace D.fields, D.tableTypes, D.stations, plus roads/fence/drainage
    //             and trigger render(). Existing inspections survive by key (fid::t etc.)
    //             unless a record is removed during commit — those become orphans
    //             and should be reviewed before deletion.
    return { ok:false, reason:"backend-not-connected" };
  },

  /* ---- Inspection plan (ITP) management ----
   * The ITP defines the checklist items used for each work scope (table, station,
   * site-wide). Items can be added, edited or removed per project. Existing
   * inspection records key on item index — so removing an item leaves any
   * recorded results orphaned by index; the UI surfaces this as a warning.
   *
   * Backend contract:
   *   GET    /itp/{scope}                 -> [ItpItem, ...]
   *   POST   /itp/{scope}                 -> ItpItem
   *   PATCH  /itp/{scope}/items/{idx}     -> ItpItem
   *   DELETE /itp/{scope}/items/{idx}     -> { idx, orphaned:n }
   *
   * Where scope ∈ {"table","station","site"} and ItpItem matches the shape
   * of items in D.tableItp / D.stationItp / D.siteItp.
   */
  _itpArr(scope){
    if(scope==="table")   return D.tableItp;
    if(scope==="station") return D.stationItp;
    if(scope==="site")    return D.siteItp;
    return null;
  },
  addItp(scope, item){
    const arr = this._itpArr(scope); if(!arr) return -1;
    // Validation: required fields
    if(!item || !item.item || !item.cat) return -1;
    const clean = {
      scope: scope==="table" ? (item.scope==="electrical" ? "electrical" : "mechanical") : undefined,
      cat: String(item.cat).trim(),
      code: String(item.code||"").trim().toUpperCase().slice(0,6) || "GEN",
      item: String(item.item).trim(),
      crit: String(item.crit||"").trim(),
    };
    // Drop scope key for non-table ITPs
    if(scope!=="table") delete clean.scope;
    arr.push(clean);
    if(scope==="table") D.itp = D.tableItp;
    // TODO backend: POST /itp/{scope}  body=clean
    return arr.length-1;
  },
  updateItp(scope, idx, patch){
    const arr = this._itpArr(scope); if(!arr || !arr[idx]) return false;
    const cur = arr[idx];
    if(patch.cat !== undefined)  cur.cat  = String(patch.cat).trim();
    if(patch.code !== undefined) cur.code = String(patch.code).trim().toUpperCase().slice(0,6) || cur.code;
    if(patch.item !== undefined) cur.item = String(patch.item).trim();
    if(patch.crit !== undefined) cur.crit = String(patch.crit).trim();
    if(scope==="table" && patch.scope !== undefined){
      cur.scope = patch.scope==="electrical" ? "electrical" : "mechanical";
    }
    // TODO backend: PATCH /itp/{scope}/items/{idx}  body=patch
    return true;
  },
  deleteItp(scope, idx){
    const arr = this._itpArr(scope); if(!arr || !arr[idx]) return 0;
    // Count how many inspection records would have orphaned results at this index.
    const orphaned = this._countItpUsage(scope, idx);
    arr.splice(idx,1);
    if(scope==="table") D.itp = D.tableItp;
    // Remove or shift recorded results so indices stay aligned.
    this._reindexItpUsage(scope, idx);
    // TODO backend: DELETE /itp/{scope}/items/{idx}
    return orphaned;
  },
  /* Returns how many recorded inspection items reference this ITP index. */
  _countItpUsage(scope, idx){
    const k = String(idx);
    let n = 0;
    if(scope==="table"){
      Object.values(inspections||{}).forEach(ins=>{
        if(ins && ins.items && ins.items[k]) n++;
      });
    } else if(scope==="station"){
      Object.values(stationInspections||{}).forEach(byStation=>{
        Object.values(byStation||{}).forEach(inv=>{
          if(inv && inv.items && inv.items[k]) n++;
        });
      });
    } else if(scope==="site"){
      if(siteInspection && siteInspection.items && siteInspection.items[k]) n++;
    }
    return n;
  },
  /* When an item is deleted at index `idx`, shift down every higher-indexed
   * recorded result so the remaining items still line up with the trimmed
   * ITP array. Drop the deleted index entirely. */
  _reindexItpUsage(scope, idx){
    const reindex = (items)=>{
      if(!items) return items;
      const next = {};
      Object.keys(items).forEach(k=>{
        const n = parseInt(k,10);
        if(isNaN(n)) { next[k] = items[k]; return; }
        if(n === idx) return;          // drop deleted
        if(n > idx)   next[String(n-1)] = items[k];
        else          next[k] = items[k];
      });
      return next;
    };
    if(scope==="table"){
      Object.values(inspections||{}).forEach(ins=>{
        if(ins) ins.items = reindex(ins.items);
      });
    } else if(scope==="station"){
      Object.values(stationInspections||{}).forEach(byStation=>{
        Object.values(byStation||{}).forEach(inv=>{
          if(inv) inv.items = reindex(inv.items);
        });
      });
    } else if(scope==="site"){
      if(siteInspection) siteInspection.items = reindex(siteInspection.items);
    }
  },
};

/* downscale an image File -> {thumb, full} data URLs (keeps memory sane) */
function processImage(file){
  return new Promise((resolve,reject)=>{
    const img=new Image(), url=URL.createObjectURL(file);
    img.onload=()=>{
      const mk=(maxW,q)=>{
        const sc=Math.min(1,maxW/img.width), w=Math.round(img.width*sc), h=Math.round(img.height*sc);
        const cv=document.createElement("canvas"); cv.width=w; cv.height=h;
        cv.getContext("2d").drawImage(img,0,0,w,h);
        return cv.toDataURL("image/jpeg",q);
      };
      // Tighter compression: smaller thumb, slightly smaller full image
      const out={ thumb:mk(200,.65), full:mk(1024,.75), name:file.name };
      URL.revokeObjectURL(url); resolve(out);
    };
    img.onerror=()=>{ URL.revokeObjectURL(url); reject(new Error("Could not load image")); };
    img.src=url;
  });
}

// Estimate localStorage usage; warn user when close to limit
function storageUsageKB(){
  try{
    let bytes=0;
    for(const k in localStorage){
      if(Object.prototype.hasOwnProperty.call(localStorage,k)){
        bytes += (localStorage[k]||"").length + k.length;
      }
    }
    return Math.round(bytes/1024);
  }catch(_){ return 0; }
}
function checkStorageHealth(){
  const kb=storageUsageKB();
  if(kb>4500) toast(`Storage almost full (${kb} KB). Export a snapshot soon.`,"warn");
  return kb;
}
// table roll-up status from its items
function tableRoll(fid,t){
  const ins=inspections[ikey(fid,t)];
  const total=D.itp.length;
  let pass=0,fail=0,done=0;
  if(ins){ D.itp.forEach((_,i)=>{ const r=ins.items[i]; if(r){ if(r.status==="pass"){pass++;done++;} else if(r.status==="fail"){fail++;done++;} } }); }
  let overall="pending";
  if(done===total && total>0) overall = fail>0?"fail":"pass";
  else if(fail>0) overall="fail";
  else if(done>0) overall="partial";
  return {total,pass,fail,done,overall,rate:total?Math.round(done/total*100):0};
}
let ncrSeq = 16;
// Format an NCR sequence number into its reference. Always pads to 3 digits so
// seq 100 -> "NCR-BAL-100" (the old "NCR-BAL-0"+seq concatenation produced
// "NCR-BAL-0100"). Shared by every failure site + the toast/QC view so the
// reference is generated in exactly one place.
function ncrRef(n){ return "NCR-BAL-"+String(n).padStart(3,"0"); }

// seed Field 1 / Table 1 from demo data so QC opens with realistic state
(function seedInsp(){
  const ins=getInsp("Field 1",1);
  Object.entries(D.seed).forEach(([id,[s,n,by,at,ph,ncr]])=>{
    const day=new Date(); day.setHours(+at.split(":")[0],+at.split(":")[1],0,0);
    ins.items[+id]={ status:s, by, at, ncr, photo:false,
      comments: n?[{ id:"seed"+id, by, at:day.toISOString(), text:n }]:[],
      photos: [] };
  });
})();

/* ---------- counts ---------- */
// flatten every recorded item result across all (field,table) inspections
function allResults(){
  const out=[];
  Object.entries(inspections).forEach(([k,ins])=>{
    const [fid,t]=k.split("::");
    Object.entries(ins.items).forEach(([i,r])=>{
      const it=D.itp[+i]; if(!it) return;
      out.push({fid,t,itemId:+i,cat:it.cat,code:it.code,item:it.item,
        itp:`BAL-${it.code}-${String(+i+1).padStart(3,"0")}`,...r});
    });
  });
  return out;
}

/* ---- PUNCH LIST: every failed item across table / module / pile scopes ---- */
function punchItems(){
  const out=[];
  Object.entries(inspections).forEach(([k,ins])=>{
    const parts=k.split("::");
    const fid=parts[0], t=parts[1], scopeKey=parts[2]||null;
    // determine scope + which ITP applies
    let scope="Table", ITP=D.tableItp, loc=`${fid} · T${t}`, where="";
    if(scopeKey && scopeKey[0]==="M"){
      scope="Module"; ITP=D.tableItp;
      const m=+scopeKey.slice(1); const ty=D.tableTypes[tableTypeFor(D.fields.find(x=>x.id===fid)||D.fields[0],+t)];
      const cols=ty?ty.cols:27; where=`Module R${Math.floor(m/cols)+1}·C${(m%cols)+1}`; loc=`${fid} · T${t} · ${where}`;
    } else if(scopeKey && scopeKey[0]==="P"){
      scope="Pile"; ITP=D.pileItp;
      const p=+scopeKey.slice(1); const ty=D.tableTypes[tableTypeFor(D.fields.find(x=>x.id===fid)||D.fields[0],+t)];
      const perRow=ty?ty.pilesPerRow:14; const info=pileInfo(p,perRow);
      where=`${info.side==="N"?"North":"South"} pile ${info.col}`; loc=`${fid} · T${t} · ${info.side}${info.col}`;
    }
    const items=ins.items||{};
    Object.entries(items).forEach(([i,r])=>{
      if(r.status!=="fail") return;
      const it=ITP[+i]; if(!it) return;
      const dscope = it.scope || "mechanical";
      out.push({
        key:k, idx:+i, scope, scopeKey, fid, t:+t, where,
        workScope:"table",
        cat:it.cat, code:it.code, item:it.item,
        disciplineScope:dscope,
        itp:`BAL-${it.code}-${String(+i+1).padStart(3,"0")}`,
        loc, ncr:r.ncr||"", by:r.by||"", at:r.at||"",
        resolved:!!r.resolved,
        comment:(r.comments&&r.comments.length)?r.comments[r.comments.length-1].text:""
      });
    });
  });
  // Station failures
  Object.entries(stationInspections).forEach(([stId, invs])=>{
    const st = D.stations.find(s=>s.id===stId); if(!st) return;
    Object.entries(invs).forEach(([invIdx, inv])=>{
      Object.entries(inv.items||{}).forEach(([i,r])=>{
        if(r.status!=="fail") return;
        const it = D.stationItp[+i]; if(!it) return;
        out.push({
          key:`${stId}::INV${invIdx}`, idx:+i, scope:"Inverter", scopeKey:`INV${invIdx}`,
          fid:stId, t:+invIdx+1, where:invLabel(stId, +invIdx),
          workScope:"station",
          cat:it.cat, code:it.code, item:it.item, disciplineScope:"electrical",
          itp:`BAL-${it.code}-${String(+i+1).padStart(3,"0")}`,
          loc:`${st.label} · ${invShort(stId, +invIdx)}`,
          ncr:r.ncr||"", by:r.by||"", at:r.at||"",
          resolved:!!r.resolved,
          comment:(r.comments&&r.comments.length)?r.comments[r.comments.length-1].text:""
        });
      });
    });
  });
  // Site failures
  Object.entries(siteInspection.items||{}).forEach(([i,r])=>{
    if(r.status!=="fail") return;
    const it = D.siteItp[+i]; if(!it) return;
    out.push({
      key:`SITE::${i}`, idx:+i, scope:"Site-wide", scopeKey:null,
      fid:"SITE", t:0, where:"Site-wide",
      workScope:"site",
      cat:it.cat, code:it.code, item:it.item, disciplineScope:"civil",
      itp:`BAL-${it.code}-${String(+i+1).padStart(3,"0")}`,
      loc:"Site-wide", ncr:r.ncr||"", by:r.by||"", at:r.at||"",
      resolved:!!r.resolved,
      comment:(r.comments&&r.comments.length)?r.comments[r.comments.length-1].text:""
    });
  });
  // sort: open first, then by work scope (table -> station -> site), then category, then location
  const wsOrder = {table:0, station:1, site:2};
  out.sort((a,b)=> (a.resolved-b.resolved) || (wsOrder[a.workScope]-wsOrder[b.workScope]) || a.cat.localeCompare(b.cat) || String(a.fid).localeCompare(String(b.fid)) || a.t-b.t);
  return out;
}
function punchByCat(){
  const items=punchItems(); const map={};
  items.forEach(p=>{ (map[p.cat]=map[p.cat]||[]).push(p); });
  return map;
}
// Group label for a punch item by physical location (issue #8). A field crew
// works one location at a time, so the punch list now groups by Field → Table
// (then transformer station, then site-wide) instead of by inspection category.
function punchLocKey(p){
  if(p.workScope==="site") return "Site-wide";
  if(p.workScope==="station"){ const st=D.stations.find(s=>s.id===p.fid); return st?st.label:p.fid; }
  return `${p.fid} · T${p.t}`;
}
function punchByLocation(){
  const rank=x=>x.workScope==="site"?2:x.workScope==="station"?1:0;
  const fno=x=>parseInt(String(x.fid||"").replace(/\D/g,""),10)||0;
  const items=punchItems().slice().sort((a,b)=>
    rank(a)-rank(b) || fno(a)-fno(b) || ((a.t||0)-(b.t||0)) || ((+a.idx||0)-(+b.idx||0)));
  const map={};
  items.forEach(p=>{ const k=punchLocKey(p); (map[k]=map[k]||[]).push(p); });
  return map;
}
function punchCounts(){
  const items=punchItems();
  const open=items.filter(p=>!p.resolved).length;
  return {total:items.length, open, resolved:items.length-open};
}

/* ---- Map pin geometry for punch-list items --------------------------------
 * Returns an array of pins ready to render on the .mapstage as %-positioned
 * dots. Each open punch item becomes one pin, placed within its parent field's
 * bounding box. When the CAD/DWG ingest is wired up, this function will be
 * replaced (or augmented) by a real lat/lon → screen-coord projection; for
 * now it uses the schematic field positions in D.fields[].{x,y,w,h}.
 *
 * The (offsetX, offsetY) deterministic spread inside each field prevents
 * multiple pins for the same table from sitting on top of each other.
 */
function punchPinsForMap(opts){
  const showResolved = !!(opts && opts.showResolved);
  const items = punchItems().filter(p => showResolved || !p.resolved);
  // Index fields and stations by id for quick lookup
  const fieldById = {};
  D.fields.forEach(f => { fieldById[f.id] = f; });
  // Stations: derive a parent-field for each one from its `area` string.
  const stationParent = {};
  D.stations.forEach(st => {
    // area looks like "Field 1 / South" — extract the field id
    const m = (st.area || "").match(/Field\s+\d+/i);
    if (m && fieldById[m[0]]) stationParent[st.id] = fieldById[m[0]];
  });
  // Deterministic pseudo-random spread inside a field so pins don't stack.
  // Same input → same output, so the visual is stable across renders.
  function spread(seed, lo, hi){
    let h = 2166136261;
    const s = String(seed);
    for(let i=0;i<s.length;i++){ h ^= s.charCodeAt(i); h = (h * 16777619) >>> 0; }
    return lo + ((h % 10000) / 10000) * (hi - lo);
  }

  const pins = [];
  items.forEach((p, idx) => {
    let parentField = null;
    if (p.workScope === "site") {
      // Site-wide failures don't belong to a specific field; we'll show them
      // anchored to a fixed corner (handled separately by the renderer).
      pins.push({
        id: "pin-" + idx,
        item: p,
        anchor: "site",  // signals the renderer to position in a fixed corner
        x: 0, y: 0,
        color: pinColorFor(p),
      });
      return;
    }
    if (p.workScope === "station") {
      parentField = stationParent[p.fid];
    } else {
      parentField = fieldById[p.fid];
    }
    if (!parentField) return;  // unknown field — skip rather than crash

    // Place the pin inside the field's bounding box. Margin in % keeps pins
    // away from the field border so they don't visually clip.
    const margin = 0.18;  // 18% inset from each edge
    const innerW = parentField.w * (1 - margin * 2);
    const innerH = parentField.h * (1 - margin * 2);
    // Seed: tie position to scope + index so the same item always lands in
    // the same spot. Use table number for table-scope, scopeKey for module/
    // pile, invIdx for stations.
    const seed = `${p.fid}::${p.t}::${p.scopeKey || ""}::${p.idx}`;
    const dx = spread(seed, 0, innerW);
    const dy = spread(seed + "y", 0, innerH);
    pins.push({
      id: "pin-" + idx,
      item: p,
      anchor: "field",
      x: parentField.x + parentField.w * margin + dx,
      y: parentField.y + parentField.h * margin + dy,
      color: pinColorFor(p),
    });
  });
  return pins;
}

/* Returns the pin color for a given punch item based on scope + severity. */
function pinColorFor(p){
  if (p.resolved) return C.grass;
  // Open: red if NCR raised, amber otherwise
  if (p.ncr) return C.rust;
  return C.amber;
}

function qcCounts(){
  const all=allResults();
  const pass=all.filter(r=>r.status==="pass").length;
  const fail=all.filter(r=>r.status==="fail").length;
  const done=pass+fail;
  const ncr=all.filter(r=>r.ncr).length;
  // total possible = inspected tables × items (or at least the items touched)
  const touchedTables=new Set(all.map(r=>r.fid+"::"+r.t)).size || 1;
  const total=Math.max(done, touchedTables*D.itp.length);
  return {total,pass,fail,done,ncr,rate:total?Math.round(done/total*100):0,tables:touchedTables};
}
/* Per-field stats for the overview breakdown.
 * Returns one row per field with live counts derived from `inspections`.
 * Used by vOverview() to render the "By field" card below the site-wide KPIs. */
function fieldStats(){
  const all = allResults();
  return D.fields.map(f=>{
    const inField = all.filter(r=>r.fid===f.id);
    const pass = inField.filter(r=>r.status==="pass").length;
    const fail = inField.filter(r=>r.status==="fail").length;
    const ncr  = inField.filter(r=>r.ncr).length;
    const done = pass + fail;
    // Tables touched at table-scope (exclude module/pile sub-keys)
    const tablesTouched = new Set(
      Object.keys(inspections)
        .filter(k=>k.startsWith(f.id+"::") && !k.includes("::M") && !k.includes("::P"))
        .filter(k=>recStarted(inspections[k]))
    ).size;
    // Tables accepted/rejected using EFFECTIVE status — combines manager signoff
    // with derived-from-QC status. Matches what the site map actually shows.
    let tablesAccepted = 0, tablesRejected = 0;
    for(let t=1; t<=f.tables; t++){
      const s = tableEffectiveStatus(f.id, t).status;
      if(s === "pass") tablesAccepted++;
      else if(s === "fail") tablesRejected++;
    }
    const total = Math.max(done, tablesTouched * D.itp.length);
    const rate = total ? Math.round(done/total*100) : 0;
    // Inspection-progress rate as % of total tables in the field
    const progress = f.tables ? Math.round(tablesTouched/f.tables*100) : 0;
    return {
      id: f.id, tables: f.tables, mwp: f.mwp,
      tablesTouched, tablesAccepted, tablesRejected,
      pass, fail, ncr, done, total, rate, progress
    };
  });
}
function siteCounts(){
  const tables=D.fields.reduce((a,f)=>a+f.tables,0);
  const mwp=D.fields.reduce((a,f)=>a+f.mwp,0);
  const piles=D.bom[0].items.reduce((a,i)=>a+i.qty,0)+D.bom[1].items.reduce((a,i)=>a+i.qty,0);
  const overall=Math.round(D.fields.reduce((a,f)=>a+f.done*f.tables,0)/tables);
  const ncr=D.fields.reduce((a,f)=>a+f.ncr,0);
  return {tables,mwp:mwp.toFixed(1),piles,overall,ncr,fields:D.fields.length};
}

/* ---------- chrome ---------- */
/* -- LOGIN SCREEN ---------------------------------------------------------- */
function loginScreen(){
  const roles=D.roles;
  return `<div class="login-overlay" id="login-overlay">
    <div class="login-box">
      <div class="login-logo">
        <div class="login-glyph"><img src="data:image/png;base64,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" alt="TerraTrace logo" style="width:100%;height:100%;object-fit:cover;display:block"/></div>
        <div><div class="login-brand serif">GridProof</div><div class="login-sub">powered by TerraTrace</div></div>
      </div>
      <div class="login-project">${D.project.name} · ${D.project.location}</div>
      <div class="login-operator">Operator · <b>Catalin Radu</b></div>
      <div class="login-label">Select your role to continue</div>
      <div class="login-roles">
        ${Object.entries(roles).map(([rid,r])=>`
          <button class="role-card ${currentRole===rid?'sel':''}" data-rolesel="${rid}" style="--rc:${r.color}">
            <div class="rc-label" style="color:${r.color}">${r.label}</div>
            <div class="rc-desc">${r.desc}</div>
            <div class="rc-access">
              ${r.canEdit?'<span class="rca">Edit</span>':''}
              ${r.canApprove?'<span class="rca">Approve</span>':''}
              ${r.tddAccess?'<span class="rca">TDD</span>':''}
              ${!r.canEdit&&!r.canApprove?'<span class="rca ro">Read-only</span>':''}
            </div>
          </button>`).join("")}
      </div>
      <button class="login-enter" id="login-enter">Enter platform →</button>
      <div class="login-note">All inspection data is stored locally in this browser. Use the gear menu (top right) to save or load data snapshots.</div>
    </div>
  </div>`;
}
function showLogin(){ document.getElementById("app").insertAdjacentHTML("afterbegin",loginScreen()); wireLogin(); }
function wireLogin(){
  document.querySelectorAll("[data-rolesel]").forEach(el=>el.onclick=()=>{
    currentRole=el.dataset.rolesel;
    document.querySelectorAll("[data-rolesel]").forEach(b=>b.classList.toggle("sel",b.dataset.rolesel===currentRole));
  });
  const btn=document.getElementById("login-enter");
  if(btn) btn.onclick=()=>{ isLoggedIn=true; saveToStorage(); document.getElementById("login-overlay").remove(); render(); };
}

/* Builds the top-nav tab buttons, including the live punch/RFI count badges.
   Factored out so refreshBadges() can re-render just the nav without a full
   page render — that's what keeps the badge counts live as data changes. */
function navTabsHTML(){
  const navItems=[["overview","Overview"],["rfi","RFI Register"],["sitemap","Site Map"],["qc","Quality Control"],["punch","Punch List"],["tdd","Documents"]];
  const visible = currentRole==="tdd"
    ? [["overview","Overview"],["tdd","Documents"]]
    : navItems;
  return visible.map(([v,l])=>{
    const pc = v==="punch"?punchCounts().open : v==="rfi"?rfiCounts().pending : 0;
    return `<button class="tab ${state.view===v?'active':''}" data-view="${v}"><span class="ti"></span>${l}${pc?`<span class="navbadge">${pc}</span>`:""}</button>`;
  }).join("");
}
/* Re-renders the topbar nav badges (and the mobile drawer nav if present) so the
   punch/RFI counters stay current after any data change, without a full render.
   Call this after any mutation that can change punchCounts().open or
   rfiCounts().pending. */
function refreshBadges(){
  const nav = document.getElementById("topnav");
  if(nav){
    nav.innerHTML = navTabsHTML();
    // Re-bind the freshly-created tab buttons
    nav.querySelectorAll(".tab").forEach(t=>t.onclick=()=>setView(t.dataset.view));
  }
  // Mobile drawer nav, if it exists in the DOM
  const dnav = document.getElementById("drawer-nav");
  if(dnav){
    dnav.querySelectorAll("[data-view]").forEach(btn=>{
      const v = btn.dataset.view;
      const pc = v==="punch"?punchCounts().open : v==="rfi"?rfiCounts().pending : 0;
      let badge = btn.querySelector(".navbadge");
      if(pc){
        if(!badge){
          badge = document.createElement("span");
          badge.className = "navbadge";
          badge.style.marginLeft = "auto";
          btn.appendChild(badge);
        }
        badge.textContent = pc;
      } else if(badge){
        badge.remove();
      }
    });
  }
}

function chrome(){
  const sc=siteCounts();
  return `
  <div class="topbar">
    <div class="mark">
      <div class="glyph"><img src="data:image/png;base64,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" alt="TerraTrace logo" style="width:100%;height:100%;object-fit:cover;display:block"/></div>
      <div class="nm"><b class="serif">GridProof</b><span>powered by TerraTrace</span></div>
    </div>
    <div class="vr"></div>
    <div class="nav" id="topnav">
      ${navTabsHTML()}
    </div>
    <div class="topright">
      <div class="meta-stack"><div>Survey GPS <b class="mono">±1.2 m</b></div><div>Last sync <b class="mono">08:42 IST</b></div></div>
      <button class="themebtn" id="themebtn" title="Toggle light / dark mode" aria-label="Toggle theme">
        <svg class="ic-sun" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">
          <circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>
        </svg>
        <svg class="ic-moon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/>
        </svg>
      </button>
      <button class="rolebtn" id="rolebtn" title="Switch role" style="--rcol:${D.roles[currentRole].color}">
        <span class="rolebtn-dot"></span>
        <span class="rolebtn-label"><b>${D.roles[currentRole].operator}</b><span class="rolebtn-role"> · ${D.roles[currentRole].label}</span></span>
      </button>
      <div class="gear-wrap" id="gear-wrap">
        <button class="iconbtn" id="gearbtn" title="Settings &amp; export" aria-label="Settings">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
        </button>
        <div class="gear-menu" id="gear-menu">
          <div class="gear-section">History</div>
          <button class="gear-item" id="undobtn" disabled>
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7v6h6"/><path d="M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6.7 3L3 13"/></svg>
            <span style="flex:1">Undo</span><span style="font-size:10px;color:var(--dim2);font-family:'IBM Plex Mono',monospace">⌘Z</span>
          </button>
          <button class="gear-item" id="redobtn" disabled>
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 7v6h-6"/><path d="M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6.7 3L21 13"/></svg>
            <span style="flex:1">Redo</span><span style="font-size:10px;color:var(--dim2);font-family:'IBM Plex Mono',monospace">⌘⇧Z</span>
          </button>
          <div class="gear-divider"></div>
          <div class="gear-section">Data &amp; backup</div>
          <button class="gear-item" id="snapExport">
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            Save snapshot
          </button>
          <label class="gear-item">
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            Load snapshot<input type="file" id="snapImport" accept=".json" style="display:none"/>
          </label>
          <button class="gear-item" id="resetDemoBtn">
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 10 9 10"/></svg>
            Reset to demo defaults
          </button>
          <div class="gear-divider"></div>
          <div class="gear-section">Project topology</div>
          <button class="gear-item" id="cadIngestBtn">
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h18v18H3z"/><path d="M9 3v18M15 3v18M3 9h18M3 15h18"/></svg>
            Import from CAD/DWG…
          </button>
          <button class="gear-item" id="itpManageBtn">
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
            Manage inspection items…
          </button>
          <div class="gear-divider"></div>
          <div class="gear-section">Appearance</div>
          <button class="gear-item" id="gearTheme">
            <span class="ic-sun-sm">
              <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>
            </span>
            <span class="ic-moon-sm">
              <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>
            </span>
            Toggle dark/light
          </button>
        </div>
      </div>
      <div class="gps" id="netstatus" title="Connection status"><span class="gdot"></span><span class="glabel">Online</span></div>
      <button class="hamburger" id="hamburger" aria-label="Menu" title="Open menu">
        <span></span><span></span><span></span>
      </button>
    </div>
  </div>
  <div class="drawer-overlay" id="drawer-overlay"></div>
  <nav class="drawer" id="drawer">
    <div class="drawer-head">
      <div class="drawer-brand">
        <div class="drawer-logo"><img src="data:image/png;base64,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" alt="logo" style="width:100%;height:100%;object-fit:cover"/></div>
        <div><div style="font-weight:700;font-size:15px">GridProof</div><div style="font-size:10px;color:var(--dim)">powered by TerraTrace</div></div>
      </div>
      <button class="drawer-close" id="drawer-close" aria-label="Close">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
    <div class="drawer-role" id="drawer-role"></div>
    <div class="drawer-nav" id="drawer-nav"></div>
    <div class="drawer-foot">
      <button class="drawer-action" id="drawerTheme">
        <svg class="ic-sun" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>
        <svg class="ic-moon" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>
        Toggle dark / light
      </button>
      <button class="drawer-action" id="drawerSave">
        <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
        Save snapshot
      </button>
      <label class="drawer-action">
        <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
        Load snapshot<input type="file" id="drawerLoad" accept=".json" style="display:none"/>
      </label>
    </div>
  </nav>
  <div class="strip">
    ${[
      ["Project", D.project.name],["Location", D.project.location],
      ["Coordinates", `<span class="mono">${D.project.gps}</span>`],
      ["Client", D.project.client],["EPC", D.project.epc],
      ["ITP", `<span class="mono">ITP-BAL · Rev B</span>`],
      ["Drawing set", `<span class="mono">${D.project.drawingRev}</span>`]
    ].map(([k,v])=>`<div class="sc"><b>${k}</b><span>${v}</span></div>`).join("")}
  </div>
  <div class="viewport">
    <div class="view ${state.view==='overview'?'active':''}" id="v-overview"></div>
    <div class="view ${state.view==='rfi'?'active':''}" id="v-rfi"></div>
    <div class="view ${state.view==='sitemap'?'active':''}" id="v-sitemap"></div>
    <div class="view ${state.view==='qc'?'active':''}" id="v-qc"></div>
    <div class="view ${state.view==='punch'?'active':''}" id="v-punch"></div>
    <div class="view ${state.view==='tdd'?'active':''}" id="v-tdd"></div>
  </div>
  <div class="lightbox" id="lightbox" style="display:none">
    <button class="lb-close" id="lbclose" aria-label="Close photo viewer">✕</button>
    <button class="lb-nav lb-prev" id="lbprev" aria-label="Previous photo">‹</button>
    <button class="lb-nav lb-next" id="lbnext" aria-label="Next photo">›</button>
    <img id="lbimg" src="" alt="evidence"/>
    <div class="lb-cap" id="lbcap"></div>
    <div class="lb-counter" id="lbcounter"></div>
  </div>
  <div class="modal" id="cadModal" style="display:none">
    <div class="modal-card">
      <button class="modal-close" id="cadModalClose" aria-label="Close">✕</button>
      <div class="modal-head">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h18v18H3z"/><path d="M9 3v18M15 3v18M3 9h18M3 15h18"/></svg>
        <h2>Import project topology from CAD/DWG</h2>
      </div>
      <div class="modal-body">
        <p>Upload your engineering drawings and the platform will extract the project structure automatically — fields, rows, tables, piles, stations, inverters, roads, fence line, drainage. Inspection plans are then attached to the extracted topology and the platform is ready to inspect.</p>
        <div class="cad-status">
          <span class="cad-status-dot"></span>
          <span><b>Backend not yet connected.</b> This is a preview of where DWG ingest will live. Until backend is wired, the project topology is the demo Ballyroe dataset.</span>
        </div>
        <div class="cad-grid">
          <div class="cad-block">
            <div class="cad-block-title">What gets extracted automatically</div>
            <ul class="cad-list ok">
              <li><b>Fields &amp; rows</b> — from PV layout (panel arrangement drawings)</li>
              <li><b>Tables per row &amp; type</b> — 3×27 / 3×18 / 3×9 from block references</li>
              <li><b>Pile count per table</b> — from pile/foundation layer</li>
              <li><b>Transformer stations &amp; pad heights</b> — from civil overall plan (e.g. T1-T8)</li>
              <li><b>Inverter count per station</b> — from electrical SLD or station drawing</li>
              <li><b>Internal roads &amp; passing bays</b> — from civil road &amp; panel layout</li>
              <li><b>Fence line &amp; gates</b> — from civil overall plan</li>
              <li><b>Crossings, culverts, drainage</b> — from civil drainage sheets</li>
            </ul>
          </div>
          <div class="cad-block">
            <div class="cad-block-title">What stays manual</div>
            <ul class="cad-list dim">
              <li>ITP items and acceptance criteria — from the QC plan, not the drawing</li>
              <li>Inspector assignments and schedules</li>
              <li>Photo evidence, comments, NCRs — created in the field</li>
              <li>Module-to-string and string-to-inverter assignments — from the stringing layout</li>
              <li>Torque values, tolerances — from manufacturer manuals</li>
            </ul>
          </div>
        </div>
        <div class="cad-drop" id="cadDrop">
          <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
          <div class="cad-drop-t">Drop DWG / DXF / IFC files here</div>
          <div class="cad-drop-s">or click to browse · accepted: .dwg, .dxf, .ifc, .pdf (vector)</div>
          <input type="file" id="cadFile" accept=".dwg,.dxf,.ifc,.pdf" multiple style="display:none"/>
        </div>
        <div class="cad-result" id="cadResult" style="display:none"></div>
        <details class="cad-spec">
          <summary>Backend integration contract</summary>
          <div class="cad-spec-body">
            <p>The backend implements two endpoints. The frontend calls them through <code>Store.ingestTopology</code>:</p>
            <pre>POST /projects/{projectId}/topology/dwg-ingest
  Body: multipart/form-data with one or more CAD files
  Returns: {
    extracted: TopologyPayload,
    warnings: [{ layer, message, severity }],
    confidence: 0..1
  }

POST /projects/{projectId}/topology/commit
  Body: TopologyPayload  (after manual review &amp; corrections)
  Returns: { projectId, version, ts }

TopologyPayload shape (matches the in-memory D.* shape):
  {
    project: { name, client, epc, location, gps },
    fields: [{ id, tables, area_m2, ... }],
    tableTypes: { "3x27": { rows, cols, pilesPerRow, ... }, ... },
    stations: [{ id, label, area, invCount, padHeight, ref, gps }],
    roads:    [{ id, type, length_m, polyline }],
    fence:    [{ id, length_m, polyline, gates: [...] }],
    drainage: [{ id, kind, polyline }],
  }</pre>
            <p>The ITPs (<code>tableItp</code>, <code>stationItp</code>, <code>siteItp</code>) are <i>not</i> part of the payload — they're configured separately and apply automatically to the extracted topology.</p>
          </div>
        </details>
      </div>
    </div>
  </div>
  <div class="modal" id="itpModal" style="display:none">
    <div class="modal-card itp-modal-card">
      <button class="modal-close" id="itpModalClose" aria-label="Close">✕</button>
      <div class="modal-head">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
        <h2>Manage inspection items</h2>
      </div>
      <div class="modal-body itp-body">
        <p>
          Add, edit or remove inspection items for each work scope. Changes take effect immediately
          across the QC view, PDF reports and punch list. Click the <b>Reset to demo defaults</b>
          option in the gear menu to restore the original inspection plan.
        </p>
        <div class="itp-scope-tabs" id="itpScopeTabs">
          <button class="itp-tab" data-itpscope="table">Tables</button>
          <button class="itp-tab" data-itpscope="station">Stations</button>
          <button class="itp-tab" data-itpscope="site">Site-wide</button>
        </div>
        <div class="itp-list-wrap" id="itpListWrap"></div>
        <details class="itp-add" id="itpAdd">
          <summary>+ Add new inspection item</summary>
          <div class="itp-add-body">
            <div class="itp-add-grid">
              <div class="itp-add-row" id="itpAddScopeRow">
                <label class="itp-add-l">Scope</label>
                <select id="itpAddScope" class="itp-input">
                  <option value="mechanical">⚙ Mechanical</option>
                  <option value="electrical">⚡ Electrical</option>
                </select>
              </div>
              <div class="itp-add-row">
                <label class="itp-add-l">Category</label>
                <input id="itpAddCat" type="text" class="itp-input" placeholder="e.g. Table Mechanical Assembly" maxlength="80"/>
              </div>
              <div class="itp-add-row">
                <label class="itp-add-l">Code</label>
                <input id="itpAddCode" type="text" class="itp-input" placeholder="e.g. MECH" maxlength="6"/>
              </div>
            </div>
            <div class="itp-add-row">
              <label class="itp-add-l">Item name</label>
              <input id="itpAddItem" type="text" class="itp-input" placeholder="e.g. Connector torque check" maxlength="120"/>
            </div>
            <div class="itp-add-row">
              <label class="itp-add-l">Acceptance criteria</label>
              <textarea id="itpAddCrit" class="itp-input itp-crit" rows="4" placeholder="What must be verified for this check to pass? Reference drawings, torque values, tolerances…" maxlength="1500"></textarea>
            </div>
            <div class="itp-actions">
              <button class="obtn ok" id="itpAddSubmit">Add item</button>
            </div>
          </div>
        </details>
      </div>
    </div>
  </div>`;
}

/* ---------- INSPECTIONS OVERVIEW ---------- */
function vOverview(){
  const qc=qcCounts();
  const all=allResults();
  const cats=[...new Set(D.itp.map(it=>it.cat))];
  const ftp = qc.done?Math.round(qc.pass/qc.done*100):0;
  const open=Math.max(0,qc.total-qc.done);
  const rc = rfiCounts();
  const pendingInspections = rc.pending + rc.scheduled;
  // Per-field rollup for the "By field" card
  const fs = fieldStats();
  const siteOverall = {
    totalTables: fs.reduce((a,f)=>a+f.tables,0),
    totalAccepted: fs.reduce((a,f)=>a+f.tablesAccepted,0),
    totalRejected: fs.reduce((a,f)=>a+f.tablesRejected,0),
  };
  const kpis=[
    ["QC acceptance", qc.rate+"%", `${qc.done} of ${qc.total} checks closed`, C.grass],
    ["First-time pass", ftp+"%", `${qc.pass} passed without rework`, C.steel],
    ["Failed checks", qc.fail, "raised as non-conformance", C.rust],
    ["Pending inspections", pendingInspections, `${rc.pending} new · ${rc.scheduled} scheduled`, C.amber],
    ["Open NCRs", qc.ncr, "awaiting close-out", C.hiviz],
    ["Tables inspected", qc.tables, `across ${cats.length} categories`, C.grass],
  ];
  // per-category pass/fail across all recorded results
  const catData=cats.map(cat=>{
    const code=D.itp.find(it=>it.cat===cat).code;
    const rs=all.filter(r=>r.cat===cat);
    return {cat, code,
      pass:rs.filter(r=>r.status==="pass").length,
      fail:rs.filter(r=>r.status==="fail").length,
      total:rs.length};
  });
  const maxTot=Math.max(1,...catData.map(d=>d.total));
  const catBars=catData.map(d=>{
    const w=v=>maxTot?(v/maxTot*100):0;
    return `<div class="fbar-row" style="grid-template-columns:160px 1fr 56px">
      <div class="fl" title="${d.cat}" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${d.cat}</div>
      <div class="fbar-track">
        <div class="fbar-seg" style="width:${w(d.pass)}%;background:${C.grass}"></div>
        <div class="fbar-seg" style="width:${w(d.fail)}%;background:${C.rust}"></div>
      </div>
      <div class="fbar-val"><span class="mono">${d.pass}/${d.total}</span></div>
    </div>`;
  }).join("");
  // donut
  const segs=[["Pass",qc.pass,C.grass],["Fail",qc.fail,C.rust],["Open",open,C.dim2]];
  let acc=0; const circ=2*Math.PI*44;
  const donut=segs.map(([l,v,col])=>{const frac=qc.total?v/qc.total:0,dash=frac*circ;
    const s=`<circle r="44" cx="62" cy="62" fill="none" stroke="${col}" stroke-width="15" stroke-dasharray="${dash} ${circ-dash}" stroke-dashoffset="${-acc}" transform="rotate(-90 62 62)" stroke-linecap="butt"/>`;
    acc+=dash; return s;}).join("");
  // NCR register from all results
  const ncrs=all.filter(r=>r.ncr);
  const ncrRows = ncrs.length?ncrs.map(r=>`<tr>
      <td class="mono" style="color:${C.rust}">${r.ncr}</td>
      <td class="mono">${r.fid} · T${r.t}</td>
      <td class="mono">${r.itp}</td>
      <td>${r.item}</td>
      <td style="color:${C.dim}">${r.cat}</td>
      <td>${r.by||"—"}</td>
      <td><span class="pill" style="background:${C.hiviz}22;color:${C.hiviz}">OPEN</span></td>
    </tr>`).join("")
    :`<tr><td colspan="7" style="color:${C.dim};text-align:center;padding:18px">No open non-conformances.</td></tr>`;

  return `<div class="ovwrap">
    <div class="vhead"><h1 class="serif">Inspections overview</h1>
      <div class="vs">${D.project.name} · ${D.project.location}</div>
      <div class="vtag">ITP-BAL · Rev B</div></div>
    <div class="kpis">${kpis.map(([k,v,t,col])=>
      `<div class="kpi" style="--accent:${col}"><div class="kk">${k}</div><div class="kv" style="color:${col}">${v}</div><div class="kt">${t}</div></div>`).join("")}</div>
    <div class="ovgrid">
      <div class="card">
        <h3>Result by category</h3>
        <div class="csub">Pass / fail across all recorded inspection checks</div>
        ${catBars}
        <div class="typelegend" style="margin-top:14px">
          <span><i style="background:${C.grass};border-radius:2px"></i>Pass</span>
          <span><i style="background:${C.rust};border-radius:2px"></i>Fail</span>
        </div>
      </div>
      <div class="card">
        <h3>Overall acceptance</h3><div class="csub">Status distribution across all inspection items</div>
        <div class="donut-wrap">
          <svg width="124" height="124" viewBox="0 0 124 124">${donut}
            <text x="62" y="60" text-anchor="middle" fill="${C.ink}" font-size="26" font-weight="600" font-family="IBM Plex Sans">${qc.rate}%</text>
            <text x="62" y="77" text-anchor="middle" fill="${C.dim2}" font-size="8.5" letter-spacing="1.5" font-family="IBM Plex Sans">CLOSED</text>
          </svg>
          <div class="dleg">
            <div><i style="background:${C.grass}"></i>Pass <b>${qc.pass}</b></div>
            <div><i style="background:${C.rust}"></i>Fail / NCR <b>${qc.fail}</b></div>
            <div><i style="background:${C.dim2}"></i>Open <b>${open}</b></div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" style="margin-top:14px">
      <div class="punchcard-h">
        <div>
          <h3>By field</h3>
          <div class="csub">Per-field breakdown across all 13 fields. Click any field to jump to its site map.</div>
        </div>
        <div class="csub" style="font-family:'IBM Plex Mono',monospace;font-size:10px">
          <span style="color:${C.grass}">●</span> ${siteOverall.totalAccepted} tables accepted ·
          <span style="color:${C.rust}">●</span> ${siteOverall.totalRejected} rejected ·
          <span style="color:${C.dim}">●</span> ${siteOverall.totalTables} planned
        </div>
      </div>
      <div class="fieldgrid">
        ${fs.map(f=>{
          const greenPct = f.tables ? (f.tablesAccepted/f.tables*100) : 0;
          const redPct   = f.tables ? (f.tablesRejected/f.tables*100) : 0;
          const isDormant = (f.tablesTouched===0 && f.tablesAccepted===0 && f.tablesRejected===0);
          return `<div class="fieldcard" data-fieldjump="${esc(f.id)}" title="Open ${esc(f.id)} on the site map">
            <div class="fc-head">
              <div class="fc-name">${esc(f.id)}</div>
              <div class="fc-meta">${f.tables} tables · ${f.mwp} MWp</div>
            </div>
            <div class="fc-bar" title="${f.tablesAccepted} accepted, ${f.tablesRejected} rejected of ${f.tables} planned">
              <div class="fc-bar-seg" style="width:${greenPct}%;background:${C.grass}"></div>
              <div class="fc-bar-seg" style="width:${redPct}%;background:${C.rust}"></div>
            </div>
            <div class="fc-stats">
              <div class="fc-stat"><span class="fc-sv" style="color:${C.grass}">${f.pass}</span><span class="fc-sl">pass</span></div>
              <div class="fc-stat"><span class="fc-sv" style="color:${f.fail?C.rust:C.dim2}">${f.fail}</span><span class="fc-sl">fail</span></div>
              <div class="fc-stat"><span class="fc-sv" style="color:${f.ncr?C.hiviz:C.dim2}">${f.ncr}</span><span class="fc-sl">NCR</span></div>
              <div class="fc-stat"><span class="fc-sv" style="color:${isDormant?C.dim2:C.ink}">${f.tablesTouched}/${f.tables}</span><span class="fc-sl">tables</span></div>
            </div>
            ${isDormant?`<div class="fc-dormant">Not started</div>`:""}
          </div>`;
        }).join("")}
      </div>
    </div>
    <div class="card" style="margin-top:14px">
      <h3>Non-conformance register (NCR)</h3>
      <div class="csub">Open items linked to failed inspections</div>
      <table class="bom"><thead><tr><th>NCR</th><th>Location</th><th>ITP Ref</th><th>Inspection Item</th><th>Category</th><th>Raised by</th><th>Status</th></tr></thead>
        <tbody>${ncrRows}</tbody></table>
    </div>
    ${(()=>{const pc=punchCounts(); const bc=punchByCat(); const cats=Object.keys(bc);
      return `<div class="card punchcard" style="margin-top:14px">
        <div class="punchcard-h">
          <div><h3>Punch list</h3><div class="csub">All rejected items requiring close-out, grouped by category</div></div>
          <button class="export-btn go" id="goPunch">Open punch list →</button>
        </div>
        <div class="punchcard-stats">
          <div class="pcs"><b style="color:${C.rust}">${pc.open}</b><span>Open</span></div>
          <div class="pcs"><b style="color:${C.grass}">${pc.resolved}</b><span>Resolved</span></div>
          <div class="pcs"><b>${pc.total}</b><span>Total</span></div>
        </div>
        ${cats.length?`<div class="punchcard-cats">${cats.map(c=>{const o=bc[c].filter(p=>!p.resolved).length;
          return `<span class="pcc"><i style="background:${o?C.rust:C.grass}"></i>${c} <b>${o}</b></span>`;}).join("")}</div>`
          :`<div class="csub" style="margin-top:10px">No rejected items yet — nothing to close out.</div>`}
      </div>`;})()}
  </div>`;
}

/* ---------- PUNCH LIST ---------- */
function scopeBadge(scope){
  const c = scope==="Pile"?C.steel : scope==="Module"?C.hiviz : C.dim2;
  return `<span class="scopechip" style="background:${c}22;color:${c};border:1px solid ${c}66">${scope}</span>`;
}
function vPunch(){
  const byCat=punchByCat(); const cats=Object.keys(byCat);
  const pc=punchCounts();
  const cards = cats.length ? cats.map(cat=>{
    const items=byCat[cat];
    const open=items.filter(p=>!p.resolved).length;
    const code=items[0].code;
    const rows=items.map(p=>`
      <div class="punchrow ${p.resolved?'done':''}">
        <button class="punchchk ${p.resolved?'on':''}" data-punchtoggle="${p.key}|${p.idx}" title="${p.resolved?'Reopen':'Mark resolved'}">${p.resolved?"✓":""}</button>
        <div class="punchmain" data-punchjump="${p.key}|${p.idx}">
          <div class="punchtop">
            <span class="punchitem">${p.item}</span>
            ${scopeBadge(p.scope)}
            ${p.ncr?`<span class="punchncr">${p.ncr}</span>`:""}
          </div>
          <div class="punchmeta">
            <span class="mono">${p.itp}</span> · <span class="mono">${p.loc}</span>${p.by?` · ${p.by}`:""}
          </div>
          ${p.comment?`<div class="punchnote">“${esc(p.comment)}”</div>`:""}
        </div>
        <span class="punchstate" style="color:${p.resolved?C.grass:C.rust}">${p.resolved?"RESOLVED":"OPEN"}</span>
      </div>`).join("");
    return `<div class="punchcat">
      <div class="punchcathead">
        <span class="pch-name">${cat}</span>
        <span class="pch-code mono">${code}</span>
        <span class="pch-count">${open} open${items.length-open?` · ${items.length-open} resolved`:""}</span>
      </div>
      ${rows}
    </div>`;
  }).join("") : `<div class="punch-empty">
      <div class="pe-ico">✓</div>
      <div class="pe-t">No rejected items</div>
      <div class="pe-s">Nothing has been failed yet. Items you reject in Quality Control — at table, module or pile level — will collect here, grouped by category.</div>
    </div>`;

  return `<div class="punchwrap">
    <div class="vhead">
      <h1 class="serif">Punch list</h1>
      <div class="vs">${D.project.name} · ${D.project.location} · all rejected items requiring close-out</div>
      <div class="vtag">ITP-BAL · Rev B</div>
    </div>
    <div class="punchbar">
      <div class="punchstats">
        <div class="ps"><b style="color:${C.rust}">${pc.open}</b><span>Open</span></div>
        <div class="ps"><b style="color:${C.grass}">${pc.resolved}</b><span>Resolved</span></div>
        <div class="ps"><b>${pc.total}</b><span>Total</span></div>
        <div class="ps"><b>${cats.length}</b><span>Categories</span></div>
      </div>
      <div class="punchexport">
        <button class="export-btn pdf" id="punchPdf">⬇ Export PDF</button>
        <button class="export-btn xls" id="punchXls">⬇ Export Excel</button>
      </div>
    </div>
    <div class="punchlist">${cards}</div>
  </div>`;
}


/* ---------- INSPECTIONS (RFI REGISTER) -------------------------------- */
function vRFI(){
  const counts = rfiCounts();
  const filt = state.rfiFilter || "open";
  const all = rfiList();
  const filtered = all.filter(r=>{
    if(filt==="all") return true;
    if(filt==="open") return r.status!=="closed";
    return r.status===filt;
  });
  const sel = state.rfiSelected ? rfis[state.rfiSelected] : null;

  // Filter pills
  const pills = [
    ["open","Open",counts.open],
    ["pending","Pending",counts.pending],
    ["scheduled","Scheduled",counts.scheduled],
    ["in_progress","In progress",counts.in_progress],
    ["closed","Closed",counts.closed],
    ["all","All",counts.all],
  ].map(([k,l,c])=>`<button class="cl-pill ${filt===k?'sel':''}" data-rfifilter="${k}">${l} <b>${c}</b></button>`).join("");

  // Cards
  let cards;
  if(!filtered.length){
    cards = `<div class="empty-state">
      <div class="es-ico">📋</div>
      <div class="es-t">No ${filt==="all"?"RFIs raised yet":filt==="open"?"open RFIs":esc(filt)+" RFIs"}</div>
      <div class="es-s">${filt==="open"?"All work has been signed off, or no contractor has requested inspection yet.":"Switch the filter to see other RFIs, or raise a new one."}</div>
    </div>`;
  } else {
    cards = filtered.map(r=>{
      const st = RFI_STATUS[r.status];
      const oc = r.outcome ? RFI_OUTCOME[r.outcome] : null;
      const target = rfiTargetLabel(r);
      const requested = fmtDate(r.requestedAt);
      const due = r.requestedFor ? fmtDate(r.requestedFor) : "—";
      const selCls = (sel && sel.id===r.id) ? "sel" : "";
      const scopeBadge = r.scope==="table"?"📋 Table":r.scope==="station"?"🔌 Station":"🌐 Site-wide";
      return `<div class="rfi-card ${selCls}" data-rfi-sel="${r.id}">
        <div class="rfi-card-head">
          <span class="rfi-id mono">${r.id}</span>
          <span class="rfi-status" style="--rc:${st.color}">${st.glyph} ${st.label}</span>
          ${oc?`<span class="rfi-outcome" style="--rc:${oc.color}">${oc.label}</span>`:""}
        </div>
        <div class="rfi-card-title">${esc(r.title)}</div>
        <div class="rfi-card-meta">
          <span class="rfi-scope">${scopeBadge}</span>
          <span class="rfi-target">${target}</span>
        </div>
        <div class="rfi-card-foot">
          <span>By <b>${esc(r.requestedBy)}</b> · ${esc(requested)}</span>
          <span>${r.status==="closed"?`Closed ${fmtDate(r.closedAt)}`:`Wanted ${esc(due)}`}</span>
        </div>
      </div>`;
    }).join("");
  }

  // Detail panel
  let detail;
  if(state.rfiNew){
    // Build target picker based on scope
    const sc = state.rfiNewScope || "table";
    const fields = D.fields.map(f=>`<option value="${f.id}" ${f.id===state.qcField?'selected':''}>${esc(f.id)}</option>`).join("");
    const stations = D.stations.map(s=>`<option value="${s.id}">${esc(s.label)}</option>`).join("");
    let targetPicker = "";
    if(sc==="table"){
      targetPicker = `<div class="rfi-row">
        <label class="field-l">Field</label>
        <select id="rfi-field" class="rfi-input">${fields}</select>
      </div>
      <div class="rfi-row">
        <label class="field-l">Row</label>
        <input id="rfi-row" type="number" min="1" max="20" value="1" class="rfi-input"/>
      </div>
      <div class="rfi-row">
        <label class="field-l">Table</label>
        <input id="rfi-table" type="number" min="1" max="65" value="1" class="rfi-input"/>
      </div>`;
    } else if(sc==="station"){
      targetPicker = `<div class="rfi-row">
        <label class="field-l">Station</label>
        <select id="rfi-station" class="rfi-input">${stations}</select>
      </div>
      <div class="rfi-row">
        <label class="field-l">Inverters</label>
        <input id="rfi-invs" type="text" placeholder="e.g. 1-4 or 1,3,5" class="rfi-input"/>
      </div>`;
    } else {
      targetPicker = `<div class="rfi-row"><div class="rfi-hint">Site-wide RFIs cover all civil &amp; infrastructure work — no target needed.</div></div>`;
    }
    const inspectors = ["Catalin Radu","Catalin Radu","Catalin Radu","Catalin Radu","Catalin Radu"];
    detail = `<div class="rfi-detail">
      <div class="rfi-dhead">
        <h2>New Request for Inspection</h2>
        <button class="obtn" id="rfi-cancel-new">Cancel</button>
      </div>
      <div class="rfi-dbody">
        <div class="rfi-row">
          <label class="field-l">Scope</label>
          <div class="rfi-scope-pick">
            ${["table","station","site"].map(s=>`<button class="rfi-scope-btn ${sc===s?'sel':''}" data-rfi-newscope="${s}">${s==="table"?"📋 Table":s==="station"?"🔌 Station":"🌐 Site-wide"}</button>`).join("")}
          </div>
        </div>
        ${targetPicker}
        <div class="rfi-row">
          <label class="field-l">Title</label>
          <input id="rfi-title" type="text" class="rfi-input" placeholder="What work is ready for inspection?" maxlength="120"/>
        </div>
        <div class="rfi-row">
          <label class="field-l">Notes for inspector</label>
          <textarea id="rfi-notes" class="rfi-input" rows="3" placeholder="Any context, attachments, special access requirements…" maxlength="500"></textarea>
        </div>
        <div class="rfi-row">
          <label class="field-l">Requested by</label>
          <input id="rfi-by" type="text" class="rfi-input" value="Conecon GmbH"/>
        </div>
        <div class="rfi-row">
          <label class="field-l">Wanted by</label>
          <input id="rfi-for" type="datetime-local" class="rfi-input"/>
        </div>
        <div class="rfi-actions-row">
          <button class="obtn ok" id="rfi-submit">Raise RFI</button>
        </div>
      </div>
    </div>`;
  } else if(sel){
    const st = RFI_STATUS[sel.status];
    const oc = sel.outcome ? RFI_OUTCOME[sel.outcome] : null;
    const suggested = rfiSuggestedOutcome(sel);
    const inspectors = ["Catalin Radu","Catalin Radu","Catalin Radu","Catalin Radu","Catalin Radu"];

    // Action buttons depend on status
    let actions = "";
    if(sel.status==="pending"){
      actions = `<div class="rfi-section-title">Schedule this inspection</div>
        <div class="rfi-row">
          <label class="field-l">Assign to</label>
          <select id="rfi-assign" class="rfi-input">${inspectors.map(n=>`<option ${n===(sel.assignedTo||"Catalin Radu")?"selected":""}>${esc(n)}</option>`).join("")}</select>
        </div>
        <div class="rfi-row">
          <label class="field-l">Scheduled for</label>
          <input id="rfi-sched-for" type="datetime-local" class="rfi-input" value="${sel.requestedFor?sel.requestedFor.slice(0,16):""}"/>
        </div>
        <div class="rfi-actions-row">
          <button class="obtn ok" data-rfi-schedule="${sel.id}">Schedule</button>
          <button class="obtn nu" data-rfi-delete="${sel.id}">Cancel RFI</button>
        </div>`;
    } else if(sel.status==="scheduled"){
      actions = `<div class="rfi-section-title">Inspection scheduled</div>
        <div class="rfi-kv"><span class="k">Assigned to</span><span class="v">${esc(sel.assignedTo||"—")}</span></div>
        <div class="rfi-kv"><span class="k">Scheduled</span><span class="v">${fmtDate(sel.scheduledFor)} · ${fmtTime(sel.scheduledFor)}</span></div>
        <div class="rfi-actions-row">
          <button class="obtn ok" data-rfi-start="${sel.id}">Start inspection →</button>
          <button class="obtn nu" data-rfi-reopen="${sel.id}">Move back to pending</button>
        </div>`;
    } else if(sel.status==="in_progress"){
      actions = `<div class="rfi-section-title">Inspection in progress</div>
        <div class="rfi-kv"><span class="k">Inspector</span><span class="v">${esc(sel.assignedTo||"—")}</span></div>
        ${suggested?`<div class="rfi-hint">Based on current results, the suggested outcome is <b style="color:${RFI_OUTCOME[suggested].color}">${RFI_OUTCOME[suggested].label}</b>.</div>`:`<div class="rfi-hint">No results yet — open the inspection to fill the checklist.</div>`}
        <div class="rfi-actions-row">
          <button class="obtn" data-rfi-start="${sel.id}">Continue inspection →</button>
        </div>
        <div class="rfi-section-title">Close the inspection</div>
        <div class="rfi-actions-row" style="flex-wrap:wrap">
          <button class="obtn ok" data-rfi-close="${sel.id}:accepted">✓ Accept</button>
          <button class="obtn" style="background:#B8862B;color:#fff" data-rfi-close="${sel.id}:accepted_with_punch">⚠ Accept with punch</button>
          <button class="obtn no" data-rfi-close="${sel.id}:rejected">✕ Reject</button>
        </div>`;
    } else if(sel.status==="closed"){
      actions = `<div class="rfi-section-title">Closed</div>
        <div class="rfi-kv"><span class="k">Outcome</span><span class="v" style="color:${oc?oc.color:'inherit'}">${oc?oc.label:"—"}</span></div>
        <div class="rfi-kv"><span class="k">Closed</span><span class="v">${fmtDate(sel.closedAt)} · ${fmtTime(sel.closedAt)}</span></div>
        <div class="rfi-kv"><span class="k">Inspector</span><span class="v">${esc(sel.assignedTo||"—")}</span></div>
        <div class="rfi-actions-row">
          <button class="obtn" data-rfi-start="${sel.id}">Open inspection record →</button>
          <button class="obtn nu" data-rfi-reopen="${sel.id}">Re-open</button>
        </div>`;
    }

    detail = `<div class="rfi-detail">
      <div class="rfi-dhead">
        <div>
          <div class="rfi-detail-id mono">${sel.id}</div>
          <h2>${esc(sel.title)}</h2>
        </div>
        <span class="rfi-status big" style="--rc:${st.color}">${st.glyph} ${st.label}</span>
      </div>
      <div class="rfi-dbody">
        <div class="rfi-kv"><span class="k">Scope</span><span class="v">${sel.scope==="table"?"📋 Table":sel.scope==="station"?"🔌 Station":"🌐 Site-wide"}</span></div>
        <div class="rfi-kv"><span class="k">Target</span><span class="v">${rfiTargetLabel(sel)}</span></div>
        <div class="rfi-kv"><span class="k">Requested by</span><span class="v">${esc(sel.requestedBy)}</span></div>
        <div class="rfi-kv"><span class="k">Raised</span><span class="v">${fmtDate(sel.requestedAt)} · ${fmtTime(sel.requestedAt)}</span></div>
        ${sel.requestedFor?`<div class="rfi-kv"><span class="k">Wanted by</span><span class="v">${fmtDate(sel.requestedFor)} · ${fmtTime(sel.requestedFor)}</span></div>`:""}
        ${sel.notes?`<div class="rfi-notes"><div class="field-l">Notes</div><div>${esc(sel.notes)}</div></div>`:""}
        ${actions}
      </div>
    </div>`;
  } else {
    detail = `<div class="rfi-empty">
      <div class="es-ico" style="font-size:32px">📋</div>
      <div class="es-t">Select an RFI</div>
      <div class="es-s">Pick a request from the list to see details and take action, or raise a new one.</div>
    </div>`;
  }

  return `<div class="rfi-wrap">
    <div class="rfi-bar">
      <div class="rfi-title-row">
        <h2>Requests for Inspection</h2>
        <button class="obtn ok" id="rfi-new-btn">+ Raise RFI</button>
      </div>
      <div class="cl-filter rfi-filter">${pills}</div>
    </div>
    <div class="rfi-grid">
      <div class="rfi-list">${cards}</div>
      <div class="rfi-detail-wrap">${detail}</div>
    </div>
  </div>`;
}


/* ---------- TDD VAULT -------------------------------------------------- */
function vTDD(){
  const role=D.roles[currentRole];
  const cats=D.tddCategories;
  const filtCat=state.tddCat;
  const search=(state.tddSearch||"").toLowerCase();
  const docs=tddDocs.filter(d=>(filtCat==="all"||d.cat===filtCat)&&(!search||d.name.toLowerCase().includes(search)||d.ref.toLowerCase().includes(search)||d.notes.toLowerCase().includes(search)));

  const catTabs=[{id:"all",label:"All",icon:"[FL]",color:C.dim},...cats].map(c=>`
    <button class="tdd-cat-tab ${filtCat===c.id?'sel':''}" data-tddcat="${c.id}" style="--tc:${c.color||C.hiviz}">
      ${c.icon||"[FL]"} ${c.label}${filtCat===c.id&&c.id!=="all"?` <span class="tcc">${tddDocs.filter(d=>d.cat===c.id).length}</span>`:""}
    </button>`).join("");

  const statusColor={approved:C.grass,pending:C.amber,rejected:C.rust,review:C.steel};
  const rows=docs.length?docs.map(d=>{
    const cat=cats.find(c=>c.id===d.cat)||{icon:"[F]",color:C.dim,label:d.cat};
    return `<div class="tdd-row" data-tddid="${d.id}">
      <div class="tdd-icon" style="background:${cat.color}22;color:${cat.color}">${cat.icon}</div>
      <div class="tdd-main">
        <div class="tdd-name">${esc(d.name)}</div>
        <div class="tdd-meta mono">${esc(d.ref)} · Rev ${esc(d.rev)} · ${esc(d.date)}</div>
        <div class="tdd-notes">${esc(d.notes)}</div>
      </div>
      <div class="tdd-right">
        <span class="pill" style="background:${(statusColor[d.status]||C.dim)}22;color:${(statusColor[d.status]||C.dim)};border:1px solid ${(statusColor[d.status]||C.dim)}44">${d.status.toUpperCase()}</span>
        <div class="tdd-by">${esc(d.by)}</div>
        ${role.canApprove&&d.status!=="approved"?`<button class="obtn ok" style="font-size:10px;padding:4px 10px" data-tddapprove="${d.id}">Approve</button>`:""}
        ${role.canEdit||role.canApprove?`<button class="obtn nu" style="font-size:10px;padding:4px 10px" data-tdddel="${d.id}">Remove</button>`:""}
      </div>
    </div>`;
  }).join("")
  :`<div class="empty-state">
      <div class="es-ico">🔍</div>
      <div class="es-t">${search?"No matches":(filtCat!=="all"?"Nothing in this category":"No documents yet")}</div>
      <div class="es-s">${search?`Nothing in the document repository matches "${esc(search)}". Try a different keyword or clear filters.`:(filtCat!=="all"?"Try a different category, or clear the filter to see everything.":"Add the first document using the button above.")}</div>
    </div>`;

  return `<div class="tddwrap">
    <div class="vhead">
      <h1 class="serif">Documents</h1>
      <div class="vs">Project document repository — ${D.project.name}</div>
      <div class="vtag">${tddDocs.length} documents</div>
    </div>
    <div class="tdd-toolbar">
      <div class="tdd-cats">${catTabs}</div>
      <div class="tdd-actions">
        <input class="tdd-search" id="tddSearch" placeholder="Search docs…" value="${state.tddSearch||""}"/>
        ${role.canEdit||role.canApprove?`<button class="export-btn go" id="tddAddDoc">+ Add document</button>`:""}
        <button class="export-btn" id="tddExport">⬇ Export list</button>
      </div>
    </div>
    <div class="tdd-stats">
      ${cats.map(c=>{const n=tddDocs.filter(d=>d.cat===c.id).length; const ap=tddDocs.filter(d=>d.cat===c.id&&d.status==="approved").length;
        return n?`<div class="tdd-stat"><span>${c.icon}</span><b>${ap}/${n}</b><span>${c.label}</span></div>`:"";}).join("")}
    </div>
    <div class="tdd-list" id="tdd-list">${rows}</div>
    <div id="tdd-modal" class="tdd-modal" style="display:none">
      <div class="tdd-modal-box">
        <div class="tdd-modal-hd">Add document</div>
        <div class="tdd-form">
          <label>Name<input id="tdf-name" placeholder="Document name"/></label>
          <label>Category<select id="tdf-cat">${cats.map(c=>`<option value="${c.id}">${c.icon} ${c.label}</option>`).join("")}</select></label>
          <label>Reference No.<input id="tdf-ref" placeholder="e.g. CNC-BV748-E04"/></label>
          <label>Rev.<input id="tdf-rev" value="1" style="width:70px"/></label>
          <label>Date<input id="tdf-date" placeholder="YYYY-MM"/></label>
          <label>Author / Company<input id="tdf-by" placeholder="e.g. Conecon GmbH"/></label>
          <label>Notes<input id="tdf-notes" placeholder="Short description"/></label>
        </div>
        <div class="tdd-modal-btns">
          <button class="obtn ok" id="tdf-save">Save document</button>
          <button class="obtn" id="tdf-cancel">Cancel</button>
        </div>
      </div>
    </div>
    <div class="card" style="margin-top:18px">
      <h3>Project parties</h3><div class="csub">Roles across the project</div>
      <table class="bom"><tbody>
        <tr><td style="color:${C.dim};width:200px">Client / developer</td><td>${D.project.client}</td></tr>
        <tr><td style="color:${C.dim}">EPC / piling contractor</td><td>${D.project.epc}</td></tr>
        <tr><td style="color:${C.dim}">Mounting structure</td><td>${D.project.structure} (${D.project.system})</td></tr>
        <tr><td style="color:${C.dim}">Inverter engineering</td><td>${D.project.inverterEng}</td></tr>
        <tr><td style="color:${C.dim}">Location</td><td>${D.project.location} · <span class="mono">${D.project.gps}</span></td></tr>
      </tbody></table>
    </div>
  </div>`;
}

/* ---------- SITE MAP ---------- */
function tableTypeFor(f, t){
  // Real CAD type when the topology has been loaded (applyTopology); else the
  // original deterministic pseudo-assignment for the demo seed.
  if(realTypeByKey){ const rt=realTypeByKey[f.id+"::"+t]; if(rt) return rt; }
  // deterministic pseudo-assignment reflecting the type mix (most are 3×27, edges smaller)
  const types=Object.keys(D.tableTypes);
  const seed=(t*7 + f.id.length*3) % 10;
  if(seed<6) return "3x27"; if(seed<9) return "3x18"; return "3x9";
}

// Replace the in-memory topology (D.fields + per-table types) with the real
// CAD layout extracted from the field/ZIM DXFs and loaded from Supabase
// (topo_fields / topo_tables). Inspection records SURVIVE unchanged — they key
// on "Field N::t", which is the same identity the canonical tables use. Called
// once at boot by lib/topology.applyCanonicalTopology after the headless engine
// is up. See CLAUDE.md (CAD = source of truth; QC inspects these exact tables).
function applyTopology(payload){
  if(!payload || !Array.isArray(payload.fields) || !payload.fields.length) return false;
  D.fields = payload.fields;
  realTypeByKey = payload.typeByKey || null;
  if(typeof render==="function") render();  // component mode -> __gpNotify -> store bump
  return true;
}
// Replace the synthetic station/inverter model with the REAL transformer stations
// + inverter designators from the CAD topology (topo_inverters.label, "TR{n}-INV{m}"),
// so QC Electrical numbering matches the Site Map 1:1 and each station shows its true
// inverter count. Inspection records key on (stationId, invIdx); the per-station
// inverter list is sorted by INV number so invIdx maps to a stable real inverter.
function applyInverterTopology(payload){
  if(!payload || !Array.isArray(payload.stations) || !payload.stations.length) return false;
  D.stations = payload.stations.map(s => ({
    id: s.id,
    label: s.label || s.id,
    area: s.area || "",
    invCount: s.invCount != null ? s.invCount : (Array.isArray(s.inverters) ? s.inverters.length : 0),
    padHeight: s.padHeight,
    ref: s.ref || s.id,
    ratingMva: s.ratingMva,
    inverters: Array.isArray(s.inverters) ? s.inverters : [],
  }));
  // Keep the default selection valid after the model swap.
  if(!D.stations.find(s=>s.id===state.qcStation)) state.qcStation = D.stations[0].id;
  if(typeof render==="function") render();
  return true;
}
// Real inverter designator for a (station, inverter-index). Falls back to the
// synthetic "<ST>-INV<n>" when no CAD label is loaded (offline / pre-topology).
function invLabel(stationId, invIdx){
  const st = D.stations.find(s=>s.id===stationId);
  const inv = st && st.inverters && st.inverters[invIdx];
  return (inv && inv.label) ? inv.label : `${stationId}-INV${(+invIdx)+1}`;
}
// Short "INV{m}" part of the designator (for the compact grid cells / breadcrumb).
function invShort(stationId, invIdx){
  const m = invLabel(stationId, invIdx).match(/INV\s*\d+$/i);
  return m ? m[0].replace(/\s+/g,"") : `INV${(+invIdx)+1}`;
}
function vSiteMap(){
  const f = D.fields.find(x=>x.id===state.selField) || D.fields[0];
  // rollup acceptance per field — uses the EFFECTIVE status, so tables that
  // are fully verified in QC count as "pass" on the site map even if the
  // manager hasn't tapped the Accept button yet.
  function fieldRoll(fl){
    let pass=0,fail=0;
    for(let t=1;t<=fl.tables;t++){
      const s = tableEffectiveStatus(fl.id, t).status;
      if(s==="pass") pass++;
      else if(s==="fail") fail++;
    }
    return {pass,fail,done:pass+fail};
  }
  // Pre-compute punch pins for the overlay layer (if toggle is on)
  const showPins = state.mapShowPins !== false;
  const allPins = showPins ? punchPinsForMap({showResolved:false}) : [];
  // Group pin counts per field for the cluster badges + per-table-cell dots
  const pinsPerField = {};
  const pinsPerTable = {};   // key: "fid::t" → count
  allPins.forEach(pin => {
    const it = pin.item;
    if(pin.anchor === "field") {
      // Resolve which field this pin belongs to.
      // For station pins, parse the exact field number from the station's
      // `area` string. IMPORTANT: use an exact regex match, not .includes(),
      // because "Field 1" is a substring of "Field 12"/"Field 13" and would
      // mis-resolve those stations to Field 1.
      let fldId = it.fid;
      if(it.workScope === "station"){
        const st = D.stations.find(s=>s.id===it.fid);
        const m = st && (st.area||"").match(/Field\s+(\d+)/i);
        fldId = m ? ("Field " + m[1]) : null;
      }
      if(fldId){
        pinsPerField[fldId] = (pinsPerField[fldId] || 0) + 1;
        if(it.workScope !== "station"){
          const k = `${it.fid}::${it.t}`;
          pinsPerTable[k] = (pinsPerTable[k] || 0) + 1;
        }
      }
    }
  });
  const fieldsHtml = D.fields.map(fl=>{
    const r=fieldRoll(fl);
    const col=r.fail>0?C.rust:(r.pass>0?C.grass:C.dim2);
    const pct=fl.tables?Math.round(r.done/fl.tables*100):0;
    const pinCount = pinsPerField[fl.id] || 0;
    return `<div class="field ${fl.id===state.selField?'sel':''}" data-field="${fl.id}"
       style="left:${fl.x}%;top:${fl.y}%;width:${fl.w}%;height:${fl.h}%">
       <div class="fdot" style="background:${col}"></div>
       <div class="fid">${fl.id}</div>
       <div class="fmeta">${fl.tables} tbl · ${r.done}/${fl.tables} inspected</div>
       <div class="fpbar"><i style="width:${pct}%;background:${col}"></i></div>
       ${showPins && pinCount>0 ? `<div class="fpinbadge" title="${pinCount} open punch item${pinCount===1?"":"s"} in this field">${pinCount}</div>` : ""}
    </div>`;
  }).join("");
  // Punch-pin overlay layer. Sits ABOVE the field rectangles, BELOW the legend.
  // Each pin is absolutely positioned on the mapstage. Click → opens a popup.
  const pinsLayer = showPins ? allPins.filter(p=>p.anchor==="field").map(pin=>{
    const it = pin.item;
    return `<button class="ppin" data-pinid="${pin.id}"
              style="left:${pin.x}%;top:${pin.y}%;--pc:${pin.color}"
              title="${esc(it.item)} — ${esc(it.loc)}${it.ncr?` · ${it.ncr}`:""}"
              aria-label="Punch item: ${esc(it.item)} at ${esc(it.loc)}">
            </button>`;
  }).join("") : "";
  // Site-wide pins (anchored to a fixed corner of the map)
  const sitePins = showPins ? allPins.filter(p=>p.anchor==="site") : [];
  const sitePinStack = sitePins.length ? `<div class="ppin-site-stack" title="${sitePins.length} site-wide open item${sitePins.length===1?"":"s"}">
      <div class="ppin-site-lbl">Site-wide</div>
      ${sitePins.map(pin=>`<button class="ppin ppin-site" data-pinid="${pin.id}" style="--pc:${pin.color}" title="${esc(pin.item.item)}"></button>`).join("")}
    </div>` : "";
  // The popup itself, rendered if a pin is selected
  const popup = (state.mapPin && showPins) ? (()=>{
    const pin = allPins.find(p => p.id === state.mapPin);
    if(!pin) return "";
    const it = pin.item;
    const scopeChip = scopeBadge(it.scope);
    return `<div class="ppin-popup" id="ppinPopup"
                  style="left:${pin.anchor==='site'?'94%':pin.x+'%'};top:${pin.anchor==='site'?'88%':pin.y+'%'}">
        <button class="ppin-popup-x" data-pinclose="1" aria-label="Close">✕</button>
        <div class="ppin-popup-h">
          <span class="ppin-dot" style="background:${pin.color}"></span>
          ${scopeChip}
          ${it.ncr ? `<span class="ppin-ncr">${esc(it.ncr)}</span>` : `<span class="ppin-open">OPEN</span>`}
        </div>
        <div class="ppin-popup-t">${esc(it.item)}</div>
        <div class="ppin-popup-loc">${esc(it.loc)}</div>
        <div class="ppin-popup-meta">
          <span class="mono">${esc(it.itp)}</span>
          ${it.by ? ` · ${esc(it.by)}` : ""}${it.at ? ` · ${esc(it.at)}` : ""}
        </div>
        ${it.comment ? `<div class="ppin-popup-note">"${esc(it.comment)}"</div>` : ""}
        <button class="obtn ok ppin-popup-go" data-pingoqc="${pin.id}">Open in Quality Control →</button>
      </div>`;
  })() : "";
  // table grid for selected field — colored by EFFECTIVE acceptance status
  // (manager signoff if set, else derived from QC results). Clickable.
  let grid="";
  for(let t=1;t<=f.tables;t++){
    const ty=tableTypeFor(f,t), tt=D.tableTypes[ty];
    const eff = tableEffectiveStatus(f.id, t);
    const st = eff.status;
    let bg='transparent', fg=C.dim, bd=tt.color, glyph=t;
    if(st==="pass"){ bg=C.grass; fg=C.bg; bd=C.grass; }
    else if(st==="fail"){ bg=C.rust; fg=C.bg; bd=C.rust; }
    else if(st==="partial"){ bd=C.amber; }   // partial: leave outline-only with amber border
    const sel = state.selTable===t;
    // Per-cell punch indicator (small red dot + count badge)
    const pCount = pinsPerTable[`${f.id}::${t}`] || 0;
    const pDot = (showPins && pCount>0)
      ? `<span class="tcell-pdot" title="${pCount} open punch item${pCount===1?"":"s"}">${pCount>1?pCount:""}</span>`
      : "";
    // Hover title: include "auto" hint when status was derived from QC, not manual
    const statusLbl = st==="pass" ? (eff.source==="derived" ? "Accepted (auto, from QC)" : "Accepted")
                    : st==="fail" ? (eff.source==="derived" ? "Failed (auto, from QC)" : "Failed")
                    : st==="partial" ? "In progress"
                    : "Not inspected";
    grid+=`<div class="tcell${sel?' tsel':''}${eff.source==="derived"?' tauto':''}" data-table="${t}"
      title="${f.id} · Table ${t} · ${tt.label} · ${statusLbl}${pCount?` · ${pCount} open punch item${pCount===1?"":"s"}`:""}"
      style="background:${bg};color:${fg};border-color:${bd}">${glyph}${pDot}</div>`;
  }
  const typeLeg=Object.values(D.tableTypes).map(t=>`<span><i style="background:transparent;border-color:${t.color}"></i>${t.label}</span>`).join("");
  const roll=fieldRoll(f);

  // selected-table panel
  let tpanel="";
  if(state.selTable){
    const t=state.selTable, ty=tableTypeFor(f,t), tt=D.tableTypes[ty];
    const manual = tableStatus[tkey(f.id,t)];                    // manager's call (if any)
    const eff = tableEffectiveStatus(f.id, t);                   // effective for the map
    const st = eff.status;                                       // what colour the map shows
    const lab = st==="pass"?["Accepted",C.grass]
              : st==="fail"?["Failed",C.rust]
              : st==="partial"?["In progress",C.amber]
              : ["Not inspected",C.dim];
    // If the cell is green/red because of derived QC data (not because the
    // manager pressed Accept/Fail), tell the manager — they may still want
    // to sign off explicitly for the audit trail.
    const autoHint = (eff.source === "derived" && (st==="pass"||st==="fail"))
      ? `<div class="autohint" title="This status was derived from inspection results in Quality Control. Click ${st==='pass'?'Accept':'Fail'} below to add your formal signoff.">
           <svg viewBox="0 0 16 16" width="11" height="11" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M2 8a6 6 0 0 1 11.5-2.4M14 8a6 6 0 0 1-11.5 2.4M11 4l3 1.6L12.4 8M5 12L2 10.4 3.6 8"/></svg>
           Auto-derived from QC results · awaiting manager signoff
         </div>` : "";
    tpanel=`
      <div class="tdetail">
        <div class="tdhead">
          <div><div class="lbl">${f.id}</div><div class="tdt serif">Table ${t}</div></div>
          <span class="pill" style="background:${lab[1]}22;color:${lab[1]}">${lab[0].toUpperCase()}</span>
        </div>
        ${autoHint}
        <div class="metagrid" style="margin-top:12px">
          <div class="mcell"><b>Type</b><span>${tt.label}</span></div>
          <div class="mcell"><b>Piles</b><span class="mono">${tt.piles}</span></div>
          <div class="mcell"><b>C-rail</b><span class="mono">C120×60×2.0</span></div>
          <div class="mcell"><b>Tilt</b><span class="mono">${D.project.tilt}</span></div>
        </div>
        <div class="field-l" style="margin-top:14px">Acceptance</div>
        <div class="resultrow">
          <button class="rbtn" data-tset="pass" style="background:${manual==="pass"?C.grass:'var(--bg2)'};color:${manual==="pass"?C.bg:C.grass};border:1px solid ${C.grass}">✓ Accept</button>
          <button class="rbtn" data-tset="fail" style="background:${manual==="fail"?C.rust:'var(--bg2)'};color:${manual==="fail"?C.bg:C.rust};border:1px solid ${C.rust}">✕ Fail</button>
        </div>
        ${manual?`<button class="photobtn" data-tset="clear" style="margin-top:9px">↺ Clear manager signoff</button>`:""}
        <div class="auditmeta">${
          manual
            ? `Manager signoff: ${manual==="pass"?"Accepted":"Failed"} · ${manual==="fail"?"NCR auto-linked":"signed"} · device BAL-FIELD-03`
            : eff.source==="derived"
              ? `Status auto-derived from inspection results. Click Accept or Fail to record a formal signoff.`
              : `Select Accept or Fail to record acceptance for this table.`
        }</div>
      </div>`;
  } else {
    tpanel=`<div style="margin-top:14px;font-size:11px;color:${C.dim2};line-height:1.6;border:1px dashed ${C.line2};border-radius:3px;padding:14px">
      Click a table in the grid to record acceptance.<br/>
      <span style="color:${C.grass}">Green</span> = fully verified or manually accepted ·
      <span style="color:${C.rust}">Red</span> = failed ·
      <span style="color:${C.amber}">Amber outline</span> = in progress ·
      Plain outline = not yet inspected.</div>`;
  }

  return `<div class="mapview">
    <div class="mapstage" id="mapstage">
      ${fieldsHtml}
      ${pinsLayer}
      ${sitePinStack}
      ${popup}
      <svg class="compass" viewBox="0 0 60 60">
        <circle cx="30" cy="30" r="26" fill="none" stroke="${C.line}"/>
        <path d="M30 6 L34 30 L30 28 L26 30 Z" fill="${C.hiviz}"/>
        <path d="M30 54 L34 30 L30 32 L26 30 Z" fill="${C.dim2}"/>
        <text x="30" y="16" text-anchor="middle" fill="${C.dim}" font-size="7" font-family="IBM Plex Mono">N</text>
      </svg>
      <div class="mlegend"><b>Table acceptance</b>
        <div><i style="background:${C.grass}"></i>Accepted</div>
        <div><i style="background:${C.rust}"></i>Failed</div>
        <div><i style="background:${C.dim2}"></i>Not inspected</div>
        ${showPins ? `
          <div class="mlegend-sep"></div>
          <b>Punch pins</b>
          <div><i class="legpin" style="background:${C.rust}"></i>Open · NCR raised</div>
          <div><i class="legpin" style="background:${C.amber}"></i>Open · no NCR</div>` : ""}
      </div>
      <button class="mappins-toggle ${showPins?'on':''}" id="mapPinsToggle"
              title="${showPins?'Hide':'Show'} punch-list pins on the map">
        <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
          <path d="M8 1.5C5.5 1.5 3.5 3.5 3.5 6c0 3.4 4.5 8.5 4.5 8.5s4.5-5.1 4.5-8.5C12.5 3.5 10.5 1.5 8 1.5z"/>
          <circle cx="8" cy="6" r="1.5"/>
        </svg>
        ${showPins ? "Pins on" : "Pins off"}
        ${showPins && allPins.length ? `<span class="mappins-count">${allPins.length}</span>` : ""}
      </button>
      <div class="scalebar"><span>schematic layout · not to scale</span><div class="bar"></div><span>13 fields · Ballyroe</span></div>
      <div class="maphint">Click a field, then click any table to mark it accepted or failed.</div>
    </div>
    <div class="fpanel">
      <div class="ph serif">${f.id}</div>
      <div class="psub">${f.tables} tables · ${tableTypeFor(f,1)&&"Sigma65 fixed-tilt"}</div>
      <div class="fstats">
        <div class="fcell"><b>Accepted</b><span style="color:${C.grass}">${roll.pass}</span></div>
        <div class="fcell"><b>Failed</b><span style="color:${roll.fail>0?C.rust:C.dim}">${roll.fail}</span></div>
        <div class="fcell"><b>Inspected</b><span>${roll.done}/${f.tables}</span></div>
        <div class="fcell"><b>Acceptance</b><span style="color:${C.grass}">${roll.done?Math.round(roll.pass/roll.done*100):0}%</span></div>
      </div>
      <div class="tabgrid-h">Table grid · click to accept / fail</div>
      <div class="tabgrid">${grid}</div>
      <div class="typelegend">${typeLeg}</div>
      ${tpanel}
    </div>
  </div>`;
}

/* ---------- QC ---------- */
function vQC(){
  const scope = state.qcWorkScope || "table";
  const sel = (s,l,icon,count)=>`<button class="ws-pill ${scope===s?'sel':''}" data-workscope="${s}">${icon}<span class="ws-l">${l}</span>${count!=null?`<span class="ws-c">${count}</span>`:""}</button>`;

  // Site-wide counts for the selector pills
  const tablesInspected = Object.keys(inspections).filter(k=>!k.includes("::M")&&!k.includes("::P")&&recStarted(inspections[k])).length;
  const stationInvDone = (()=>{ let n=0; D.stations.forEach(st=>{ for(let i=0;i<st.invCount;i++){ if(recStarted(getStationInv(st.id,i))) n++; } }); return n; })();
  const siteDone = Object.values(siteInspection.items||{}).filter(_itemStarted).length;

  const selector = `<div class="ws-bar">
    ${sel("table","Tables",`<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="1.5" y="3.5" width="13" height="3"/><rect x="1.5" y="9.5" width="13" height="3"/></svg>`,`${tablesInspected} in progress`)}
    ${sel("station","Stations",`<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="2" y="5" width="12" height="9" rx="1"/><path d="M5 5V3M11 5V3M2 9h12"/></svg>`,`${stationInvDone}/${D.stations.reduce((a,s)=>a+s.invCount,0)} inverters`)}
    ${sel("site","Site-wide",`<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="8" cy="8" r="6.5"/><path d="M1.5 8h13M8 1.5a10 10 0 010 13M8 1.5a10 10 0 000 13"/></svg>`,`${siteDone}/${D.siteItp.length} items`)}
  </div>`;

  let body;
  if(scope==="station") body = vQCStation();
  else if(scope==="site") body = vQCSite();
  else body = vQCTable();

  return `<div class="qc-wrap-outer">${selector}${body}</div>`;
}

/* -------- Table-scope QC (original Field / Row / Table) -------- */
function vQCTable(){
  const f = D.fields.find(x=>x.id===state.qcField) || D.fields[0];
  const nRows = rowsForField(f);
  const rowTables = tablesInRow(f, state.qcRow);
  if(!rowTables.includes(state.qcTable)) state.qcTable = rowTables[0];
  const fid=f.id, t=state.qcTable;
  const roll = tableRoll(fid,t);

  /* ---- LEFT: field tree (fields -> rows) ---- */
  let tree=`<div class="sbhead"><span>Inspection navigator</span><span class="mono">ITP-BAL</span></div>`;
  D.fields.forEach(fl=>{
    const open = fl.id===state.qcField;
    // field roll-up (accepted tables)
    let acc=0,fl_fail=0,insp=0;
    for(let tt=1;tt<=fl.tables;tt++){const rr=tableRoll(fl.id,tt); if(rr.overall==="pass")acc++; else if(rr.overall==="fail")fl_fail++; if(rr.done>0)insp++;}
    const dot = fl_fail>0?C.rust:(acc>0?C.grass:C.dim2);
    tree+=`<div class="catgroup">
      <div class="cathead navfield ${open?'open':''}" data-qfield="${fl.id}">
        <span style="display:flex;align-items:center;gap:8px"><span class="sq" style="background:${dot};border-radius:50%"></span>${fl.id}</span>
        <span class="cc">${fl.tables} tbl${insp?` · ${acc}✓`:""}</span>
      </div>`;
    if(open){
      tree+=`<div class="rowlist">`;
      for(let row=1; row<=nRows; row++){
        const tabs=tablesInRow(fl,row);
        let rPass=0,rFail=0,rDone=0;
        tabs.forEach(tt=>{const rr=tableRoll(fl.id,tt); if(rr.overall==="pass")rPass++; else if(rr.overall==="fail")rFail++; if(rr.done>0)rDone++;});
        const rc = rFail>0?C.rust:(rPass>0?C.grass:C.dim2);
        tree+=`<div class="rowitem ${row===state.qcRow?'sel':''}" data-qrow="${row}">
          <span class="rlab">Row ${String(row).padStart(2,"0")}</span>
          <span class="rmeta"><span class="sq" style="background:${rc}"></span>${tabs.length} tables${rDone?` · ${rDone} insp.`:""}</span>
        </div>`;
      }
      tree+=`</div>`;
    }
    tree+=`</div>`;
  });

  /* ---- MIDDLE: row table-strip + module grid + checklist ---- */
  // table chips for current row
  const chips = rowTables.map(tt=>{
    const rr=tableRoll(fid,tt);
    const col = rr.overall==="pass"?C.grass : rr.overall==="fail"?C.rust : rr.overall==="partial"?C.amber : "transparent";
    const fg = (rr.overall==="pass"||rr.overall==="fail")?C.bg:C.ink;
    const ty=D.tableTypes[tableTypeFor(f,tt)];
    return `<button class="tabchip ${tt===t?'sel':''}" data-qtable="${tt}" title="${ty.label} · ${rr.done}/${rr.total} items"
      style="background:${col};color:${fg};border-color:${col==='transparent'?ty.color:col}">
      <b>T${tt}</b><span>${rr.done}/${rr.total}</span></button>`;
  }).join("");

  // module grid for selected table — true 3-row portrait layout
  const tt=D.tableTypes[tableTypeFor(f,t)];
  const cols=tt.cols, rows=tt.rows;
  const mr=moduleTableRoll(fid,t,cols);
  let modgrid="";
  for(let row=0; row<rows; row++){
    let cells="";
    for(let cIdx=0;cIdx<cols;cIdx++){
      const m=row*cols+cIdx;
      const rr=moduleRoll(fid,t,m);
      const col = rr.overall==="pass"?C.grass : rr.overall==="fail"?C.rust : rr.overall==="partial"?C.amber : "transparent";
      const sel = state.qcModule===m;
      cells+=`<button class="mod ${sel?'sel':''}" data-qmod="${m}" title="Module R${row+1}·C${cIdx+1} — ${rr.overall}"
        style="background:${col==='transparent'?'var(--bg2)':col};border-color:${col==='transparent'?'var(--line2)':col}"></button>`;
    }
    modgrid+=`<div class="modrow">${cells}</div>`;
  }

  // pile grid for selected table — North row + South row (per drawing rope-alignment detail)
  const perRow=tt.pilesPerRow;
  const pr=pileTableRoll(fid,t,perRow);
  const pileRowHtml=(side,base)=>{
    let cells="";
    for(let c=0;c<perRow;c++){
      const p=base+c;
      const rr=pileRoll(fid,t,p);
      const col = rr.overall==="pass"?C.grass : rr.overall==="fail"?C.rust : rr.overall==="partial"?C.amber : "transparent";
      const sel = state.qcPile===p;
      cells+=`<button class="pile ${sel?'sel':''}" data-qpile="${p}" title="${side} pile ${c+1} — ${rr.overall}"
        style="background:${col==='transparent'?'var(--bg2)':col};border-color:${col==='transparent'?'var(--line2)':col}">${side}${c+1}</button>`;
    }
    return cells;
  };
  const pilegrid=`
    <div class="pilerow"><span class="pilelab">North</span><div class="pilecells">${pileRowHtml("N",0)}</div></div>
    <div class="ropeline"><span>rope alignment</span></div>
    <div class="pilerow"><span class="pilelab">South</span><div class="pilecells">${pileRowHtml("S",perRow)}</div></div>`;

  const inMod = state.qcModule!=null;
  const inPile = state.qcPile!=null;
  // active checklist: piles use the pile ITP, modules/table use the structure ITP
  const ITP = inPile ? D.pileItp : D.tableItp;
  // checklist source: pile-scoped, module-scoped, or table-scoped

  // Counts for status filter pills (global across all scopes)
  let _pass=0,_fail=0,_pending=0;
  ITP.forEach((it,i)=>{
    const res = inPile ? pileItemResult(fid,t,state.qcPile,i)
              : inMod ? modItemResult(fid,t,state.qcModule,i)
              : itemResult(fid,t,i);
    if(res.status==="pass") _pass++;
    else if(res.status==="fail") _fail++;
    else _pending++;
  });

  // Counts per scope (mechanical / electrical only — civil lives in the Site-wide work scope).
  // Pile ITP doesn't use scope tags.
  const usesScope = !inPile;
  const scope = state.qcMechFilter||"all";
  const _scopeCounts = usesScope ? {mechanical:0,electrical:0,all:ITP.length} : null;
  if(usesScope) ITP.forEach(it=>{ if(_scopeCounts[it.scope]!=null) _scopeCounts[it.scope]++; });

  const filt=state.qcChecklistFilter||"all";
  const scopeFilterBar = usesScope ? `<div class="cl-scope">
    <button class="cl-scope-pill ${scope==='all'?'sel':''}" data-clmechfilter="all">All <b>${_scopeCounts.all}</b></button>
    ${_scopeCounts.mechanical>0?`<button class="cl-scope-pill ${scope==='mechanical'?'sel':''} mechanical" data-clmechfilter="mechanical">⚙ Mechanical <b>${_scopeCounts.mechanical}</b></button>`:""}
    ${_scopeCounts.electrical>0?`<button class="cl-scope-pill ${scope==='electrical'?'sel':''} electrical" data-clmechfilter="electrical">⚡ Electrical <b>${_scopeCounts.electrical}</b></button>`:""}
  </div>` : "";

  const filterBar=`${scopeFilterBar}<div class="cl-filter">
    <button class="cl-pill ${filt==='all'?'sel':''}" data-clfilter="all">All <b>${ITP.length}</b></button>
    <button class="cl-pill ${filt==='pass'?'sel':''} pass" data-clfilter="pass">Pass <b>${_pass}</b></button>
    <button class="cl-pill ${filt==='fail'?'sel':''} fail" data-clfilter="fail">Fail <b>${_fail}</b></button>
    <button class="cl-pill ${filt==='pending'?'sel':''} pending" data-clfilter="pending">Open <b>${_pending}</b></button>
  </div>`;

  // Helper to check whether an item passes both filters
  const matchesFilter = (it,i)=>{
    if(usesScope && scope!=="all" && it.scope!==scope) return false;
    if(filt==="all") return true;
    const res = inPile ? pileItemResult(fid,t,state.qcPile,i)
              : inMod ? modItemResult(fid,t,state.qcModule,i)
              : itemResult(fid,t,i);
    return res.status===filt;
  };

  let checklist=filterBar;
  let _anyShown=false;

  // Build groups: when scoped, render scope -> categories. Otherwise just categories.
  const scopeOrder = ["mechanical","electrical"];
  const scopeLabels = {mechanical:"⚙ Mechanical scope", electrical:"⚡ Electrical scope"};

  const renderCat = (catItems, code, cat)=>{
    if(!catItems.length) return "";
    _anyShown=true;
    let out=`<div class="clcat"><span>${esc(cat)}</span><span class="cc">${code}</span></div>`;
    catItems.forEach(({it,i})=>{
      const res = inPile ? pileItemResult(fid,t,state.qcPile,i)
                : inMod ? modItemResult(fid,t,state.qcModule,i)
                : itemResult(fid,t,i);
      const st=STATUS[res.status];
      const sel=i===state.qcItem;
      out+=`<div class="clrow ${sel?'sel':''}" data-qitem="${i}">
        <span class="clstat" style="background:${st.color}">${st.glyph||""}</span>
        <span class="clname">${esc(it.item)}<span class="clref">BAL-${code}-${String(i+1).padStart(3,"0")}</span></span>
        <span class="clbtns">
          <button class="clmini ${res.status==='pass'?'pass':''}" data-qset="${i}:pass" title="Pass" aria-label="Mark item ${i+1} as Pass">✓</button>
          <button class="clmini ${res.status==='fail'?'fail':''}" data-qset="${i}:fail" title="Fail" aria-label="Mark item ${i+1} as Fail">✕</button>
        </span>
      </div>`;
    });
    return out;
  };

  if(usesScope){
    // Group by scope, then by category within scope
    scopeOrder.forEach(sc=>{
      if(scope!=="all" && scope!==sc) return;
      const itemsInScope = ITP.map((it,i)=>({it,i})).filter(x=>x.it.scope===sc && matchesFilter(x.it,x.i));
      if(!itemsInScope.length) return;
      // Scope header
      checklist+=`<div class="cl-scope-head cl-scope-${sc}">${scopeLabels[sc]}</div>`;
      // Cats within scope, preserving original order
      const catsInScope=[];
      itemsInScope.forEach(x=>{ if(!catsInScope.includes(x.it.cat)) catsInScope.push(x.it.cat); });
      catsInScope.forEach(cat=>{
        const items = itemsInScope.filter(x=>x.it.cat===cat);
        const code = items[0].it.code;
        checklist += renderCat(items, code, cat);
      });
    });
  } else {
    // Pile ITP: just by category
    const cats=[...new Set(ITP.map(it=>it.cat))];
    cats.forEach(cat=>{
      const items=ITP.map((it,i)=>({it,i})).filter(x=>x.it.cat===cat && matchesFilter(x.it,x.i));
      const code = ITP.find(it=>it.cat===cat).code;
      checklist += renderCat(items, code, cat);
    });
  }

  if(!_anyShown){
    const filtLabel = filt==="pass"?"passed":filt==="fail"?"failed":"open";
    const scopeLabel = scope==="all" ? "" : ` in ${scope}`;
    checklist+=`<div class="empty-state">
      <div class="es-ico">${filt==="fail"?"✓":filt==="pass"?"○":"✓"}</div>
      <div class="es-t">No ${filtLabel} items${scopeLabel}</div>
      <div class="es-s">${filt==="fail"?"Nothing has been rejected on this scope. That's good news.":filt==="pass"?"No items have been accepted yet — start ticking them off.":"Every item has been actioned. Switch back to All to see results."}</div>
    </div>`;
  }

  const overallLabel = roll.overall==="pass"?["ACCEPTED",C.grass]
    : roll.overall==="fail"?["REJECTED",C.rust]
    : roll.overall==="partial"?["IN PROGRESS",C.amber]:["NOT STARTED",C.dim2];

  /* ---- RIGHT: selected item detail (pile / module / table scope) ---- */
  // clamp selected item to the active checklist length
  if(state.qcItem>=ITP.length) state.qcItem=0;
  const it=ITP[state.qcItem];
  const res = inPile ? pileItemResult(fid,t,state.qcPile,state.qcItem)
            : inMod ? modItemResult(fid,t,state.qcModule,state.qcItem)
            : itemResult(fid,t,state.qcItem);
  const st=STATUS[res.status];
  const code=it.code;
  const modRow = inMod ? Math.floor(state.qcModule/cols)+1 : 0;
  const modCol = inMod ? (state.qcModule%cols)+1 : 0;
  const pInfo = inPile ? pileInfo(state.qcPile,perRow) : null;
  const pileName = inPile ? `${pInfo.side==="N"?"North":"South"} pile ${pInfo.col}` : "";
  const locTxt = inPile ? `${fid} · T${t} · ${pInfo.side}${pInfo.col} (${pInfo.side==="N"?"North":"South"} row)`
              : inMod ? `${fid} · T${t} · Module R${modRow}·C${modCol}`
              : `${fid} · R${String(state.qcRow).padStart(2,"0")} · T${t}`;
  const scopeTag = inPile?" · pile":inMod?" · module":"";
  // photos & comments scope
  const evid = inPile ? getPile(fid,t,state.qcPile) : inMod ? getModule(fid,t,state.qcModule) : res;
  const evPhotos = evid.photos||[];
  const evComments = evid.comments||[];
  let panel=`
    <div class="lbl">Inspection item ${String(state.qcItem+1).padStart(3,"0")} · BAL-${code}-${String(state.qcItem+1).padStart(3,"0")}${scopeTag}</div>
    <div class="iname serif">${it.item}</div><div class="icat">${it.cat}${inPile?` · ${pileName}`:inMod?` · Module R${modRow}·C${modCol}`:""}</div>
    <div class="metagrid">
      <div class="mcell"><b>Location</b><span class="mono">${locTxt}</span></div>
      <div class="mcell"><b>Table type</b><span class="mono">${D.tableTypes[tableTypeFor(f,t)].label}</span></div>
      <div class="mcell"><b>NCR linked</b><span class="mono" style="color:${res.ncr?C.rust:C.dim}">${res.ncr||"—"}</span></div>
      <div class="mcell"><b>Status</b><span style="color:${st.color};font-weight:600">${st.label}</span></div>
    </div>
    <div class="field-l">Acceptance criteria</div>
    <div class="crit">${esc(it.crit||"—")}</div>
    <div class="field-l">Result</div>
    <div class="resultrow">
      ${["pass","fail"].map(s=>{const on=res.status===s,c=STATUS[s].color;
        return `<button class="rbtn" data-qset="${state.qcItem}:${s}" style="background:${on?c:'var(--bg2)'};color:${on?C.bg:c};border:1px solid ${c}">${s==="fail"?"✕ Fail / raise NCR":"✓ Pass"}</button>`;}).join("")}
    </div>
    <div class="field-l">Photo evidence ${evPhotos.length?`· ${evPhotos.length}`:""}${scopeTag}</div>
    <div class="gallery">
      ${evPhotos.map(p=>`<div class="thumb" data-viewphoto="${p.id}">
          <img src="${p.thumb}" alt="${p.name||"photo"}"/>
          <button class="thdel" data-delphoto="${p.id}" title="Remove">✕</button>
        </div>`).join("")}
      <button class="addphoto" id="qaddphoto">
        <span class="pi-cam">+</span><span>Add photo</span>
      </button>
      <input type="file" id="qphotoinput" accept="image/*" capture="environment" multiple style="display:none"/>
    </div>
    <div class="field-l">Comments ${evComments.length?`· ${evComments.length}`:""}${scopeTag}</div>
    <div class="thread">
      ${evComments.length?evComments.map(c=>`
        <div class="cmt">
          <div class="cmt-h"><span class="cmt-by">${esc(c.by)}</span><span class="cmt-at">${Store._day(c.at)} · ${Store._hm(c.at)}</span>
            <button class="cmt-del" data-delcomment="${c.id}" title="Delete">✕</button></div>
          <div class="cmt-tx">${esc(c.text)}</div>
        </div>`).join("")
        :`<div class="cmt-empty">No comments yet. Add an observation, deviation, or rework note.</div>`}
    </div>
    <div class="cmt-compose">
      <textarea class="note" id="qcomment" rows="2" placeholder="Write a comment…" maxlength="500" aria-label="Comment text"></textarea>
      <button class="cmt-send" id="qcommentsend" aria-label="Post comment">Post</button>
    </div>
    <div class="cmt-count" id="qcommentcount">0 / 500</div>
    <div class="auditmeta">${res.by?`Inspected by ${res.by} · ${res.at} IST<br>`:""}Logged ${fid} · GPS ±1.2 m · Piling Rev B<br>Audit trail: ${res.by?"signed":"unsigned"} · device BAL-FIELD-03</div>
    <button class="export" id="qexport">Export table report — ${fid} T${t}</button>`;

  // mobile step header (only visible on narrow screens via CSS)
  const stepTitles={nav:"Select field & row",table:`${fid} · Row ${String(state.qcRow).padStart(2,"0")}`,checklist:`Table ${t} · checklist`,item:it.item};
  const stepBack={table:"nav",checklist:"table",item:"checklist"};
  const ms=state.mobileStep;
  const mstepHead=`<div class="mstep">
      ${ms!=="nav"?`<button class="mback" data-mback="${stepBack[ms]}">‹ Back</button>`:`<span class="mback ghost">QC</span>`}
      <div class="mtitle2">${stepTitles[ms]}</div>
      ${(ms==="checklist")?`<span class="mpill" style="--oc:${overallLabel[1]}">${overallLabel[0]}</span>`:`<span style="width:46px"></span>`}
    </div>`;

  return `<div class="qcgrid ${state.qcPanelCollapsed?'ipanel-collapsed':''}" data-step="${ms}">
    ${mstepHead}
    <div class="sidebar">${tree}</div>
    <div class="insp-mid">
      <div class="qcbar">
        <div class="crumb">
          <span class="cb">${fid}</span><span class="cs">/</span>
          <span class="cb">Row ${String(state.qcRow).padStart(2,"0")}</span><span class="cs">/</span>
          <span class="cb hl">Table ${t}</span>
        </div>
        <div class="tableoverall" style="--oc:${overallLabel[1]}">
          <span class="ostat">${overallLabel[0]}</span>
          <span class="oprog">${roll.done}/${roll.total} items · ${roll.pass}✓ ${roll.fail}✕</span>
          <div class="oactions">
            <button class="obtn mod-toggle ${(state.showModules||inMod)?'on':''}" data-modtoggle="1" title="Show module layout">[G] Modules</button>
            <button class="obtn pile-toggle ${(state.showPiles||inPile)?'on':''}" data-piletoggle="1" title="Show pile layout">[P] Piles</button>
            <button class="obtn ok" data-tableall="pass" title="Accept all items">Accept table</button>
            <button class="obtn no" data-tableall="fail" title="Fail table">Reject</button>
            <button class="obtn nu" data-tableall="clear" title="Reset table">Reset</button>
          </div>
        </div>
      </div>
      <div class="rowstrip" id="rowstrip">${chips}</div>
      ${(state.showModules||inMod)?`<div class="modwrap">
        <div class="modhdr">
          <div class="modttl">Table ${t} · <span class="mono">${tt.label}</span> — module layout</div>
          <div class="modsum">
            <span style="color:${C.grass}">${mr.acc}✓</span>
            <span style="color:${mr.fail?C.rust:C.dim}">${mr.fail}✕</span>
            <span style="color:${C.dim}">${mr.done}/${mr.n} modules</span>
          </div>
        </div>
        <div class="modgrid" id="modgrid">${modgrid}</div>
        <div class="modlegend">
          <span><i style="background:${C.grass}"></i>Accepted</span>
          <span><i style="background:${C.rust}"></i>Failed</span>
          <span><i style="background:${C.amber}"></i>Partial</span>
          <span><i style="background:var(--bg2);border:1px solid var(--line2)"></i>Not inspected</span>
          <span class="modhint">Click a module to inspect it · 3 × ${cols} portrait</span>
        </div>
      </div>`:``}
      ${inMod?`<div class="modscope">
          <span class="modscope-l">Inspecting <b>Module R${modRow}·C${modCol}</b> of Table ${t}</span>
          <div class="oactions">
            <button class="obtn ok" data-modall="pass">Accept module</button>
            <button class="obtn no" data-modall="fail">Fail module</button>
            <button class="obtn nu" data-modall="clear">Reset</button>
            <button class="obtn" data-modexit="1">← Whole table</button>
          </div>
        </div>`:``}
      ${(state.showPiles||inPile)?`<div class="modwrap pilewrap">
        <div class="modhdr">
          <div class="modttl">Table ${t} · <span class="mono">${tt.label}</span> — pile layout (N + S rows · ${perRow} per row)</div>
          <div class="modsum">
            <span style="color:${C.grass}">${pr.acc}✓</span>
            <span style="color:${pr.fail?C.rust:C.dim}">${pr.fail}✕</span>
            <span style="color:${C.dim}">${pr.done}/${pr.n} piles</span>
          </div>
        </div>
        <div class="pilegrid" id="pilegrid">${pilegrid}</div>
        <div class="modlegend">
          <span><i style="background:${C.grass}"></i>Accepted</span>
          <span><i style="background:${C.rust}"></i>Failed</span>
          <span><i style="background:${C.amber}"></i>Partial</span>
          <span><i style="background:var(--bg2);border:1px solid var(--line2)"></i>Not inspected</span>
          <span class="modhint">Click a pile to inspect it · North row + South row per drawing C100</span>
        </div>
      </div>`:``}
      ${inPile?`<div class="modscope">
          <span class="modscope-l">Inspecting <b>${pileName}</b> of Table ${t}</span>
          <div class="oactions">
            <button class="obtn ok" data-pileall="pass">Accept pile</button>
            <button class="obtn no" data-pileall="fail">Fail pile</button>
            <button class="obtn nu" data-pileall="clear">Reset</button>
            <button class="obtn" data-pileexit="1">← Whole table</button>
          </div>
        </div>`:``}
      <div class="checklist" id="checklist">${checklist}</div>
    </div>
    <div class="ipanel">
      <button class="ipanel-toggle" id="ipanel-toggle" title="Hide details panel">›</button>
      ${panel}
    </div>
    <button class="ipanel-floating" id="ipanel-floating" title="Show details panel">‹</button>
  </div>`;
}

/* -------- Station-scope QC (Stations -> Inverters) -------- */
function vQCStation(){
  const sid = state.qcStation || "ST1";
  const station = D.stations.find(s=>s.id===sid) || D.stations[0];
  const invIdx = state.qcInverter|0;
  const inv = getStationInv(station.id, invIdx);
  const ITP = D.stationItp;
  const sr = stationRoll(station);
  const ir = stationInvRoll(station.id, invIdx);

  // LEFT: list of stations + per-station inverter grid (expanded for active)
  let tree = `<div class="sbhead"><span>Stations</span><span class="mono">8 · ${D.stations.reduce((a,s)=>a+s.invCount,0)} inverters</span></div>`;
  D.stations.forEach(st=>{
    const open = st.id===station.id;
    const r = stationRoll(st);
    const dot = r.fail>0?C.rust:(r.pass>0?C.grass:C.dim2);
    tree += `<div class="catgroup">
      <div class="cathead navfield ${open?'open':''}" data-station="${st.id}">
        <span style="display:flex;align-items:center;gap:9px"><span class="sq" style="background:${dot}"></span>${esc(st.label)}</span>
        <span class="cc">${st.invCount} inv · ${r.done}/${r.total}</span>
      </div>`;
    if(open){
      // inverter grid (4 cols on desktop, 3 on mobile via CSS)
      tree += `<div class="rowlist" style="padding:8px 12px">
        <div class="invgrid">`;
      for(let i=0;i<st.invCount;i++){
        const rr = stationInvRoll(st.id,i);
        const bg = rr.overall==="pass"?C.grass:rr.overall==="fail"?C.rust:rr.overall==="partial"?C.amber:"var(--panel2)";
        const col = (rr.overall==="pass"||rr.overall==="fail"||rr.overall==="partial")?C.bg:"var(--dim)";
        const sel = i===invIdx;
        tree += `<button class="invcell ${sel?'sel':''}" data-inv="${i}" style="background:${bg};color:${col}" title="${invLabel(st.id,i)} · ${rr.overall}">${invShort(st.id,i)}</button>`;
      }
      tree += `</div></div>`;
    }
    tree += `</div>`;
  });

  // MIDDLE: header + checklist for selected inverter
  const overallLabel = ir.overall==="pass"?["ACCEPTED",C.grass]
    : ir.overall==="fail"?["REJECTED",C.rust]
    : ir.overall==="partial"?["IN PROGRESS",C.amber]:["NOT STARTED",C.dim2];

  // Counts and filter pills
  let _pass=0,_fail=0,_pending=0;
  ITP.forEach((it,i)=>{ const r=stationInvItemResult(station.id,invIdx,i); if(r.status==="pass")_pass++; else if(r.status==="fail")_fail++; else _pending++; });
  const filt = state.qcChecklistFilter || "all";
  const filterBar = `<div class="cl-filter">
    <button class="cl-pill ${filt==='all'?'sel':''}" data-clfilter="all">All <b>${ITP.length}</b></button>
    <button class="cl-pill ${filt==='pass'?'sel':''} pass" data-clfilter="pass">Pass <b>${_pass}</b></button>
    <button class="cl-pill ${filt==='fail'?'sel':''} fail" data-clfilter="fail">Fail <b>${_fail}</b></button>
    <button class="cl-pill ${filt==='pending'?'sel':''} pending" data-clfilter="pending">Open <b>${_pending}</b></button>
  </div>`;

  // Build checklist grouped by ITP cat
  const cats=[...new Set(ITP.map(it=>it.cat))];
  let checklist = filterBar;
  let anyShown = false;
  cats.forEach(cat=>{
    const code = ITP.find(it=>it.cat===cat).code;
    const items = ITP.map((it,i)=>({it,i})).filter(x=>{
      if(x.it.cat!==cat) return false;
      if(filt==="all") return true;
      return stationInvItemResult(station.id,invIdx,x.i).status===filt;
    });
    if(!items.length) return;
    anyShown = true;
    checklist += `<div class="clcat"><span>${esc(cat)}</span><span class="cc">${code}</span></div>`;
    items.forEach(({it,i})=>{
      const res = stationInvItemResult(station.id,invIdx,i);
      const st = STATUS[res.status];
      const sel = i===state.qcItem;
      checklist += `<div class="clrow ${sel?'sel':''}" data-stitem="${i}">
        <span class="clstat" style="background:${st.color}">${st.glyph||""}</span>
        <span class="clname">${esc(it.item)}<span class="clref">BAL-${code}-${String(i+1).padStart(3,"0")}</span></span>
        <span class="clbtns">
          <button class="clmini ${res.status==='pass'?'pass':''}" data-stset="${i}:pass" aria-label="Pass">✓</button>
          <button class="clmini ${res.status==='fail'?'fail':''}" data-stset="${i}:fail" aria-label="Fail">✕</button>
        </span>
      </div>`;
    });
  });
  if(!anyShown){
    const lbl = filt==="pass"?"passed":filt==="fail"?"failed":"open";
    checklist += `<div class="empty-state"><div class="es-ico">${filt==="fail"?"✓":"○"}</div><div class="es-t">No ${lbl} items</div><div class="es-s">Switch filter to see other items.</div></div>`;
  }

  // RIGHT: selected item detail
  if(state.qcItem>=ITP.length) state.qcItem=0;
  const it = ITP[state.qcItem];
  const res = stationInvItemResult(station.id, invIdx, state.qcItem);
  const photos = res.photos||[];
  const comments = res.comments||[];
  const panel = `
    <div class="lbl">${it.code}-${String(state.qcItem+1).padStart(3,"0")} · ${esc(invLabel(station.id,invIdx))}</div>
    <div class="iname">${esc(it.item)}</div>
    <div class="field-l">Acceptance criteria</div>
    <div class="crit">${esc(it.crit||"—")}</div>
    <div class="field-l">Result</div>
    <div class="resultrow">
      ${["pass","fail"].map(s=>{const on=res.status===s,c=STATUS[s].color;
        return `<button class="rbtn" data-stset="${state.qcItem}:${s}" style="background:${on?c:'var(--bg2)'};color:${on?C.bg:c};border:1px solid ${c}">${s==="fail"?"✕ Fail / raise NCR":"✓ Pass"}</button>`;}).join("")}
    </div>
    <div class="field-l">Photo evidence ${photos.length?`· ${photos.length}`:""}</div>
    <div class="gallery">
      ${photos.map(p=>`<div class="thumb" data-stviewphoto="${p.id}">
        <img src="${p.thumb}" alt="${esc(p.name||"photo")}"/>
        <button class="thdel" data-stdelphoto="${p.id}" title="Remove">✕</button>
      </div>`).join("")}
      <button class="addphoto" id="stAddPhoto"><span class="pi-cam">+</span><span>Add photo</span></button>
      <input type="file" id="stPhotoInput" accept="image/*" capture="environment" multiple style="display:none"/>
    </div>
    <div class="field-l">Comments ${comments.length?`· ${comments.length}`:""}</div>
    <div class="thread">
      ${comments.length?comments.map(c=>`
        <div class="cmt"><div class="cmt-h"><span class="cmt-by">${esc(c.by)}</span><span class="cmt-at">${fmtDate(c.at)} · ${fmtTime(c.at)}</span>
          <button class="cmt-del" data-stdelcmt="${c.id}">✕</button></div>
          <div class="cmt-tx">${esc(c.text)}</div></div>`).join("")
        :`<div class="cmt-empty">No comments yet.</div>`}
    </div>
    <div class="cmt-compose">
      <textarea class="note" id="stComment" rows="2" placeholder="Write a comment…" maxlength="500"></textarea>
      <button class="cmt-send" id="stCommentSend">Post</button>
    </div>
    <div class="auditmeta">${res.by?`Inspected by ${esc(res.by)} · ${esc(res.at)}<br>`:""}Station: ${esc(station.label)} · Pad ${station.padHeight} m · ${esc(station.area)}<br>Inverter ${invIdx+1} of ${station.invCount}</div>
    <button class="export" id="qexport-station">Export inverter report — ${invLabel(station.id,invIdx)}</button>`;

  // Mobile step header
  const ms = state.mobileStep || "nav";
  const stationStepTitles = {nav:"Select station & inverter", checklist:`${invLabel(station.id,invIdx)} · checklist`, item:it.item};
  const stationStepBack = {checklist:"nav", item:"checklist"};
  const stMs = (ms==="nav"||ms==="checklist"||ms==="item") ? ms : "nav";
  const mstepHead = `<div class="mstep">
      ${stMs!=="nav"?`<button class="mback" data-mback="${stationStepBack[stMs]}">‹ Back</button>`:`<span class="mback ghost">QC</span>`}
      <div class="mtitle2">${esc(stationStepTitles[stMs]||"")}</div>
      ${stMs==="checklist"?`<span class="mpill" style="--oc:${overallLabel[1]}">${overallLabel[0]}</span>`:`<span style="width:46px"></span>`}
    </div>`;

  return `<div class="qcgrid ${state.qcPanelCollapsed?'ipanel-collapsed':''}" data-step="${stMs}">
    ${mstepHead}
    <div class="sidebar">${tree}</div>
    <div class="insp-mid">
      <div class="qcbar">
        <div class="crumb">
          <span class="cb">${esc(station.label)}</span><span class="cs">/</span>
          <span class="cb hl">${invShort(station.id,invIdx)}</span>
        </div>
        <div class="tableoverall" style="--oc:${overallLabel[1]}">
          <span class="ostat">${overallLabel[0]}</span>
          <span class="oprog">${ir.done}/${ir.total} items · ${ir.pass}✓ ${ir.fail}✕</span>
          <div class="oactions">
            <button class="obtn ok" data-stinvall="pass">Accept inverter</button>
            <button class="obtn no" data-stinvall="fail">Reject</button>
            <button class="obtn nu" data-stinvall="clear">Reset</button>
          </div>
        </div>
      </div>
      <div class="checklist" id="checklist">${checklist}</div>
    </div>
    <div class="ipanel">
      <button class="ipanel-toggle" id="ipanel-toggle" title="Hide details panel">›</button>
      ${panel}
    </div>
    <button class="ipanel-floating" id="ipanel-floating" title="Show details panel">‹</button>
  </div>`;
}

/* -------- Site-scope QC (single page, no per-table drill) -------- */
function vQCSite(){
  const ITP = D.siteItp;
  const sr = siteRoll();

  // Counts + filter pills
  let _pass=0,_fail=0,_pending=0;
  ITP.forEach((it,i)=>{ const r=siteItemResult(i); if(r.status==="pass")_pass++; else if(r.status==="fail")_fail++; else _pending++; });
  const filt = state.qcChecklistFilter || "all";
  const filterBar = `<div class="cl-filter">
    <button class="cl-pill ${filt==='all'?'sel':''}" data-clfilter="all">All <b>${ITP.length}</b></button>
    <button class="cl-pill ${filt==='pass'?'sel':''} pass" data-clfilter="pass">Pass <b>${_pass}</b></button>
    <button class="cl-pill ${filt==='fail'?'sel':''} fail" data-clfilter="fail">Fail <b>${_fail}</b></button>
    <button class="cl-pill ${filt==='pending'?'sel':''} pending" data-clfilter="pending">Open <b>${_pending}</b></button>
  </div>`;

  const cats=[...new Set(ITP.map(it=>it.cat))];
  let checklist = filterBar;
  let anyShown = false;
  cats.forEach(cat=>{
    const code = ITP.find(it=>it.cat===cat).code;
    const items = ITP.map((it,i)=>({it,i})).filter(x=>{
      if(x.it.cat!==cat) return false;
      if(filt==="all") return true;
      return siteItemResult(x.i).status===filt;
    });
    if(!items.length) return;
    anyShown = true;
    checklist += `<div class="clcat"><span>${esc(cat)}</span><span class="cc">${code}</span></div>`;
    items.forEach(({it,i})=>{
      const res = siteItemResult(i);
      const st = STATUS[res.status];
      const sel = i===state.qcItem;
      checklist += `<div class="clrow ${sel?'sel':''}" data-siteitem="${i}">
        <span class="clstat" style="background:${st.color}">${st.glyph||""}</span>
        <span class="clname">${esc(it.item)}<span class="clref">BAL-${code}-${String(i+1).padStart(3,"0")}</span></span>
        <span class="clbtns">
          <button class="clmini ${res.status==='pass'?'pass':''}" data-siteset="${i}:pass" aria-label="Pass">✓</button>
          <button class="clmini ${res.status==='fail'?'fail':''}" data-siteset="${i}:fail" aria-label="Fail">✕</button>
        </span>
      </div>`;
    });
  });
  if(!anyShown){
    const lbl = filt==="pass"?"passed":filt==="fail"?"failed":"open";
    checklist += `<div class="empty-state"><div class="es-ico">${filt==="fail"?"✓":"○"}</div><div class="es-t">No ${lbl} items</div><div class="es-s">Switch filter to see other items.</div></div>`;
  }

  // Right panel
  if(state.qcItem>=ITP.length) state.qcItem=0;
  const it = ITP[state.qcItem];
  const res = siteItemResult(state.qcItem);
  const photos = res.photos||[];
  const comments = res.comments||[];
  const panel = `
    <div class="lbl">${it.code}-${String(state.qcItem+1).padStart(3,"0")} · Site-wide</div>
    <div class="iname">${esc(it.item)}</div>
    <div class="field-l">Acceptance criteria</div>
    <div class="crit">${esc(it.crit||"—")}</div>
    <div class="field-l">Result</div>
    <div class="resultrow">
      ${["pass","fail"].map(s=>{const on=res.status===s,c=STATUS[s].color;
        return `<button class="rbtn" data-siteset="${state.qcItem}:${s}" style="background:${on?c:'var(--bg2)'};color:${on?C.bg:c};border:1px solid ${c}">${s==="fail"?"✕ Fail / raise NCR":"✓ Pass"}</button>`;}).join("")}
    </div>
    <div class="field-l">Photo evidence ${photos.length?`· ${photos.length}`:""}</div>
    <div class="gallery">
      ${photos.map(p=>`<div class="thumb" data-siteviewphoto="${p.id}">
        <img src="${p.thumb}" alt="${esc(p.name||"photo")}"/>
        <button class="thdel" data-sitedelphoto="${p.id}" title="Remove">✕</button>
      </div>`).join("")}
      <button class="addphoto" id="siteAddPhoto"><span class="pi-cam">+</span><span>Add photo</span></button>
      <input type="file" id="sitePhotoInput" accept="image/*" capture="environment" multiple style="display:none"/>
    </div>
    <div class="field-l">Comments ${comments.length?`· ${comments.length}`:""}</div>
    <div class="thread">
      ${comments.length?comments.map(c=>`
        <div class="cmt"><div class="cmt-h"><span class="cmt-by">${esc(c.by)}</span><span class="cmt-at">${fmtDate(c.at)} · ${fmtTime(c.at)}</span>
          <button class="cmt-del" data-sitedelcmt="${c.id}">✕</button></div>
          <div class="cmt-tx">${esc(c.text)}</div></div>`).join("")
        :`<div class="cmt-empty">No comments yet.</div>`}
    </div>
    <div class="cmt-compose">
      <textarea class="note" id="siteComment" rows="2" placeholder="Write a comment…" maxlength="500"></textarea>
      <button class="cmt-send" id="siteCommentSend">Post</button>
    </div>
    <div class="auditmeta">${res.by?`Inspected by ${esc(res.by)} · ${esc(res.at)}<br>`:""}Scope: site-wide — no per-table assignment<br>Civil drawings: 24278-MWP-06-00-DR-C-1000 series</div>
    <button class="export" id="qexport-site">Export site-wide acceptance report</button>`;

  // Site has no left navigator — use a stat panel instead
  const overallLabel = sr.overall==="pass"?["ACCEPTED",C.grass]
    : sr.overall==="fail"?["REJECTED",C.rust]
    : sr.overall==="partial"?["IN PROGRESS",C.amber]:["NOT STARTED",C.dim2];

  const stat = `<div class="sbhead"><span>Site-wide work</span><span class="mono">${ITP.length} items</span></div>
    <div style="padding:14px 16px;color:var(--dim);font-size:11.5px;line-height:1.6">
      Civil and infrastructure work that lives at <b style="color:var(--ink)">project level</b>, not per-table.
      <br><br>
      Roads, fences, crossings, drainage, compound and substation boundary apply to the whole site.
      They share inspection results across all fields.
    </div>
    <div style="padding:0 16px 14px">
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;font-size:11px">
        <div style="padding:8px 10px;background:var(--panel2);border-radius:3px"><div style="color:var(--dim2);font-size:9px;letter-spacing:1px;margin-bottom:2px">PASS</div><div style="color:${C.grass};font-weight:600;font-size:15px">${sr.pass}</div></div>
        <div style="padding:8px 10px;background:var(--panel2);border-radius:3px"><div style="color:var(--dim2);font-size:9px;letter-spacing:1px;margin-bottom:2px">FAIL</div><div style="color:${C.rust};font-weight:600;font-size:15px">${sr.fail}</div></div>
        <div style="padding:8px 10px;background:var(--panel2);border-radius:3px"><div style="color:var(--dim2);font-size:9px;letter-spacing:1px;margin-bottom:2px">OPEN</div><div style="color:${C.amber};font-weight:600;font-size:15px">${sr.total-sr.done}</div></div>
        <div style="padding:8px 10px;background:var(--panel2);border-radius:3px"><div style="color:var(--dim2);font-size:9px;letter-spacing:1px;margin-bottom:2px">PROGRESS</div><div style="color:var(--ink);font-weight:600;font-size:15px">${sr.rate}%</div></div>
      </div>
    </div>`;

  // Mobile step header — site has no nav level; default to checklist
  const ms = state.mobileStep || "checklist";
  const siteStMs = (ms==="checklist"||ms==="item") ? ms : "checklist";
  const siteStepTitles = {checklist:"Site-wide checklist", item:it.item};
  const mstepHead = `<div class="mstep">
      ${siteStMs==="item"?`<button class="mback" data-mback="checklist">‹ Back</button>`:`<span class="mback ghost">SITE</span>`}
      <div class="mtitle2">${esc(siteStepTitles[siteStMs]||"")}</div>
      ${siteStMs==="checklist"?`<span class="mpill" style="--oc:${overallLabel[1]}">${overallLabel[0]}</span>`:`<span style="width:46px"></span>`}
    </div>`;

  return `<div class="qcgrid ${state.qcPanelCollapsed?'ipanel-collapsed':''}" data-step="${siteStMs}">
    ${mstepHead}
    <div class="sidebar">${stat}</div>
    <div class="insp-mid">
      <div class="qcbar">
        <div class="crumb"><span class="cb hl">Site-wide civil & infrastructure</span></div>
        <div class="tableoverall" style="--oc:${overallLabel[1]}">
          <span class="ostat">${overallLabel[0]}</span>
          <span class="oprog">${sr.done}/${sr.total} items · ${sr.pass}✓ ${sr.fail}✕</span>
        </div>
      </div>
      <div class="checklist" id="checklist">${checklist}</div>
    </div>
    <div class="ipanel">
      <button class="ipanel-toggle" id="ipanel-toggle" title="Hide details panel">›</button>
      ${panel}
    </div>
    <button class="ipanel-floating" id="ipanel-floating" title="Show details panel">‹</button>
  </div>`;
}

/* ---------- render / events ---------- */
function render(){
  // Component mode: React owns the view layer. The engine stays a headless
  // domain core; render() just signals React to re-read state.
  if (typeof window!=="undefined" && window.__gpComponentMode){
    if (typeof window.__gpNotify==="function") window.__gpNotify();
    return;
  }
  document.getElementById("app").innerHTML = chrome();
  document.getElementById("v-overview").innerHTML  = vOverview();
  document.getElementById("v-rfi").innerHTML       = vRFI();
  document.getElementById("v-sitemap").innerHTML   = vSiteMap();
  document.getElementById("v-qc").innerHTML        = vQC();
  document.getElementById("v-punch").innerHTML     = vPunch();
  document.getElementById("v-tdd").innerHTML       = vTDD();
  wire();
}
function rerenderView(){
  if(state.view==="sitemap")  document.getElementById("v-sitemap").innerHTML=vSiteMap();
  if(state.view==="qc")       document.getElementById("v-qc").innerHTML=vQC();
  if(state.view==="overview") document.getElementById("v-overview").innerHTML=vOverview();
  if(state.view==="rfi")      document.getElementById("v-rfi").innerHTML=vRFI();
  if(state.view==="punch")    document.getElementById("v-punch").innerHTML=vPunch();
  if(state.view==="tdd")      document.getElementById("v-tdd").innerHTML=vTDD();
  wire();
  refreshBadges();
}
function setView(v){
  // Role-gate: TDD reviewer can't access QC/Controls/SiteMap
  if(currentRole==="tdd"&&["qc","sitemap","punch","docs","rfi"].includes(v)) return;
  // Auditor can't edit but can view all
  state.view=v;
  document.querySelectorAll(".tab").forEach(t=>t.classList.toggle("active",t.dataset.view===v));
  document.querySelectorAll(".view").forEach(el=>el.classList.remove("active"));
  const el=document.getElementById("v-"+v); if(!el) return;
  el.classList.add("active");
  const fn={qc:vQC,sitemap:vSiteMap,overview:vOverview,rfi:vRFI,punch:vPunch,tdd:vTDD};
  if(fn[v]){ el.innerHTML=fn[v](); wire(); }
}
function nowHM(){const n=new Date();return `${String(n.getHours()).padStart(2,"0")}:${String(n.getMinutes()).padStart(2,"0")}`;}
function setItemStatus(fid,t,itemId,s){
  const ins=getInsp(fid,t);
  const cur=ins.items[itemId]||{status:"pending",note:"",photo:false,by:"",at:"",ncr:""};
  if(s==="clear"){ delete ins.items[itemId]; return; }
  cur.status=s; cur.by=cur.by||"Catalin Radu"; cur.at=cur.at||nowHM();
  if(s==="fail"&&!cur.ncr) cur.ncr=ncrRef(ncrSeq++);
  if(s==="pass") cur.ncr="";
  ins.items[itemId]=cur;
}
function setTableAll(fid,t,s){
  const ins=getInsp(fid,t);
  // Resolve the table type so we know how many modules and piles to update.
  const f=D.fields.find(x=>x.id===fid)||D.fields[0];
  const tt=D.tableTypes[tableTypeFor(f,t)];
  const moduleCount = tt.rows * tt.cols;          // e.g. 3 * 27 = 81 modules
  const pileCount   = 2 * tt.pilesPerRow;          // north + south rows

  if(s==="clear"){
    // Reset the table-level checklist
    ins.items={};
    // Also clear module-level and pile-level acceptance for this table
    for(let m=0; m<moduleCount; m++){
      const k=mkey(fid,t,m); if(inspections[k]) delete inspections[k];
    }
    for(let p=0; p<pileCount; p++){
      const k=pkey(fid,t,p); if(inspections[k]) delete inspections[k];
    }
    return;
  }
  // Pass/fail: update the table-level ITP items first
  D.itp.forEach((_,i)=>setItemStatus(fid,t,i,s));

  // Cascade to modules. Failed items keep their fail status (so NCRs are preserved);
  // pending items take the new status. This matches inspector intuition: accepting
  // a table means "everything pending is fine"; failed items must be addressed
  // through their own NCR close-out workflow.
  for(let m=0; m<moduleCount; m++){
    const k=mkey(fid,t,m);
    const mod=inspections[k];
    // Skip modules that already have an explicit fail — don't silently override
    if(mod && mod.status==="fail") continue;
    // Either no record yet or pending/partial — set the cascaded status
    const target = inspections[k] = inspections[k] || {status:"pending",comments:[],photos:[],items:{},by:"",at:""};
    target.status = s;
    target.by = target.by || (typeof Store!=="undefined" && Store._author ? Store._author() : "Catalin Radu");
    target.at = target.at || (typeof Store!=="undefined" && Store._hm ? Store._hm(Store._now()) : "");
  }
  for(let p=0; p<pileCount; p++){
    const k=pkey(fid,t,p);
    const pl=inspections[k];
    if(pl && pl.status==="fail") continue;
    const target = inspections[k] = inspections[k] || {status:"pending",comments:[],photos:[],items:{},by:"",at:""};
    target.status = s;
    target.by = target.by || (typeof Store!=="undefined" && Store._author ? Store._author() : "Catalin Radu");
    target.at = target.at || (typeof Store!=="undefined" && Store._hm ? Store._hm(Store._now()) : "");
  }
  // TODO backend: PUT /inspections/{fid}/{t}/all { status: s }
  // The server should perform the same cascade (with the failed-items preserved
  // rule) and return the count of modules and piles affected.
}
function updItem(fid,t,itemId,patch){
  const ins=getInsp(fid,t);
  const cur=ins.items[itemId]||{status:"pending",note:"",photo:false,by:"",at:"",ncr:""};
  Object.assign(cur,patch); ins.items[itemId]=cur;
}
function rerenderQC(){
  document.getElementById("v-qc").innerHTML=vQC();
  // Inject tablet slide-over backdrop. The backdrop only renders visually on
  // tablet viewports (CSS controls display); on phone and desktop it has no effect.
  const grid = document.querySelector("#v-qc .qcgrid");
  if(grid && !grid.querySelector(".qc-backdrop")){
    const bd = document.createElement("div");
    bd.className = "qc-backdrop";
    bd.setAttribute("aria-hidden","true");
    bd.onclick = ()=>{ state.qcPanelCollapsed = true; rerenderQC(); };
    grid.appendChild(bd);
  }
  wire();
  refreshBadges();
}
function rerenderRFI(){ document.getElementById("v-rfi").innerHTML=vRFI(); wire(); refreshBadges(); }

function exportReport(){
  const f=state.qcField, t=state.qcTable;
  const roll=tableRoll(f,t);
  const overall = roll.overall==="pass"?"ACCEPTED":roll.overall==="fail"?"REJECTED":roll.overall==="partial"?"IN PROGRESS":"NOT STARTED";
  const overallColor = roll.overall==="pass"?"#2C9B73":roll.overall==="fail"?"#B84545":roll.overall==="partial"?"#B8862B":"#637588";
  const today=new Date().toLocaleString(undefined,{day:"2-digit",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"});

  const cats=[...new Set(D.tableItp.map(it=>it.cat))];
  let body=_buildReportBody(cats, D.tableItp, (i)=>itemResult(f,t,i));

  const summaryCards = `
    <div><div class="k">Project</div><div class="v">${esc(D.project.name)}</div></div>
    <div><div class="k">Client</div><div class="v">${esc(D.project.client)}</div></div>
    <div><div class="k">EPC</div><div class="v">${esc(D.project.epc)}</div></div>
    <div><div class="k">Status</div><div class="v status">${overall}</div></div>
    <div><div class="k">Location</div><div class="v">${esc(D.project.location)}</div></div>
    <div><div class="k">Coordinates</div><div class="v mono">${esc(D.project.gps)}</div></div>
    <div><div class="k">ITP</div><div class="v">ITP-BAL · Rev B</div></div>
    <div><div class="k">Items closed</div><div class="v">${roll.pass}✓ &nbsp; ${roll.fail}✕ &nbsp; ${roll.done}/${roll.total}</div></div>`;

  const html = _buildReportShell({
    title: `Ballyroe ${f} T${t} — Acceptance Report`,
    docTitle: "Table Acceptance Report",
    docSub: `${esc(f)} · Row ${String(state.qcRow).padStart(2,"0")} · Table ${t} &nbsp;|&nbsp; ${esc(today)}`,
    overallColor, summaryCards, body, today
  });
  _openReportWindow(html);
}

/* Per-field acceptance report — aggregates every table in a field -------- */
function exportFieldReport(fid){
  const f = D.fields.find(x=>x.id===fid) || D.fields[0];
  const today = new Date().toLocaleString(undefined,{day:"2-digit",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"});
  let acc=0,fail=0,part=0,insp=0,doneItems=0,passItems=0,failItems=0;
  const rows=[];
  for(let t=1;t<=f.tables;t++){
    const eff = tableEffectiveStatus(f.id,t).status;
    const roll = tableRoll(f.id,t);
    if(eff==="pass")acc++; else if(eff==="fail")fail++; else if(eff==="partial")part++;
    if(roll.done>0) insp++;
    doneItems+=roll.done; passItems+=roll.pass; failItems+=roll.fail;
    const ty = D.tableTypes[tableTypeFor(f,t)].label;
    const lbl = eff==="pass"?"ACCEPTED":eff==="fail"?"REJECTED":eff==="partial"?"IN PROGRESS":roll.done>0?"PARTIAL":"NOT STARTED";
    // Issue #6: keep the report focused on work that has actually started —
    // accepted / rejected / in-progress / partial tables. Un-started tables
    // are summarised in a single footnote instead of padding the table list.
    if(lbl!=="NOT STARTED") rows.push({t,ty,lbl,roll});
  }
  const notStarted = f.tables - rows.length;
  // Field NCRs / failed items (table scope) via the punch list
  const ncrs = punchItems().filter(p=>p.workScope==="table" && p.fid===f.id);
  const overall = fail>0?"REJECTED":(acc===f.tables&&f.tables>0?"ACCEPTED":insp>0?"IN PROGRESS":"NOT STARTED");
  const overallColor = fail>0?"#B84545":(acc===f.tables&&f.tables>0?"#2C9B73":insp>0?"#B8862B":"#637588");
  const rate = doneItems?Math.round(passItems/doneItems*100):0;

  const summaryCards = `
    <div><div class="k">Project</div><div class="v">${esc(D.project.name)}</div></div>
    <div><div class="k">Field</div><div class="v">${esc(f.id)} · ${f.mwp} MWp</div></div>
    <div><div class="k">Client / EPC</div><div class="v">${esc(D.project.client)} / ${esc(D.project.epc)}</div></div>
    <div><div class="k">Status</div><div class="v status">${overall}</div></div>
    <div><div class="k">Tables</div><div class="v">${acc}✓ &nbsp; ${fail}✕ &nbsp; ${part}◐ &nbsp; of ${f.tables}</div></div>
    <div><div class="k">Inspected</div><div class="v">${insp}/${f.tables} tables · ${doneItems} items</div></div>
    <div><div class="k">Open NCRs</div><div class="v">${ncrs.filter(n=>n.ncr).length}</div></div>
    <div><div class="k">Acceptance</div><div class="v">${rate}%</div></div>`;

  let body = `<h3>Tables — ${esc(f.id)}</h3>
    <table><thead><tr><th class="n">Table</th><th>Type</th><th>Status</th><th class="n">Items</th><th class="n">Pass</th><th class="n">Fail</th></tr></thead><tbody>`;
  rows.forEach(r=>{
    const cls = r.lbl==="ACCEPTED"?"pass":r.lbl==="REJECTED"?"fail":"pending";
    body += `<tr class="${cls}"><td class="n">T${r.t}</td><td>${esc(r.ty)}</td><td class="res">${r.lbl}</td>
      <td class="n">${r.roll.done}/${r.roll.total}</td><td class="n">${r.roll.pass}</td><td class="n">${r.roll.fail}</td></tr>`;
  });
  if(!rows.length) body += `<tr class="pending"><td colspan="6" style="text-align:center;color:#637588">No tables inspected yet in this field.</td></tr>`;
  body += `</tbody></table>`;
  if(notStarted>0) body += `<p style="font-size:9px;color:#637588;margin:2px 0 12px">+ ${notStarted} table${notStarted===1?"":"s"} not yet started (omitted).</p>`;
  if(ncrs.length){
    body += `<h3>Non-conformances</h3>
      <table><thead><tr><th>NCR</th><th>Location</th><th>ITP Ref</th><th>Inspection Item</th><th>By</th><th>Note</th></tr></thead><tbody>`;
    ncrs.forEach(n=>{
      body += `<tr class="fail"><td class="mono">${esc(n.ncr||"—")}</td><td class="mono">${esc(n.loc)}</td>
        <td class="mono">${esc(n.itp)}</td><td>${esc(n.item)}</td><td>${esc(n.by||"—")}</td><td class="note">${esc(n.comment||"")}</td></tr>`;
    });
    body += `</tbody></table>`;
  }

  const html = _buildReportShell({
    title: `Ballyroe ${f.id} — Field Acceptance Report`,
    docTitle: "Field Acceptance Report",
    docSub: `${esc(f.id)} · ${f.tables} tables &nbsp;|&nbsp; ${esc(today)}`,
    overallColor, summaryCards, body, today
  });
  _openReportWindow(html);
}

/* Shared report-shell builders ----------------------------------------- */
function _buildReportBody(cats, itp, lookupRes){
  let body="";
  // Continuous 1..N row counter across the whole report. The "#" column used
  // to print the GLOBAL itp index (i+1); because items are grouped by category
  // that made the numbers jump within a block (…9, 10, 14…) and read as
  // missing rows (issue #4). A single running counter keeps it sequential and
  // gap-free. The ITP Ref column still carries the stable per-item code/index.
  let n=0;
  cats.forEach(cat=>{
    body+=`<h3>${esc(cat)}</h3>
      <table><thead><tr><th class="n">#</th><th>ITP Ref</th><th>Inspection Item</th><th>Result</th><th>NCR</th><th>Note</th><th class="ph">Photos</th><th>By</th><th class="t">Time</th></tr></thead><tbody>`;
    itp.forEach((it,i)=>{
      if(it.cat!==cat) return;
      const r=lookupRes(i);
      const note=(r.comments&&r.comments.length)?r.comments[r.comments.length-1].text:"";
      const cls=r.status==="pass"?"pass":r.status==="fail"?"fail":"pending";
      const rlbl=r.status==="pass"?"PASS":r.status==="fail"?"FAIL":"—";
      body+=`<tr class="${cls}">
        <td class="n">${++n}</td>
        <td class="mono">BAL-${it.code}-${String(i+1).padStart(3,"0")}</td>
        <td>${esc(it.item)}</td>
        <td class="res">${rlbl}</td>
        <td class="mono">${esc(r.ncr||"—")}</td>
        <td class="note">${esc(note)}</td>
        <td class="ph">${(r.photos||[]).length}</td>
        <td>${esc(r.by||"—")}</td>
        <td class="t">${esc(r.at||"—")}</td>
      </tr>`;
    });
    body+=`</tbody></table>`;
  });
  return body;
}

function _buildReportShell({title, docTitle, docSub, overallColor, summaryCards, body, today, drawingRef}){
  return `<!doctype html><html><head><meta charset="utf-8"><title>${esc(title)}</title>
  <style>
    @page{size:A4 landscape;margin:14mm}
    *{box-sizing:border-box}
    body{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif;color:#13212E;font-size:10.5px;line-height:1.4;margin:0;padding:18px 22px;background:#fff}
    .header{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:3px solid #2C9B73;padding-bottom:10px;margin-bottom:14px}
    .brand{font-family:Georgia,serif;font-size:20px;font-weight:700;color:#13212E;letter-spacing:.3px}
    .brand small{display:block;font-family:-apple-system,sans-serif;font-size:9px;font-weight:600;color:#5A6B7A;letter-spacing:1.4px;margin-top:2px}
    .doctitle{text-align:right}
    .doctitle h1{margin:0;font-family:Georgia,serif;font-size:15px;font-weight:600}
    .doctitle .meta{font-size:9.5px;color:#5A6B7A;margin-top:4px;font-family:'Courier New',monospace}
    .summary{display:grid;grid-template-columns:repeat(4,1fr);gap:12px;background:#F5F6F8;padding:11px 13px;border-radius:3px;margin-bottom:14px;border-left:3px solid #2C9B73}
    .summary .k{font-size:8.5px;text-transform:uppercase;letter-spacing:1px;color:#5A6B7A;font-weight:600;margin-bottom:2px}
    .summary .v{font-size:11.5px;font-weight:600;color:#13212E}
    .summary .v.status{color:${overallColor}}
    h3{font-family:Georgia,serif;font-size:13px;color:#13212E;margin:16px 0 6px;padding-bottom:4px;border-bottom:1px solid #D6DEE5}
    table{width:100%;border-collapse:collapse;margin-bottom:8px}
    thead th{background:#F5F6F8;font-size:9px;text-transform:uppercase;letter-spacing:.6px;color:#5A6B7A;font-weight:700;text-align:left;padding:6px 7px;border-bottom:1.5px solid #13212E}
    tbody td{padding:6px 7px;border-bottom:1px solid #E8ECEF;vertical-align:top}
    tbody tr.fail{background:#FDF2F2}
    tbody tr.fail td.res{color:#B84545;font-weight:700}
    tbody tr.pass td.res{color:#2C9B73;font-weight:700}
    tbody tr.pending td.res{color:#637588}
    td.n,td.ph{text-align:center;font-family:'Courier New',monospace;color:#637588}
    td.mono,.mono{font-family:'Courier New',monospace;font-size:9.5px}
    td.note{color:#5A6B7A;font-style:italic;max-width:200px}
    td.t{font-family:'Courier New',monospace;color:#637588}
    .foot{margin-top:18px;padding-top:10px;border-top:1px solid #D6DEE5;font-size:9px;color:#5A6B7A;display:flex;justify-content:space-between}
    .signatures{display:grid;grid-template-columns:1fr 1fr 1fr;gap:24px;margin-top:24px;padding-top:18px;border-top:1px solid #D6DEE5}
    .sigblock{border-top:1px solid #13212E;padding-top:6px;font-size:9.5px}
    .sigblock .role{font-size:8.5px;text-transform:uppercase;letter-spacing:1px;color:#5A6B7A;font-weight:600;margin-bottom:3px}
    .drawingref{margin:8px 0 14px;padding:8px 12px;background:#FFFBEE;border-left:3px solid #B8862B;font-size:9.5px;color:#7A5A1E;font-family:'Courier New',monospace}
    @media print{
      .noprint{display:none}
      body{padding:0}
      tbody tr{page-break-inside:avoid}
      h3{page-break-after:avoid}
    }
    .actions{position:fixed;top:12px;right:12px;display:flex;gap:8px;z-index:100}
    .actions button{padding:8px 16px;background:#2C9B73;color:#fff;border:none;border-radius:3px;cursor:pointer;font-weight:600;font-size:12px;font-family:inherit}
    .actions button.alt{background:#fff;color:#13212E;border:1px solid #D6DEE5}
  </style></head>
  <body>
    <div class="actions noprint">
      <button onclick="window.print()">Save as PDF / Print</button>
      <button class="alt" onclick="window.close()">Close</button>
    </div>
    <div class="header">
      <div class="brand">GridProof<small>powered by TerraTrace · INSPECTION REPORT</small></div>
      <div class="doctitle">
        <h1>${esc(docTitle)}</h1>
        <div class="meta">${docSub}</div>
      </div>
    </div>
    <div class="summary">${summaryCards}</div>
    ${drawingRef?`<div class="drawingref">Reference drawings: ${esc(drawingRef)}</div>`:""}
    ${body}
    <div class="signatures">
      <div class="sigblock"><div class="role">Inspected by</div>${esc(D.roles[currentRole].operator)} · ${esc(D.roles[currentRole].label)}<br><span style="color:#637588;font-size:9px">Signature / Date</span></div>
      <div class="sigblock"><div class="role">QC Manager review</div>&nbsp;<br><span style="color:#637588;font-size:9px">Signature / Date</span></div>
      <div class="sigblock"><div class="role">Client / Auditor</div>&nbsp;<br><span style="color:#637588;font-size:9px">Signature / Date</span></div>
    </div>
    <div class="foot">
      <span>Ballyroe Solar Farm · Generated ${esc(today)}</span>
      <span>GridProof · powered by TerraTrace · Confidential</span>
    </div>
  </body></html>`;
}

function _openReportWindow(html){
  const w=window.open("","_blank");
  if(!w){ toast("Please allow pop-ups to export the PDF","warn"); return; }
  w.document.open(); w.document.write(html); w.document.close();
  toast("Report opened in new tab — use Save as PDF","success");
}

/* Station inverter acceptance report ----------------------------------- */
function exportStationReport(){
  const sid = state.qcStation || "ST1";
  const station = D.stations.find(s=>s.id===sid) || D.stations[0];
  const invIdx = state.qcInverter|0;
  const ir = stationInvRoll(station.id, invIdx);
  const overall = ir.overall==="pass"?"ACCEPTED":ir.overall==="fail"?"REJECTED":ir.overall==="partial"?"IN PROGRESS":"NOT STARTED";
  const overallColor = ir.overall==="pass"?"#2C9B73":ir.overall==="fail"?"#B84545":ir.overall==="partial"?"#B8862B":"#637588";
  const today=new Date().toLocaleString(undefined,{day:"2-digit",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"});

  const cats=[...new Set(D.stationItp.map(it=>it.cat))];
  const body=_buildReportBody(cats, D.stationItp, (i)=>stationInvItemResult(station.id, invIdx, i));

  const summaryCards = `
    <div><div class="k">Project</div><div class="v">${esc(D.project.name)}</div></div>
    <div><div class="k">Client</div><div class="v">${esc(D.project.client)}</div></div>
    <div><div class="k">Station</div><div class="v">${esc(station.label)}</div></div>
    <div><div class="k">Status</div><div class="v status">${overall}</div></div>
    <div><div class="k">Inverter</div><div class="v">${invShort(station.id, invIdx)} of ${station.invCount}</div></div>
    <div><div class="k">Pad height</div><div class="v">${station.padHeight} m</div></div>
    <div><div class="k">Area</div><div class="v">${esc(station.area)}</div></div>
    <div><div class="k">Items closed</div><div class="v">${ir.pass}✓ &nbsp; ${ir.fail}✕ &nbsp; ${ir.done}/${ir.total}</div></div>`;

  const html = _buildReportShell({
    title: `Ballyroe ${invLabel(station.id, invIdx)} — Acceptance Report`,
    docTitle: "Inverter Station Acceptance Report",
    docSub: `${esc(station.label)} · ${esc(station.ref)} · Inverter ${invIdx+1} &nbsp;|&nbsp; ${esc(today)}`,
    overallColor, summaryCards, body, today,
    drawingRef: "ILOS100-BAL-202 (Inverter Mounting Details) · ILOS1001-BAL-120 (Stringing Layout)"
  });
  _openReportWindow(html);
}

/* Site-wide civil & infrastructure acceptance report ------------------- */
function exportSiteReport(){
  const sr = siteRoll();
  const overall = sr.overall==="pass"?"ACCEPTED":sr.overall==="fail"?"REJECTED":sr.overall==="partial"?"IN PROGRESS":"NOT STARTED";
  const overallColor = sr.overall==="pass"?"#2C9B73":sr.overall==="fail"?"#B84545":sr.overall==="partial"?"#B8862B":"#637588";
  const today=new Date().toLocaleString(undefined,{day:"2-digit",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"});

  const cats=[...new Set(D.siteItp.map(it=>it.cat))];
  const body=_buildReportBody(cats, D.siteItp, (i)=>siteItemResult(i));

  const summaryCards = `
    <div><div class="k">Project</div><div class="v">${esc(D.project.name)}</div></div>
    <div><div class="k">Client</div><div class="v">${esc(D.project.client)}</div></div>
    <div><div class="k">EPC</div><div class="v">${esc(D.project.epc)}</div></div>
    <div><div class="k">Status</div><div class="v status">${overall}</div></div>
    <div><div class="k">Location</div><div class="v">${esc(D.project.location)}</div></div>
    <div><div class="k">Coordinates</div><div class="v mono">${esc(D.project.gps)}</div></div>
    <div><div class="k">Scope</div><div class="v">Site-wide civil &amp; infra</div></div>
    <div><div class="k">Items closed</div><div class="v">${sr.pass}✓ &nbsp; ${sr.fail}✕ &nbsp; ${sr.done}/${sr.total}</div></div>`;

  const html = _buildReportShell({
    title: `Ballyroe Site-wide Civil — Acceptance Report`,
    docTitle: "Site-wide Civil &amp; Infrastructure Acceptance Report",
    docSub: `Roads · Fencing · Drainage · Compound &nbsp;|&nbsp; ${esc(today)}`,
    overallColor, summaryCards, body, today,
    drawingRef: "24278-MWP-06-00-DR-C-1000 (Overall Plan) · -1001 · -1002 · -1003 · -1004 (Road &amp; Panel Layout sheets)"
  });
  _openReportWindow(html);
}

/* Executive project report (issue #14) — a single high-level roll-up across the
   whole project: overall acceptance, per-field progress, and the NCR position.
   Reuses the shared report shell; no per-item rows (that's the field/table
   reports' job). */
function exportExecutiveReport(){
  const today=new Date().toLocaleString(undefined,{day:"2-digit",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"});
  let totTables=0, totAcc=0, totFail=0, totPart=0, totInsp=0;
  const rows=[];
  D.fields.forEach(f=>{
    let acc=0,fail=0,part=0,insp=0;
    for(let t=1;t<=f.tables;t++){
      const eff=tableEffectiveStatus(f.id,t).status;
      if(eff==="pass")acc++; else if(eff==="fail")fail++; else if(eff==="partial")part++;
      if(tableRoll(f.id,t).done>0) insp++;
    }
    totTables+=f.tables; totAcc+=acc; totFail+=fail; totPart+=part; totInsp+=insp;
    const pct=f.tables?Math.round(acc/f.tables*100):0;
    rows.push({id:f.id, mwp:f.mwp, tables:f.tables, acc, fail, part, insp, pct});
  });
  const ncrAll=punchItems().filter(p=>p.ncr);
  const ncrOpen=ncrAll.filter(p=>!p.resolved).length;
  const acceptPct=totTables?Math.round(totAcc/totTables*100):0;
  const overall = totFail>0?"ACTION REQUIRED":(totAcc===totTables&&totTables>0?"ACCEPTED":totInsp>0?"IN PROGRESS":"NOT STARTED");
  const overallColor = totFail>0?"#B84545":(totAcc===totTables&&totTables>0?"#2C9B73":totInsp>0?"#B8862B":"#637588");

  const summaryCards = `
    <div><div class="k">Project</div><div class="v">${esc(D.project.name)}</div></div>
    <div><div class="k">Client / EPC</div><div class="v">${esc(D.project.client)} / ${esc(D.project.epc)}</div></div>
    <div><div class="k">Location</div><div class="v">${esc(D.project.location)}</div></div>
    <div><div class="k">Status</div><div class="v status">${overall}</div></div>
    <div><div class="k">Tables accepted</div><div class="v">${totAcc} / ${totTables} (${acceptPct}%)</div></div>
    <div><div class="k">Failed / In progress</div><div class="v">${totFail}✕ &nbsp; ${totPart}◐</div></div>
    <div><div class="k">Open NCRs</div><div class="v">${ncrOpen} of ${ncrAll.length}</div></div>
    <div><div class="k">Fields inspected</div><div class="v">${rows.filter(r=>r.insp>0).length} / ${rows.length}</div></div>`;

  let body=`<h3>Progress by field</h3>
    <table><thead><tr><th>Field</th><th class="n">MWp</th><th class="n">Tables</th><th class="n">Accepted</th><th class="n">Failed</th><th class="n">In&nbsp;progress</th><th class="n">Inspected</th><th class="n">Acceptance</th></tr></thead><tbody>`;
  rows.forEach(r=>{
    const cls = r.fail>0?"fail":r.acc===r.tables&&r.tables>0?"pass":"pending";
    body+=`<tr class="${cls}"><td>${esc(r.id)}</td><td class="n">${r.mwp}</td><td class="n">${r.tables}</td>
      <td class="n">${r.acc}</td><td class="n">${r.fail}</td><td class="n">${r.part}</td><td class="n">${r.insp}/${r.tables}</td><td class="n">${r.pct}%</td></tr>`;
  });
  body+=`<tr style="font-weight:700;border-top:2px solid #13212E"><td>Total</td><td class="n">—</td><td class="n">${totTables}</td>
    <td class="n">${totAcc}</td><td class="n">${totFail}</td><td class="n">${totPart}</td><td class="n">${totInsp}/${totTables}</td><td class="n">${acceptPct}%</td></tr>`;
  body+=`</tbody></table>`;
  if(ncrAll.length){
    body+=`<h3>Open non-conformances (${ncrOpen})</h3>
      <table><thead><tr><th>NCR</th><th>Location</th><th>ITP Ref</th><th>Inspection Item</th><th>Status</th></tr></thead><tbody>`;
    ncrAll.filter(n=>!n.resolved).forEach(n=>{
      body+=`<tr class="fail"><td class="mono">${esc(n.ncr)}</td><td class="mono">${esc(n.loc)}</td>
        <td class="mono">${esc(n.itp)}</td><td>${esc(n.item)}</td><td class="res">OPEN</td></tr>`;
    });
    body+=`</tbody></table>`;
  }

  const html=_buildReportShell({
    title: `${D.project.name} — Executive Project Report`,
    docTitle: "Executive Project Report",
    docSub: `${esc(D.project.name)} · ${totTables} tables · ${acceptPct}% accepted &nbsp;|&nbsp; ${esc(today)}`,
    overallColor, summaryCards, body, today
  });
  _openReportWindow(html);
}

/* ---- Punch list exports ---- */
function _punchExportData(){
  // Issue #8: the punch exports group by location (Field → Table) to match the
  // on-screen list. `byCat`/`cats` keep their names for the consumers below but
  // now hold location groups.
  const byCat=punchByLocation(); const cats=Object.keys(byCat); const pc=punchCounts();
  const today=new Date().toLocaleString("en-IE",{day:"2-digit",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"});
  return {byCat,cats,pc,today};
}
function exportPunchPDF(){
  const {byCat,cats,pc,today}=_punchExportData();
  const accent="#2C9B73", rust="#B84545", ink="#13212E", dim="#5A6B7A", line="#D6DEE5";
  let body="";
  if(!cats.length){ body=`<p style="color:${dim}">No rejected items. The punch list is clear.</p>`; }
  cats.forEach(cat=>{
    const items=byCat[cat]; const open=items.filter(p=>!p.resolved).length;
    body+=`<h2>${cat} <span class="cnt">${open} open / ${items.length} total</span></h2>
      <table><thead><tr><th>Status</th><th>Item</th><th>Scope</th><th>ITP Ref</th><th>Location</th><th>NCR</th><th>Raised by</th><th>Note</th></tr></thead><tbody>
      ${items.map(p=>`<tr class="${p.resolved?'res':'opn'}">
        <td><b>${p.resolved?"RESOLVED":"OPEN"}</b></td><td>${p.item}</td><td>${p.scope}</td>
        <td class="mono">${p.itp}</td><td class="mono">${p.loc}</td><td class="mono">${p.ncr||"—"}</td>
        <td>${p.by||"—"}</td><td>${esc(p.comment||"")}</td></tr>`).join("")}
      </tbody></table>`;
  });
  const html=`<!doctype html><html><head><meta charset="utf-8"><title>Ballyroe Punch List</title>
    <style>
      *{box-sizing:border-box} body{font-family:'Segoe UI',Arial,sans-serif;color:${ink};margin:32px;font-size:12px}
      .hd{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:3px solid ${accent};padding-bottom:12px;margin-bottom:6px}
      .hd h1{margin:0;font-size:21px;color:${ink}} .hd .sub{color:${dim};font-size:11px;margin-top:3px}
      .hd .meta{text-align:right;color:${dim};font-size:10px;line-height:1.6}
      .summary{display:flex;gap:24px;margin:14px 0 22px;padding:12px 16px;background:#F4F7F9;border:1px solid ${line};border-radius:6px}
      .summary div{font-size:11px;color:${dim}} .summary b{display:block;font-size:20px;color:${ink}}
      .summary .o b{color:${rust}} .summary .r b{color:${accent}}
      h2{font-size:13px;margin:22px 0 8px;color:${accent};border-left:3px solid ${accent};padding-left:8px}
      h2 .cnt{color:${dim};font-weight:400;font-size:10px;margin-left:8px}
      table{width:100%;border-collapse:collapse;margin-bottom:8px}
      th{background:${ink};color:#fff;font-size:9px;text-transform:uppercase;letter-spacing:.5px;padding:6px 8px;text-align:left}
      td{padding:6px 8px;border-bottom:1px solid ${line};vertical-align:top}
      tr.opn td b{color:${rust}} tr.res td b{color:${accent}} tr.res{background:#F6FAF8;color:${dim}}
      .mono{font-family:'Consolas','Courier New',monospace;font-size:10px}
      .ft{margin-top:24px;padding-top:10px;border-top:1px solid ${line};color:${dim};font-size:9px;display:flex;justify-content:space-between}
      @media print{body{margin:14mm} h2{page-break-after:avoid} tr{page-break-inside:avoid}}
    </style></head><body>
    <div class="hd"><div><h1>Punch List</h1><div class="sub">${D.project.name} — ${D.project.location}</div></div>
      <div class="meta">Client: ${D.project.client}<br>EPC: ${D.project.epc}<br>Generated ${today}<br>ITP-BAL · Rev B</div></div>
    <div class="summary"><div class="o"><b>${pc.open}</b>Open</div><div class="r"><b>${pc.resolved}</b>Resolved</div>
      <div><b>${pc.total}</b>Total items</div><div><b>${cats.length}</b>Locations</div></div>
    ${body}
    <div class="ft"><span>GridProof · powered by TerraTrace · Ballyroe Solar Farm</span><span>Survey GPS ±1.2 m · Piling Rev B</span></div>
    <script>window.onload=()=>{setTimeout(()=>window.print(),300)}<\/script>
    </body></html>`;
  const w=window.open("","_blank"); if(!w){ toast("Please allow pop-ups to export the PDF","warn"); return; }
  w.document.write(html); w.document.close();
}
function exportPunchExcel(){
  const {byCat,cats,today}=_punchExportData();
  // Excel-readable HTML table workbook (.xls) — opens natively in Excel with formatting
  let rows="";
  cats.forEach(cat=>{
    byCat[cat].forEach(p=>{
      rows+=`<tr>
        <td>${cat}</td><td>${p.resolved?"RESOLVED":"OPEN"}</td><td>${p.item}</td><td>${p.scope}</td>
        <td>${p.itp}</td><td>${p.loc}</td><td>${p.ncr||""}</td><td>${p.by||""}</td>
        <td>${esc(p.comment||"")}</td></tr>`;
    });
  });
  if(!rows) rows=`<tr><td colspan="9">No rejected items</td></tr>`;
  const head=`<tr style="background:#13212E;color:#fff;font-weight:bold">
    <th>Location group</th><th>Status</th><th>Inspection Item</th><th>Scope</th><th>ITP Ref</th><th>Location</th><th>NCR</th><th>Raised By</th><th>Note</th></tr>`;
  const xls=`<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
    <head><meta charset="utf-8"><IfMso9><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
    <x:Name>Punch List</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
    </x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>
    <table border="1"><tr><td colspan="9" style="font-size:15px;font-weight:bold">Ballyroe Solar Farm — Punch List</td></tr>
    <tr><td colspan="9">${D.project.location} · Generated ${today} · ITP-BAL Rev B</td></tr><tr></tr>
    ${head}${rows}</table></body></html>`;
  const blob=new Blob(["\ufeff"+xls],{type:"application/vnd.ms-excel"});
  const u=URL.createObjectURL(blob),a=document.createElement("a");
  a.href=u; a.download=`Ballyroe_PunchList_${new Date().toISOString().slice(0,10)}.xls`; a.click(); URL.revokeObjectURL(u);
}
function wire(){
  document.querySelectorAll(".tab").forEach(t=>t.onclick=()=>setView(t.dataset.view));
  // sitemap
  document.querySelectorAll(".field").forEach(el=>el.onclick=()=>{ state.selField=el.dataset.field; state.selTable=null; document.getElementById("v-sitemap").innerHTML=vSiteMap(); wire(); });
  document.querySelectorAll("[data-table]").forEach(el=>el.onclick=()=>{ state.selTable=+el.dataset.table; document.getElementById("v-sitemap").innerHTML=vSiteMap(); wire(); });
  document.querySelectorAll("[data-tset]").forEach(el=>el.onclick=()=>{
    const f=D.fields.find(x=>x.id===state.selField), k=tkey(f.id,state.selTable);
    const v=el.dataset.tset;
    pushHistory();
    if(v==="clear") delete tableStatus[k]; else tableStatus[k]=v;
    document.getElementById("v-sitemap").innerHTML=vSiteMap(); wire();
    saveToStorage();
    toast(v==="pass"?`Table ${state.selTable} accepted`:v==="fail"?`Table ${state.selTable} marked fail`:`Table ${state.selTable} status cleared`, v==="pass"?"success":v==="fail"?"warn":"info");
  });
  // ---- site map: punch-pin overlay ----
  const pinsToggle = document.getElementById("mapPinsToggle");
  if(pinsToggle) pinsToggle.onclick = ()=>{
    state.mapShowPins = !state.mapShowPins;
    state.mapPin = null;  // close any open popup when toggling layer
    document.getElementById("v-sitemap").innerHTML = vSiteMap();
    wire();
  };
  // Pin click → open popup. The popup itself is rendered by vSiteMap() based
  // on state.mapPin, so we set that and re-render.
  document.querySelectorAll("[data-pinid]").forEach(el=>el.onclick=(ev)=>{
    if(ev && ev.stopPropagation) ev.stopPropagation();
    state.mapPin = el.dataset.pinid;
    document.getElementById("v-sitemap").innerHTML = vSiteMap();
    wire();
  });
  // Popup close button
  document.querySelectorAll("[data-pinclose]").forEach(el=>el.onclick=()=>{
    state.mapPin = null;
    document.getElementById("v-sitemap").innerHTML = vSiteMap();
    wire();
  });
  // Click anywhere else on the mapstage to dismiss the open popup.
  const mst = document.getElementById("mapstage");
  if(mst && state.mapPin){
    mst.addEventListener("click", function _outsideClose(ev){
      // Ignore if click is on the popup itself, on a pin, or on the toggle
      if(ev.target.closest(".ppin-popup")) return;
      if(ev.target.closest("[data-pinid]")) return;
      if(ev.target.closest("#mapPinsToggle")) return;
      state.mapPin = null;
      mst.removeEventListener("click", _outsideClose);
      document.getElementById("v-sitemap").innerHTML = vSiteMap();
      wire();
    }, { once: false });
  }
  // Popup "Open in Quality Control" deep-link: takes the inspector straight to
  // the QC view at the correct scope and target, with the failing item selected.
  document.querySelectorAll("[data-pingoqc]").forEach(el=>el.onclick=()=>{
    const pinId = el.dataset.pingoqc;
    const allPins = punchPinsForMap({showResolved:false}).concat(
      punchPinsForMap({showResolved:true}).filter(p=>p.item.resolved)
    );
    const pin = allPins.find(p=>p.id===pinId);
    if(!pin) return;
    const it = pin.item;
    state.mapPin = null;
    if(it.workScope === "table"){
      state.qcWorkScope = "table";
      state.qcField = it.fid;
      state.qcTable = +it.t;
      // Resolve row: D.fields rows × tables-per-row layout
      const f = D.fields.find(x=>x.id===it.fid);
      if(f && typeof tablesInRow === "function"){
        // Find which row this table belongs to
        for(let r=1; r<=rowsForField(f); r++){
          if(tablesInRow(f,r).includes(+it.t)){ state.qcRow = r; break; }
        }
      }
      // Module / pile drill?
      if(it.scopeKey && it.scopeKey[0] === "M"){
        state.qcModule = +it.scopeKey.slice(1);
        state.qcPile = null;
        state.showModules = true;
        state.showPiles = false;
      } else if(it.scopeKey && it.scopeKey[0] === "P"){
        state.qcPile = +it.scopeKey.slice(1);
        state.qcModule = null;
        state.showPiles = true;
        state.showModules = false;
      } else {
        state.qcModule = null; state.qcPile = null;
        state.showModules = false; state.showPiles = false;
      }
      state.qcItem = +it.idx;
    } else if(it.workScope === "station"){
      state.qcWorkScope = "station";
      state.qcStation = it.fid;
      // scopeKey looks like "INV3"
      const m = (it.scopeKey || "").match(/INV(\d+)/);
      state.qcInverter = m ? +m[1] : 0;
      state.qcItem = +it.idx;
    } else if(it.workScope === "site"){
      state.qcWorkScope = "site";
      state.qcItem = +it.idx;
    }
    state.mobileStep = "checklist";
    setView("qc");
  });
  // ---- QC drill-down ----
  // Work scope selector (Tables / Stations / Site-wide)
  document.querySelectorAll("[data-workscope]").forEach(el=>el.onclick=()=>{
    state.qcWorkScope = el.dataset.workscope;
    state.qcItem = 0;
    // Reset table-scope drill state if leaving tables; reset station idx if entering stations
    if(state.qcWorkScope!=="table"){ state.qcModule=null; state.qcPile=null; state.showModules=false; state.showPiles=false; }
    // Set sensible mobile step entry for this scope
    state.mobileStep = state.qcWorkScope==="site" ? "checklist" : "nav";
    rerenderQC();
  });
  // Station list click
  document.querySelectorAll("[data-station]").forEach(el=>el.onclick=()=>{
    state.qcStation = el.dataset.station;
    state.qcInverter = 0;
    state.qcItem = 0;
    // Stay on nav step so user can pick an inverter
    rerenderQC();
  });
  // Inverter cell click — on mobile, advance to checklist step
  document.querySelectorAll("[data-inv]").forEach(el=>el.onclick=()=>{
    state.qcInverter = +el.dataset.inv;
    state.qcItem = 0;
    state.mobileStep = "checklist";
    rerenderQC();
  });
  // Station: select item in checklist — on mobile, advance to item step
  document.querySelectorAll("[data-stitem]").forEach(el=>el.onclick=()=>{
    state.qcItem = +el.dataset.stitem;
    state.mobileStep = "item";
    rerenderQC();
  });
  // Station: per-item pass/fail
  document.querySelectorAll("[data-stset]").forEach(el=>el.onclick=(e)=>{
    if(e&&e.stopPropagation) e.stopPropagation();
    const [i,s] = el.dataset.stset.split(":");
    pushHistory();
    const seqBefore = ncrSeq;
    Store.setStationInvItem(state.qcStation, state.qcInverter|0, +i, s);
    if(s==="fail" && ncrSeq>seqBefore) toast(ncrRef(ncrSeq-1)+" raised","warn");
    state.qcItem = +i;
    rerenderQC();
  });
  // Station: bulk inverter actions
  document.querySelectorAll("[data-stinvall]").forEach(el=>el.onclick=()=>{
    const v = el.dataset.stinvall;
    const _invRef = invLabel(state.qcStation, state.qcInverter|0);
    if(v==="clear" && !confirm(`Reset all items on ${_invRef}?`)) return;
    if(v==="fail" && !confirm(`Mark every item on ${_invRef} as FAILED? This will raise NCRs.`)) return;
    pushHistory();
    D.stationItp.forEach((_,i)=>Store.setStationInvItem(state.qcStation, state.qcInverter|0, i, v));
    rerenderQC();
    toast(v==="pass"?`${_invRef} accepted`:v==="fail"?`${_invRef} rejected`:`${_invRef} reset`, v==="pass"?"success":v==="fail"?"warn":"info");
  });
  // Station: comment
  const stCommentEl = document.getElementById("stComment");
  const stCommentSend = ()=>{ if(stCommentEl && stCommentEl.value.trim()){
    pushHistory();
    Store.addStationInvComment(state.qcStation, state.qcInverter|0, state.qcItem, stCommentEl.value.trim());
    rerenderQC();
  }};
  const stCmsBtn = document.getElementById("stCommentSend"); if(stCmsBtn) stCmsBtn.onclick = stCommentSend;
  if(stCommentEl){
    stCommentEl.onkeydown = e=>{ if((e.metaKey||e.ctrlKey)&&e.key==="Enter") stCommentSend(); };
    const upd=()=>{ if(stCmsBtn) stCmsBtn.disabled = !stCommentEl.value.trim(); };
    stCommentEl.oninput=upd; upd();
  }
  document.querySelectorAll("[data-stdelcmt]").forEach(el=>el.onclick=()=>{
    pushHistory();
    Store.deleteStationInvComment(state.qcStation, state.qcInverter|0, state.qcItem, el.dataset.stdelcmt);
    rerenderQC();
  });
  // Station: photo upload + view + delete
  const stPin = document.getElementById("stPhotoInput");
  const stPad = document.getElementById("stAddPhoto");
  if(stPad && stPin) stPad.onclick = ()=>stPin.click();
  if(stPin) stPin.onchange = async (e)=>{
    const files=[...e.target.files]; if(!files.length) return;
    let added=0,failed=0;
    const photoObjs=[];
    for(const f of files){
      if(f.type.startsWith("image/")){
        try{ photoObjs.push(await processImage(f)); added++; }
        catch(_){ failed++; }
      } else failed++;
    }
    if(added){
      pushHistory();
      Store.addStationInvPhotos(state.qcStation, state.qcInverter|0, state.qcItem, photoObjs);
      toast(`${added} photo${added>1?"s":""} added`,"success");
    }
    if(failed) toast(`${failed} photo${failed>1?"s":""} failed`,"warn");
    stPin.value="";
    rerenderQC();
    checkStorageHealth();
  };
  document.querySelectorAll("[data-stdelphoto]").forEach(el=>el.onclick=(e)=>{
    if(e&&e.stopPropagation) e.stopPropagation();
    if(!confirm("Remove this photo?")) return;
    pushHistory();
    Store.deleteStationInvPhoto(state.qcStation, state.qcInverter|0, state.qcItem, el.dataset.stdelphoto);
    rerenderQC(); toast("Photo removed","info");
  });
  document.querySelectorAll("[data-stviewphoto]").forEach(el=>el.onclick=()=>{
    const inv = getStationInv(state.qcStation, state.qcInverter|0);
    const item = inv.items[state.qcItem]; if(!item) return;
    const list = item.photos||[];
    const idx = list.findIndex(p=>p.id===el.dataset.stviewphoto);
    if(idx<0) return;
    const p = list[idx];
    document.getElementById("lightbox").style.display="flex";
    document.getElementById("lbimg").src=p.full;
    document.getElementById("lbcap").textContent=`${esc(p.name||"photo")} · ${fmtDate(p.at)} ${fmtTime(p.at)} · ${esc(p.by)}`;
    document.getElementById("lbcounter").textContent=`${idx+1} / ${list.length}`;
    document.getElementById("lbprev").disabled = idx<=0;
    document.getElementById("lbnext").disabled = idx>=list.length-1;
  });

  // Site: select / set / bulk / comment / photo
  document.querySelectorAll("[data-siteitem]").forEach(el=>el.onclick=()=>{
    state.qcItem = +el.dataset.siteitem;
    state.mobileStep = "item";
    rerenderQC();
  });
  document.querySelectorAll("[data-siteset]").forEach(el=>el.onclick=(e)=>{
    if(e&&e.stopPropagation) e.stopPropagation();
    const [i,s] = el.dataset.siteset.split(":");
    pushHistory();
    const seqBefore = ncrSeq;
    Store.setSiteItem(+i, s);
    if(s==="fail" && ncrSeq>seqBefore) toast(ncrRef(ncrSeq-1)+" raised","warn");
    state.qcItem = +i;
    rerenderQC();
  });
  const siteCommentEl = document.getElementById("siteComment");
  const siteCommentSend = ()=>{ if(siteCommentEl && siteCommentEl.value.trim()){
    pushHistory();
    Store.addSiteComment(state.qcItem, siteCommentEl.value.trim());
    rerenderQC();
  }};
  const siteCmsBtn = document.getElementById("siteCommentSend"); if(siteCmsBtn) siteCmsBtn.onclick = siteCommentSend;
  if(siteCommentEl){
    siteCommentEl.onkeydown = e=>{ if((e.metaKey||e.ctrlKey)&&e.key==="Enter") siteCommentSend(); };
    const upd=()=>{ if(siteCmsBtn) siteCmsBtn.disabled = !siteCommentEl.value.trim(); };
    siteCommentEl.oninput=upd; upd();
  }
  document.querySelectorAll("[data-sitedelcmt]").forEach(el=>el.onclick=()=>{
    pushHistory();
    Store.deleteSiteComment(state.qcItem, el.dataset.sitedelcmt);
    rerenderQC();
  });
  const sitePin = document.getElementById("sitePhotoInput");
  const siteAdd = document.getElementById("siteAddPhoto");
  if(siteAdd && sitePin) siteAdd.onclick = ()=>sitePin.click();
  if(sitePin) sitePin.onchange = async (e)=>{
    const files=[...e.target.files]; if(!files.length) return;
    let added=0,failed=0;
    const photoObjs=[];
    for(const f of files){
      if(f.type.startsWith("image/")){
        try{ photoObjs.push(await processImage(f)); added++; }
        catch(_){ failed++; }
      } else failed++;
    }
    if(added){
      pushHistory();
      Store.addSitePhotos(state.qcItem, photoObjs);
      toast(`${added} photo${added>1?"s":""} added`,"success");
    }
    if(failed) toast(`${failed} photo${failed>1?"s":""} failed`,"warn");
    sitePin.value="";
    rerenderQC();
    checkStorageHealth();
  };
  document.querySelectorAll("[data-sitedelphoto]").forEach(el=>el.onclick=(e)=>{
    if(e&&e.stopPropagation) e.stopPropagation();
    if(!confirm("Remove this photo?")) return;
    pushHistory();
    Store.deleteSitePhoto(state.qcItem, el.dataset.sitedelphoto);
    rerenderQC(); toast("Photo removed","info");
  });
  document.querySelectorAll("[data-siteviewphoto]").forEach(el=>el.onclick=()=>{
    const item = siteInspection.items[state.qcItem]; if(!item) return;
    const list = item.photos||[];
    const idx = list.findIndex(p=>p.id===el.dataset.siteviewphoto);
    if(idx<0) return;
    const p = list[idx];
    document.getElementById("lightbox").style.display="flex";
    document.getElementById("lbimg").src=p.full;
    document.getElementById("lbcap").textContent=`${esc(p.name||"photo")} · ${fmtDate(p.at)} ${fmtTime(p.at)} · ${esc(p.by)}`;
    document.getElementById("lbcounter").textContent=`${idx+1} / ${list.length}`;
    document.getElementById("lbprev").disabled = idx<=0;
    document.getElementById("lbnext").disabled = idx>=list.length-1;
  });

  // ipanel collapse toggle
  const ipt=document.getElementById("ipanel-toggle");
  if(ipt) ipt.onclick=()=>{ state.qcPanelCollapsed=true; rerenderQC(); };
  const ipf=document.getElementById("ipanel-floating");
  if(ipf) ipf.onclick=()=>{ state.qcPanelCollapsed=false; rerenderQC(); };
  document.querySelectorAll("[data-qfield]").forEach(el=>el.onclick=()=>{
    const fid=el.dataset.qfield;
    if(state.qcField!==fid){ state.qcField=fid; state.qcRow=1; state.qcTable=1; state.qcItem=0; state.qcModule=null; state.showModules=false; state.qcPile=null; state.showPiles=false; }
    rerenderQC();
  });
  document.querySelectorAll("[data-qrow]").forEach(el=>el.onclick=()=>{
    state.qcRow=+el.dataset.qrow; state.qcTable=tablesInRow(D.fields.find(x=>x.id===state.qcField),state.qcRow)[0]; state.qcItem=0; state.qcModule=null; state.showModules=false; state.qcPile=null; state.showPiles=false;
    state.mobileStep="table"; rerenderQC();
  });
  document.querySelectorAll("[data-qtable]").forEach(el=>el.onclick=()=>{ state.qcTable=+el.dataset.qtable; state.qcItem=0; state.qcModule=null; state.showModules=false; state.qcPile=null; state.showPiles=false; state.mobileStep="checklist"; rerenderQC(); });
  document.querySelectorAll("[data-qitem]").forEach(el=>el.onclick=()=>{ state.qcItem=+el.dataset.qitem; state.mobileStep="item"; rerenderQC(); });
  document.querySelectorAll("[data-mback]").forEach(el=>el.onclick=()=>{ state.mobileStep=el.dataset.mback; rerenderQC(); });
  // ---- module grid ----
  document.querySelectorAll("[data-modtoggle]").forEach(el=>el.onclick=()=>{
    state.showModules=!state.showModules;
    if(state.showModules){ state.showPiles=false; state.qcPile=null; }  // modules & piles are mutually exclusive
    else state.qcModule=null;
    state.qcItem=0; rerenderQC();
  });
  document.querySelectorAll("[data-qmod]").forEach(el=>el.onclick=()=>{ state.qcModule=+el.dataset.qmod; state.qcItem=0; rerenderQC(); });
  document.querySelectorAll("[data-modexit]").forEach(el=>el.onclick=()=>{ state.qcModule=null; rerenderQC(); });
  document.querySelectorAll("[data-modall]").forEach(el=>el.onclick=()=>{
    if(state.qcModule==null) return;
    const v=el.dataset.modall;
    pushHistory();
    if(v==="clear") Store.setModuleStatus(state.qcField,state.qcTable,state.qcModule,"clear");
    else { Store.setModuleStatus(state.qcField,state.qcTable,state.qcModule,v); D.itp.forEach((_,i)=>Store.setModuleItem(state.qcField,state.qcTable,state.qcModule,i,v)); }
    rerenderQC();
  });
  // ---- pile grid ----
  document.querySelectorAll("[data-piletoggle]").forEach(el=>el.onclick=()=>{
    state.showPiles=!state.showPiles;
    if(state.showPiles){ state.showModules=false; state.qcModule=null; }  // mutually exclusive
    else state.qcPile=null;
    state.qcItem=0; rerenderQC();
  });
  document.querySelectorAll("[data-qpile]").forEach(el=>el.onclick=()=>{ state.qcPile=+el.dataset.qpile; state.qcItem=0; rerenderQC(); });
  document.querySelectorAll("[data-pileexit]").forEach(el=>el.onclick=()=>{ state.qcPile=null; rerenderQC(); });
  document.querySelectorAll("[data-pileall]").forEach(el=>el.onclick=()=>{
    if(state.qcPile==null) return;
    const v=el.dataset.pileall;
    pushHistory();
    if(v==="clear") Store.setPileStatus(state.qcField,state.qcTable,state.qcPile,"clear");
    else { Store.setPileStatus(state.qcField,state.qcTable,state.qcPile,v); D.pileItp.forEach((_,i)=>Store.setPileItem(state.qcField,state.qcTable,state.qcPile,i,v)); }
    rerenderQC();
  });
  // scope flags
  const P = state.qcPile, M = state.qcModule;
  const inPile = P!=null, inMod = M!=null;
  // ---- per-item pass/fail (routes to pile / module / table scope) ----
  document.querySelectorAll("[data-qset]").forEach(el=>el.onclick=(e)=>{
    if(e&&e.stopPropagation) e.stopPropagation();
    const [i,s]=el.dataset.qset.split(":");
    pushHistory();
    const seqBefore=ncrSeq;
    if(inPile) Store.setPileItem(state.qcField,state.qcTable,P,+i,s);
    else if(inMod) Store.setModuleItem(state.qcField,state.qcTable,M,+i,s);
    else setItemStatus(state.qcField,state.qcTable,+i,s);
    if(s==="fail" && ncrSeq>seqBefore){
      toast(ncrRef(ncrSeq-1)+" raised","warn");
    }
    state.qcItem=+i; rerenderQC();
  });
  document.querySelectorAll("[data-tableall]").forEach(el=>el.onclick=()=>{
    const action=el.dataset.tableall;
    // Pre-count what will be affected, for a meaningful confirmation message.
    const f=D.fields.find(x=>x.id===state.qcField)||D.fields[0];
    const tt=D.tableTypes[tableTypeFor(f,state.qcTable)];
    const modN = tt.rows * tt.cols;
    const pileN = 2 * tt.pilesPerRow;
    // How many modules/piles already failed (will be preserved on accept)
    let failedMods=0, failedPiles=0;
    for(let m=0;m<modN;m++){ const k=mkey(state.qcField,state.qcTable,m); if(inspections[k]?.status==="fail") failedMods++; }
    for(let p=0;p<pileN;p++){ const k=pkey(state.qcField,state.qcTable,p); if(inspections[k]?.status==="fail") failedPiles++; }

    if(action==="clear"){
      if(!confirm(`Reset Table ${state.qcTable} entirely?\n\nThis clears the table-level checklist, all ${modN} module statuses, and all ${pileN} pile statuses for this table.`)) return;
    } else if(action==="fail"){
      if(!confirm(`Mark Table ${state.qcTable} as FAILED?\n\nThis raises NCRs against every checklist item and marks all ${modN} modules and ${pileN} piles as failed.`)) return;
    } else if(action==="pass" && (failedMods+failedPiles)>0){
      // Warn — but allow — accepting a table that contains failed children.
      const parts=[];
      if(failedMods) parts.push(`${failedMods} failed module${failedMods===1?"":"s"}`);
      if(failedPiles) parts.push(`${failedPiles} failed pile${failedPiles===1?"":"s"}`);
      if(!confirm(`Table ${state.qcTable} contains ${parts.join(" and ")}.\n\nAccepting the table will not clear those failures — they remain open with their NCRs until closed individually.\n\nContinue?`)) return;
    }
    pushHistory();
    setTableAll(state.qcField,state.qcTable,action); rerenderQC();
    // Build a more informative toast
    if(action==="pass"){
      const remaining = failedMods+failedPiles;
      toast(remaining>0
        ? `Table ${state.qcTable} accepted · ${remaining} failed item${remaining===1?"":"s"} still open`
        : `Table ${state.qcTable} accepted · ${modN} modules, ${pileN} piles`, "success");
    } else if(action==="fail"){
      toast(`Table ${state.qcTable} rejected · ${modN} modules, ${pileN} piles flagged`, "warn");
    } else {
      toast(`Table ${state.qcTable} reset`, "info");
    }
  });
  // ---- checklist filter pills ----
  document.querySelectorAll("[data-clfilter]").forEach(el=>el.onclick=()=>{
    state.qcChecklistFilter=el.dataset.clfilter;
    rerenderQC();
  });
  document.querySelectorAll("[data-clmechfilter]").forEach(el=>el.onclick=()=>{
    state.qcMechFilter=el.dataset.clmechfilter;
    rerenderQC();
  });
  // ---- keyboard navigation on checklist ----
  // ArrowUp/Down to move selection, P=pass, F=fail, Enter to toggle pass
  if(state.view==="qc" && !window._qcKbBound){
    window._qcKbBound=true;
    document.addEventListener("keydown",(e)=>{
      if(state.view!=="qc") return;
      // Don't trigger when typing in textarea/input
      const tag=document.activeElement?.tagName;
      if(tag==="TEXTAREA"||tag==="INPUT") return;
      const ws = state.qcWorkScope||"table";
      // Resolve which ITP + which result lookup
      const ITP = ws==="station" ? D.stationItp
                : ws==="site"    ? D.siteItp
                : state.qcPile!=null ? D.pileItp : D.tableItp;
      const lookupRes = (i)=>{
        if(ws==="station") return stationInvItemResult(state.qcStation||"ST1", state.qcInverter|0, i);
        if(ws==="site")    return siteItemResult(i);
        return state.qcPile!=null ? pileItemResult(state.qcField,state.qcTable,state.qcPile,i)
             : state.qcModule!=null ? modItemResult(state.qcField,state.qcTable,state.qcModule,i)
             : itemResult(state.qcField,state.qcTable,i);
      };
      const visible=[];
      const filt=state.qcChecklistFilter||"all";
      const sc=state.qcMechFilter||"all";
      // Mech-filter only applies to table scope (only its items carry scope tags)
      const usesScope = ws==="table" && state.qcPile==null;
      ITP.forEach((it,i)=>{
        if(usesScope && sc!=="all" && it.scope!==sc) return;
        if(filt==="all"){ visible.push(i); return; }
        if(lookupRes(i).status===filt) visible.push(i);
      });
      if(!visible.length) return;
      const idx=visible.indexOf(state.qcItem);
      if(e.key==="ArrowDown" || e.key==="j"){
        e.preventDefault();
        state.qcItem = visible[Math.min(visible.length-1, (idx<0?0:idx+1))];
        rerenderQC();
      } else if(e.key==="ArrowUp" || e.key==="k"){
        e.preventDefault();
        state.qcItem = visible[Math.max(0, (idx<0?0:idx-1))];
        rerenderQC();
      } else if(e.key==="p" || e.key==="P" || e.key==="f" || e.key==="F"){
        e.preventDefault();
        const status = (e.key==="p"||e.key==="P") ? "pass" : "fail";
        const i=state.qcItem;
        pushHistory();
        const seqBefore=ncrSeq;
        const ws = state.qcWorkScope||"table";
        if(ws==="station"){
          Store.setStationInvItem(state.qcStation||"ST1", state.qcInverter|0, i, status);
        } else if(ws==="site"){
          Store.setSiteItem(i, status);
        } else {
          if(state.qcPile!=null) Store.setPileItem(state.qcField,state.qcTable,state.qcPile,i,status);
          else if(state.qcModule!=null) Store.setModuleItem(state.qcField,state.qcTable,state.qcModule,i,status);
          else setItemStatus(state.qcField,state.qcTable,i,status);
        }
        if(status==="fail" && ncrSeq>seqBefore) toast(ncrRef(ncrSeq-1)+" raised","warn");
        rerenderQC();
      }
    });
  }
  // ---- comments (scope-aware) ----
  const qc=document.getElementById("qcomment");
  const sendComment=()=>{ if(qc&&qc.value.trim()){
    if(inPile) Store.addPileComment(state.qcField,state.qcTable,P,qc.value);
    else if(inMod) Store.addModuleComment(state.qcField,state.qcTable,M,qc.value);
    else Store.addComment(state.qcField,state.qcTable,state.qcItem,qc.value);
    rerenderQC(); } };
  const qcs=document.getElementById("qcommentsend"); if(qcs) qcs.onclick=sendComment;
  if(qc){
    qc.onkeydown=e=>{ if((e.metaKey||e.ctrlKey)&&e.key==="Enter") sendComment(); };
    const cnt=document.getElementById("qcommentcount");
    const updateUI=()=>{
      const n=qc.value.length;
      if(qcs) qcs.disabled=!qc.value.trim();
      if(cnt){
        cnt.textContent=`${n} / 500`;
        cnt.classList.toggle("warn",n>=400&&n<480);
        cnt.classList.toggle("over",n>=480);
      }
    };
    qc.oninput=updateUI; updateUI();
  }
  document.querySelectorAll("[data-delcomment]").forEach(el=>el.onclick=()=>{
    if(inPile) Store.deletePileComment(state.qcField,state.qcTable,P,el.dataset.delcomment);
    else if(inMod) Store.deleteModuleComment(state.qcField,state.qcTable,M,el.dataset.delcomment);
    else Store.deleteComment(state.qcField,state.qcTable,state.qcItem,el.dataset.delcomment);
    rerenderQC(); });
  // ---- photos (scope-aware) ----
  const pin=document.getElementById("qphotoinput");
  const padd=document.getElementById("qaddphoto");
  if(padd&&pin) padd.onclick=()=>pin.click();
  const processQCPhotos=async(files)=>{
    if(!files.length) return;
    padd.classList.add("busy"); padd.querySelector("span:last-child").textContent="Processing…";
    try{
      const out=[]; let failed=0;
      for(const f of files){
        if(f.type.startsWith("image/")){
          try{ out.push(await processImage(f)); }
          catch(_){ failed++; }
        }else{ failed++; }
      }
      if(out.length){
        if(inPile) Store.addPilePhotos(state.qcField,state.qcTable,P,out);
        else if(inMod) Store.addModulePhotos(state.qcField,state.qcTable,M,out);
        else Store.addPhotos(state.qcField,state.qcTable,state.qcItem,out);
        toast(`${out.length} photo${out.length>1?"s":""} added`,"success");
        checkStorageHealth();
      }
      if(failed) toast(`${failed} photo${failed>1?"s":""} could not be processed`,"warn");
    }catch(err){
      toast("Photo upload failed","error");
    }finally{
      rerenderQC();
    }
  };
  if(pin) pin.onchange=async(e)=>{
    await processQCPhotos([...e.target.files]);
    pin.value="";
  };
  // Drag-and-drop on gallery
  const gallery=document.querySelector(".ipanel .gallery");
  if(gallery){
    gallery.ondragover=(e)=>{ e.preventDefault(); gallery.classList.add("drag-over"); };
    gallery.ondragleave=()=>{ gallery.classList.remove("drag-over"); };
    gallery.ondrop=async(e)=>{
      e.preventDefault(); gallery.classList.remove("drag-over");
      await processQCPhotos([...e.dataTransfer.files]);
    };
  }
  document.querySelectorAll("[data-delphoto]").forEach(el=>el.onclick=(e)=>{
    if(e&&e.stopPropagation) e.stopPropagation();
    if(!confirm("Remove this photo? This can't be undone.")) return;
    if(inPile) Store.deletePilePhoto(state.qcField,state.qcTable,P,el.dataset.delphoto);
    else if(inMod) Store.deleteModulePhoto(state.qcField,state.qcTable,M,el.dataset.delphoto);
    else Store.deletePhoto(state.qcField,state.qcTable,state.qcItem,el.dataset.delphoto);
    rerenderQC();
    toast("Photo removed","info");
  });
  // ---- lightbox: track open photo + list for prev/next ----
  function _lbCurrentList(){
    const r = inPile ? getPile(state.qcField,state.qcTable,P)
            : inMod ? getModule(state.qcField,state.qcTable,M)
            : itemResult(state.qcField,state.qcTable,state.qcItem);
    return r.photos || [];
  }
  function _lbShow(idx){
    const list=_lbCurrentList();
    if(!list.length) return;
    if(idx<0) idx=0; if(idx>=list.length) idx=list.length-1;
    window._lbIdx=idx;
    const p=list[idx];
    document.getElementById("lbimg").src=p.full;
    document.getElementById("lbcap").textContent=`${p.name||"photo"} · ${Store._day(p.at)} ${Store._hm(p.at)} · ${p.by}`;
    document.getElementById("lbcounter").textContent=`${idx+1} / ${list.length}`;
    document.getElementById("lbprev").disabled = idx<=0;
    document.getElementById("lbnext").disabled = idx>=list.length-1;
  }
  document.querySelectorAll("[data-viewphoto]").forEach(el=>el.onclick=()=>{
    const list=_lbCurrentList();
    const idx=list.findIndex(x=>x.id===el.dataset.viewphoto);
    if(idx<0) return;
    document.getElementById("lightbox").style.display="flex";
    _lbShow(idx);
  });
  // ---- lightbox close + nav ----
  const lb=document.getElementById("lightbox"), lbc=document.getElementById("lbclose");
  if(lbc) lbc.onclick=()=>lb.style.display="none";
  if(lb) lb.onclick=(e)=>{ if(e.target===lb) lb.style.display="none"; };
  const lbp=document.getElementById("lbprev"); if(lbp) lbp.onclick=()=>_lbShow((window._lbIdx||0)-1);
  const lbn=document.getElementById("lbnext"); if(lbn) lbn.onclick=()=>_lbShow((window._lbIdx||0)+1);
  // arrow-key nav while lightbox open (bound once)
  if(!window._lbKbBound){
    window._lbKbBound=true;
    document.addEventListener("keydown",(e)=>{
      const lbEl=document.getElementById("lightbox");
      if(!lbEl||lbEl.style.display!=="flex") return;
      if(e.key==="ArrowLeft"){ e.preventDefault();
        const n=(window._lbIdx||0)-1;
        if(n>=0) _lbShow(n);
      } else if(e.key==="ArrowRight"){ e.preventDefault();
        _lbShow((window._lbIdx||0)+1);
      }
    });
  }
  const qe=document.getElementById("qexport"); if(qe) qe.onclick=exportReport;
  const qeSt=document.getElementById("qexport-station"); if(qeSt) qeSt.onclick=exportStationReport;
  const qeSite=document.getElementById("qexport-site"); if(qeSite) qeSite.onclick=exportSiteReport;
  // ---- theme toggle ----
  const tb=document.getElementById("themebtn");
  if(tb) tb.onclick=toggleTheme;

  // ---- gear menu ----
  const gearBtn=document.getElementById("gearbtn");
  const gearMenu=document.getElementById("gear-menu");
  if(gearBtn&&gearMenu){
    gearBtn.onclick=(e)=>{ if(e&&e.stopPropagation) e.stopPropagation(); gearMenu.classList.toggle("open"); };
    // Click anywhere else closes — attach once to body via a flag
    if(!window._gearOutsideBound){
      window._gearOutsideBound=true;
      document.addEventListener("click",(e)=>{
        const m=document.getElementById("gear-menu"), b=document.getElementById("gearbtn");
        if(m&&b&&!m.contains(e.target)&&!b.contains(e.target)) m.classList.remove("open");
      });
    }
  }
  const gearTheme=document.getElementById("gearTheme");
  if(gearTheme) gearTheme.onclick=()=>{ toggleTheme(); gearMenu&&gearMenu.classList.remove("open"); };
  const undoBtn=document.getElementById("undobtn"); if(undoBtn) undoBtn.onclick=()=>{ undo(); gearMenu&&gearMenu.classList.remove("open"); };
  const redoBtn=document.getElementById("redobtn"); if(redoBtn) redoBtn.onclick=()=>{ redo(); gearMenu&&gearMenu.classList.remove("open"); };
  updateUndoUI();

  // ---- network status indicator ----
  function updateNetStatus(){
    const el=document.getElementById("netstatus"); if(!el) return;
    const online=navigator.onLine!==false;
    el.classList.toggle("offline", !online);
    const lbl=el.querySelector(".glabel"); if(lbl) lbl.textContent=online?"Online":"Offline";
    el.title=online
      ? "Connected — changes are saved locally and ready to sync"
      : "Offline — changes save locally. They’ll sync when a backend is connected.";
  }
  updateNetStatus();
  if(!window._netBound){
    window._netBound=true;
    window.addEventListener("online", ()=>{ updateNetStatus(); toast("Back online","success"); });
    window.addEventListener("offline",()=>{ updateNetStatus(); toast("Offline — changes saved locally","warn"); });
  }

  // ---- global keyboard shortcuts (bound once) ----
  if(!window._kbBound){
    window._kbBound=true;
    document.addEventListener("keydown",(e)=>{
      // Undo / redo (Cmd/Ctrl+Z, Cmd/Ctrl+Shift+Z or Ctrl+Y)
      const isMod = e.metaKey || e.ctrlKey;
      const tag = document.activeElement?.tagName;
      const inField = tag==="TEXTAREA" || tag==="INPUT";
      if(isMod && !inField){
        if(e.key==="z" || e.key==="Z"){
          e.preventDefault();
          if(e.shiftKey) redo(); else undo();
          return;
        }
        if(e.key==="y" || e.key==="Y"){
          e.preventDefault(); redo(); return;
        }
      }
      if(e.key==="Escape"){
        const m=document.getElementById("gear-menu"); if(m&&m.classList.contains("open")) m.classList.remove("open");
        const d=document.getElementById("drawer"); if(d&&d.classList.contains("open")){
          d.classList.remove("open");
          const o=document.getElementById("drawer-overlay"); if(o) o.classList.remove("open");
          document.body.style.overflow="";
        }
        const lb=document.getElementById("lightbox"); if(lb&&lb.style.display==="flex") lb.style.display="none";
        const cm=document.getElementById("cadModal"); if(cm&&cm.style.display==="flex") cm.style.display="none";
        const im=document.getElementById("itpModal"); if(im&&im.style.display==="flex") im.style.display="none";
      }
    });
    // Auto-close drawer when window grows past mobile threshold
    window.addEventListener("resize",()=>{
      if(window.innerWidth>720){
        const d=document.getElementById("drawer");
        if(d&&d.classList.contains("open")){
          d.classList.remove("open");
          const o=document.getElementById("drawer-overlay"); if(o) o.classList.remove("open");
          document.body.style.overflow="";
        }
      }
    });
  }

  // ---- hamburger + drawer ----
  function openDrawer(){
    // Populate drawer nav dynamically so active state is current
    const nav=document.getElementById("drawer-nav");
    const roleEl=document.getElementById("drawer-role");
    if(roleEl){
      const r=D.roles[currentRole];
      roleEl.innerHTML=`<div style="font-size:10px;color:var(--dim2);letter-spacing:.5px;margin-bottom:3px">SIGNED IN AS</div>
        <div style="color:${r.color};font-weight:700;font-size:13px">${r.label}</div>`;
    }
    if(nav){
      const navItems=[["overview","Overview"],["rfi","RFI Register"],["sitemap","Site Map"],["qc","Quality Control"],["punch","Punch List"],["tdd","Documents"]];
      const visible=currentRole==="tdd"?[["overview","Overview"],["tdd","Documents"]]:navItems;
      nav.innerHTML=visible.map(([v,l])=>{
        const pc = v==="punch"?punchCounts().open : v==="rfi"?rfiCounts().pending : 0;
        return `<button class="tab ${state.view===v?"active":""}" data-drawer-view="${v}">
          <span class="ti" style="${state.view===v?"background:var(--hiviz)":"background:var(--line2)"}"></span>
          ${l}${pc?`<span class="navbadge" style="margin-left:auto">${pc}</span>`:""}
        </button>`;
      }).join("");
      nav.querySelectorAll("[data-drawer-view]").forEach(el=>el.onclick=()=>{ setView(el.dataset.drawerView); closeDrawer(); });
    }
    document.getElementById("drawer").classList.add("open");
    document.getElementById("drawer-overlay").classList.add("open");
    document.body.style.overflow="hidden";
  }
  function closeDrawer(){
    document.getElementById("drawer").classList.remove("open");
    document.getElementById("drawer-overlay").classList.remove("open");
    document.body.style.overflow="";
  }
  const hbtn=document.getElementById("hamburger");
  if(hbtn) hbtn.onclick=openDrawer;
  const dClose=document.getElementById("drawer-close");
  if(dClose) dClose.onclick=closeDrawer;
  const dOverlay=document.getElementById("drawer-overlay");
  if(dOverlay) dOverlay.onclick=closeDrawer;
  const dTheme=document.getElementById("drawerTheme");
  if(dTheme) dTheme.onclick=()=>{ toggleTheme(); closeDrawer(); };
  const dSave=document.getElementById("drawerSave");
  if(dSave) dSave.onclick=exportSnapshot;
  const dLoad=document.getElementById("drawerLoad");
  if(dLoad) dLoad.onchange=e=>{ if(e.target.files&&e.target.files[0]) importSnapshot(e.target.files[0]); };

  // ---- punch list ----
  document.querySelectorAll("[data-punchtoggle]").forEach(el=>el.onclick=(e)=>{
    if(e&&e.stopPropagation) e.stopPropagation();
    const [k,idx]=el.dataset.punchtoggle.split("|");
    const ins=inspections[k]; const cur=ins&&ins.items[idx]?!!ins.items[idx].resolved:false;
    Store.setResolved(k,+idx,!cur);
    render();  // rebuild so the punch view + nav badge both update
  });
  document.querySelectorAll("[data-punchjump]").forEach(el=>el.onclick=()=>{
    const [k,idx]=el.dataset.punchjump.split("|");
    const parts=k.split("::"); const fid=parts[0], t=+parts[1], scopeKey=parts[2]||null;
    // set QC location + scope, then open QC
    state.qcField=fid; state.qcTable=t; state.qcItem=+idx;
    state.qcModule=null; state.qcPile=null; state.showModules=false; state.showPiles=false;
    // figure the row that contains this table
    const f=D.fields.find(x=>x.id===fid)||D.fields[0];
    const nRows=rowsForField(f);
    for(let row=1;row<=nRows;row++){ if(tablesInRow(f,row).includes(t)){ state.qcRow=row; break; } }
    if(scopeKey && scopeKey[0]==="M"){ state.showModules=true; state.qcModule=+scopeKey.slice(1); }
    else if(scopeKey && scopeKey[0]==="P"){ state.showPiles=true; state.qcPile=+scopeKey.slice(1); }
    state.mobileStep="item";
    setView("qc");
  });
  const pPdf=document.getElementById("punchPdf"); if(pPdf) pPdf.onclick=exportPunchPDF;
  const pXls=document.getElementById("punchXls"); if(pXls) pXls.onclick=exportPunchExcel;
  // overview -> punch quick link
  const goPunch=document.getElementById("goPunch"); if(goPunch) goPunch.onclick=()=>setView("punch");
  // overview -> field jump to site map
  document.querySelectorAll("[data-fieldjump]").forEach(el=>el.onclick=()=>{
    const fid = el.dataset.fieldjump;
    state.selField = fid;
    state.selTable = null;
    setView("sitemap");
  });

  // -- Controls wiring -----------------------------------------------------
  document.querySelectorAll("[data-ctrldisc]").forEach(el=>el.onclick=()=>{
    state.ctrlDiscipline=el.dataset.ctrldisc; state.ctrlRecord=null; state.ctrlItem=0;
    document.getElementById("v-controls").innerHTML=vControls(); wire();
  });
  document.querySelectorAll("[data-ctrlrec]").forEach(el=>el.onclick=()=>{
    state.ctrlRecord=el.dataset.ctrlrec; state.ctrlItem=0;
    document.getElementById("v-controls").innerHTML=vControls(); wire();
  });
  document.querySelectorAll("[data-ctrlitem]").forEach(el=>el.onclick=()=>{
    state.ctrlItem=+el.dataset.ctrlitem;
    document.getElementById("v-controls").innerHTML=vControls(); wire();
  });
  document.querySelectorAll("[data-ctrlset]").forEach(el=>el.onclick=(e)=>{
    if(e&&e.stopPropagation) e.stopPropagation();
    const [i,s]=el.dataset.ctrlset.split(":");
    const recId=state.ctrlRecord||(D.disciplines.find(d=>d.id===state.ctrlDiscipline)||D.disciplines[0]).id&&"REC-01";
    const r=getCtrlItem(state.ctrlDiscipline,recId||"REC-01",+i);
    r.status=s; r.by=Store._author(); r.at=Store._hm(Store._now());
    if(s==="fail"&&!r.ncr) r.ncr=ncrRef(ncrSeq++);
    if(s==="pass") r.ncr="";
    state.ctrlItem=+i; saveToStorage();
    document.getElementById("v-controls").innerHTML=vControls(); wire();
  });
  document.querySelectorAll("[data-ctrlset1]").forEach(el=>el.onclick=(e)=>{
    if(e&&e.stopPropagation) e.stopPropagation();
    const parts=el.dataset.ctrlset1.split(":");
    const [i,s,recId]=[+parts[0],parts[1],parts[2]];
    const r=getCtrlItem(state.ctrlDiscipline,recId,i);
    r.status=s; r.by=Store._author(); r.at=Store._hm(Store._now());
    if(s==="fail"&&!r.ncr) r.ncr=ncrRef(ncrSeq++);
    if(s==="pass") r.ncr="";
    saveToStorage(); document.getElementById("v-controls").innerHTML=vControls(); wire();
  });
  document.querySelectorAll("[data-ctrlall]").forEach(el=>el.onclick=()=>{
    const [s,recId]=el.dataset.ctrlall.split(":");
    const disc=D.disciplines.find(d=>d.id===state.ctrlDiscipline)||D.disciplines[0];
    if(s==="clear" && !confirm(`Reset all items on ${disc.label} / ${recId}?`)) return;
    if(s==="fail" && !confirm(`Mark every item on ${disc.label} / ${recId} as FAILED? This will raise NCRs.`)) return;
    disc.itp.forEach((_,i)=>{
      const r=getCtrlItem(disc.id,recId,i);
      if(s==="clear"){ r.status="pending"; r.ncr=""; r.by=""; r.at=""; }
      else{ r.status=s; r.by=Store._author(); r.at=Store._hm(Store._now());
        if(s==="fail"&&!r.ncr) r.ncr=ncrRef(ncrSeq++); if(s==="pass") r.ncr=""; }
    });
    saveToStorage(); document.getElementById("v-controls").innerHTML=vControls(); wire();
    toast(s==="pass"?`${disc.label} / ${recId} accepted`:s==="fail"?`${disc.label} / ${recId} rejected`:`${disc.label} / ${recId} reset`, s==="pass"?"success":s==="fail"?"warn":"info");
  });
  // controls comments
  const cctrl=document.getElementById("ctrlcomment");
  const ctrlSendCmt=()=>{ if(cctrl&&cctrl.value.trim()){
    const recId=state.ctrlRecord||"REC-01"; const r=getCtrlItem(state.ctrlDiscipline,recId,state.ctrlItem);
    r.comments.push({id:Store._id(),by:Store._author(),at:Store._now(),text:cctrl.value.trim()});
    saveToStorage(); document.getElementById("v-controls").innerHTML=vControls(); wire();
  }};
  const ccs=document.getElementById("ctrlcommentsend"); if(ccs) ccs.onclick=ctrlSendCmt;
  if(cctrl){
    cctrl.onkeydown=e=>{ if((e.metaKey||e.ctrlKey)&&e.key==="Enter") ctrlSendCmt(); };
    const updateBtn=()=>{ if(ccs) ccs.disabled=!cctrl.value.trim(); };
    cctrl.oninput=updateBtn; updateBtn();
  }
  document.querySelectorAll("[data-ctrldelcmt]").forEach(el=>el.onclick=()=>{
    const [cid,discId,recId,i]=el.dataset.ctrldelcmt.split("::");
    const r=getCtrlItem(discId,recId,+i); r.comments=r.comments.filter(c=>c.id!==cid);
    saveToStorage(); document.getElementById("v-controls").innerHTML=vControls(); wire();
  });
  // controls photos
  const cpIn=document.getElementById("ctrlphotoinput"); const cpAdd=document.getElementById("ctrladdphoto");
  if(cpAdd&&cpIn) cpAdd.onclick=()=>cpIn.click();
  if(cpIn) cpIn.onchange=async(e)=>{
    const files=[...e.target.files]; if(!files.length) return;
    const recId=state.ctrlRecord||"REC-01";
    const r=getCtrlItem(state.ctrlDiscipline,recId,state.ctrlItem);
    let added=0, failed=0;
    for(const f of files){
      if(f.type.startsWith("image/")){
        try{
          const p=await processImage(f);
          r.photos.push({id:Store._id(),by:Store._author(),at:Store._now(),...p});
          added++;
        }catch(_){ failed++; }
      }else{ failed++; }
    }
    saveToStorage(); document.getElementById("v-controls").innerHTML=vControls(); wire();
    if(added) toast(`${added} photo${added>1?"s":""} added`,"success");
    if(failed) toast(`${failed} photo${failed>1?"s":""} could not be processed`,"warn");
    cpIn.value="";
    checkStorageHealth();
  };
  document.querySelectorAll("[data-ctrldelphoto]").forEach(el=>el.onclick=(e)=>{
    if(e&&e.stopPropagation)e.stopPropagation();
    if(!confirm("Remove this photo? This can't be undone.")) return;
    const [pid,discId,recId,i]=el.dataset.ctrldelphoto.split("::"); const r=getCtrlItem(discId,recId,+i);
    r.photos=r.photos.filter(p=>p.id!==pid); saveToStorage(); document.getElementById("v-controls").innerHTML=vControls(); wire();
    toast("Photo removed","info");
  });

  // -- TDD Vault wiring -----------------------------------------------------
  document.querySelectorAll("[data-tddcat]").forEach(el=>el.onclick=()=>{
    state.tddCat=el.dataset.tddcat; document.getElementById("v-tdd").innerHTML=vTDD(); wire();
  });
  const tddSrch=document.getElementById("tddSearch");
  if(tddSrch){ tddSrch.oninput=()=>{ state.tddSearch=tddSrch.value; document.getElementById("v-tdd").innerHTML=vTDD(); wire(); }; }
  document.querySelectorAll("[data-tddapprove]").forEach(el=>el.onclick=()=>{
    const d=tddDocs.find(x=>x.id===el.dataset.tddapprove);
    if(d){ d.status="approved"; saveToStorage();
      document.getElementById("v-tdd").innerHTML=vTDD(); wire();
      toast(`"${d.name}" approved`,"success");
    }
  });
  document.querySelectorAll("[data-tdddel]").forEach(el=>el.onclick=()=>{
    const id=el.dataset.tdddel;
    const d=tddDocs.find(x=>x.id===id);
    if(!d) return;
    if(confirm(`Remove "${d.name}" from documents?`)){
      tddDocs=tddDocs.filter(x=>x.id!==id);
      saveToStorage(); document.getElementById("v-tdd").innerHTML=vTDD(); wire();
      toast("Document removed","info");
    }
  });
  const tddAdd=document.getElementById("tddAddDoc"); const tddModal=document.getElementById("tdd-modal");
  if(tddAdd&&tddModal){ tddAdd.onclick=()=>{ tddModal.style.display="flex"; }; }
  const tdfSave=document.getElementById("tdf-save"); const tdfCancel=document.getElementById("tdf-cancel");
  if(tdfSave) tdfSave.onclick=()=>{
    const name=document.getElementById("tdf-name").value.trim(); if(!name){toast("Document name is required","warn"); return;}
    tddDocs.push({id:"tdd-"+tddDocSeq++,cat:document.getElementById("tdf-cat").value,name,ref:document.getElementById("tdf-ref").value,rev:document.getElementById("tdf-rev").value,date:document.getElementById("tdf-date").value,by:document.getElementById("tdf-by").value,status:"pending",notes:document.getElementById("tdf-notes").value});
    saveToStorage(); tddModal&&(tddModal.style.display="none"); document.getElementById("v-tdd").innerHTML=vTDD(); wire();
    toast(`Document "${name}" added`,"success");
  };
  if(tdfCancel) tdfCancel.onclick=()=>{ tddModal&&(tddModal.style.display="none"); };
  const tddExp=document.getElementById("tddExport");
  if(tddExp) tddExp.onclick=()=>{
    const header="Name\tRef\tRev\tDate\tCategory\tStatus\tBy\tNotes";
    const dataRows=tddDocs.map(d=>d.name+"\t"+d.ref+"\t"+d.rev+"\t"+d.date+"\t"+d.cat+"\t"+d.status+"\t"+d.by+"\t"+d.notes);
    const rows=[header,...dataRows].join("\n");
    const b=new Blob([rows],{type:"text/plain"}); const u=URL.createObjectURL(b),a=document.createElement("a"); a.href=u; a.download="Ballyroe_Documents.txt"; a.click(); URL.revokeObjectURL(u);
    toast("Document list exported","success");
  };

  // -- Role switcher ---------------------------------------------------------
  const rb=document.getElementById("rolebtn");
  if(rb) rb.onclick=()=>{ isLoggedIn=false; render(); showLogin(); };

  // -- Offline / snapshot ----------------------------------------------------
  const se=document.getElementById("snapExport"); if(se) se.onclick=exportSnapshot;
  const si=document.getElementById("snapImport");
  if(si) si.onchange=function(e){ if(e.target.files&&e.target.files[0]) importSnapshot(e.target.files[0]); };

  // -- Reset to demo defaults: wipe localStorage and re-run seed --------
  const resetBtn = document.getElementById("resetDemoBtn");
  if(resetBtn) resetBtn.onclick = ()=>{
    if(!confirm("Reset all inspections, RFIs and snapshots back to the demo state? This cannot be undone.")) return;
    try{ localStorage.removeItem(LS_KEY); }catch(_){}
    // Wipe in-memory stores then re-seed from D
    inspections = {};
    tableStatus = {};
    stationInspections = {};
    siteInspection = { items:{}, comments:[], photos:[] };
    rfis = {
      "RFI-BAL-001": {
        id:"RFI-BAL-001", scope:"table", target:{fid:"Field 1", row:1, t:1},
        title:"Field 1 · Row 01 · Table 1 — Mechanical complete",
        notes:"All Sigma65 hardware torqued, modules dressed, ready for handover walk.",
        requestedBy:"Conecon GmbH", requestedAt:"2026-05-26T07:40:00.000Z",
        requestedFor:"2026-05-28T09:00:00.000Z", status:"in_progress",
        assignedTo:"Catalin Radu", scheduledFor:"2026-05-28T09:00:00.000Z",
        closedAt:null, outcome:null,
      },
      "RFI-BAL-002": {
        id:"RFI-BAL-002", scope:"station", target:{stationId:"ST1", invIdx:[0,1,2,3]},
        title:"Station T1 — Inverters 1-4 ready for electrical inspection",
        notes:"DC strings landed, MV terminations torqued. Awaiting first acceptance walk.",
        requestedBy:"Conecon GmbH", requestedAt:"2026-05-27T11:15:00.000Z",
        requestedFor:"2026-05-29T10:00:00.000Z", status:"pending",
        assignedTo:null, scheduledFor:null, closedAt:null, outcome:null,
      },
      "RFI-BAL-003": {
        id:"RFI-BAL-003", scope:"site", target:null,
        title:"Site-wide — Road Type 1 sub-base, sections C-D",
        notes:"Sub-base compaction tests passed (CBR results attached separately). Ready for civil acceptance.",
        requestedBy:"Conecon GmbH", requestedAt:"2026-05-25T14:30:00.000Z",
        requestedFor:"2026-05-27T11:00:00.000Z", status:"closed",
        assignedTo:"Catalin Radu", scheduledFor:"2026-05-27T11:00:00.000Z",
        closedAt:"2026-05-27T13:15:00.000Z", outcome:"accepted_with_punch",
      },
    };
    rfiSeq = 4;
    ncrSeq = 16;
    HIST.stack = []; HIST.future = [];
    tddDocs = D.tddSeed.map(d=>({...d}));
    // Restore the original ITPs in case the user edited them
    D.tableItp   = JSON.parse(JSON.stringify(_ORIGINAL_TABLE_ITP));
    D.stationItp = JSON.parse(JSON.stringify(_ORIGINAL_STATION_ITP));
    D.siteItp    = JSON.parse(JSON.stringify(_ORIGINAL_SITE_ITP));
    D.itp = D.tableItp;
    // Re-seed Field 1 / Table 1 inspection items
    Object.entries(D.seed).forEach(([i,[status,note,by,at,photo,ncr]])=>{
      const ins = inspections[ikey("Field 1",1)] || (inspections[ikey("Field 1",1)] = { items:{}, comments:[], photos:[] });
      ins.items[i] = { status, by, at, ncr:ncr||"", photo:!!photo,
        comments: note ? [{ id:"c"+i+"_seed", by, at:new Date().toISOString(), text:note }] : [],
        photos:[] };
    });
    saveToStorage();
    const m=document.getElementById("gear-menu"); if(m) m.classList.remove("open");
    render();
    toast("Reset to demo defaults","success");
  };

  // -- CAD/DWG ingest modal -------------------------------------------------
  const cadBtn = document.getElementById("cadIngestBtn");
  const cadModal = document.getElementById("cadModal");
  const cadClose = document.getElementById("cadModalClose");
  const cadDrop  = document.getElementById("cadDrop");
  const cadFile  = document.getElementById("cadFile");
  const cadResult = document.getElementById("cadResult");
  if(cadBtn && cadModal){
    cadBtn.onclick = ()=>{
      cadModal.style.display = "flex";
      const m=document.getElementById("gear-menu"); if(m) m.classList.remove("open");
      if(cadResult) cadResult.style.display = "none";
    };
  }
  if(cadClose) cadClose.onclick = ()=>{ cadModal.style.display="none"; };
  if(cadModal) cadModal.onclick = (e)=>{ if(e.target===cadModal) cadModal.style.display="none"; };
  const handleCadFiles = async (files)=>{
    if(!files || !files.length) return;
    const names = [...files].map(f=>f.name).join(", ");
    cadResult.style.display = "block";
    cadResult.className = "cad-result info";
    cadResult.innerHTML = `<b>${files.length} file${files.length>1?"s":""} selected:</b> ${esc(names)}<br><span style="color:var(--dim)">Calling <code style="color:var(--hiviz);font-family:'IBM Plex Mono',monospace;font-size:11px">Store.ingestTopology()</code>…</span>`;
    const res = await Store.ingestTopology(files);
    if(!res.ok){
      cadResult.innerHTML += `<br><br><b style="color:var(--amber)">⚠ ${esc(res.message || res.reason)}</b><br><span style="color:var(--dim)">When the backend is connected, this would show the extracted topology for review before commit.</span>`;
    }
  };
  if(cadDrop && cadFile){
    cadDrop.onclick = ()=>cadFile.click();
    cadFile.onchange = (e)=>{ handleCadFiles(e.target.files); cadFile.value=""; };
    ["dragenter","dragover"].forEach(ev=>cadDrop.addEventListener(ev,(e)=>{e.preventDefault();cadDrop.classList.add("drag-over");}));
    ["dragleave","drop"].forEach(ev=>cadDrop.addEventListener(ev,(e)=>{e.preventDefault();cadDrop.classList.remove("drag-over");}));
    cadDrop.addEventListener("drop",(e)=>{ if(e.dataTransfer&&e.dataTransfer.files) handleCadFiles(e.dataTransfer.files); });
  }

  // -- ITP manager modal ----------------------------------------------------
  const itpBtn = document.getElementById("itpManageBtn");
  const itpModal = document.getElementById("itpModal");
  const itpClose = document.getElementById("itpModalClose");
  const itpListWrap = document.getElementById("itpListWrap");
  const itpAdd = document.getElementById("itpAdd");
  const itpAddScopeRow = document.getElementById("itpAddScopeRow");
  const itpAddScope = document.getElementById("itpAddScope");

  /* The active scope tab inside the modal — modal-local state, not in `state` */
  if(window._itpView === undefined) window._itpView = { scope:"table", editing:-1 };

  function _itpEsc(s){ return esc(String(s==null?"":s)); }

  function _itpRender(){
    if(!itpListWrap) return;
    const scope = window._itpView.scope;
    // Set scope-tab highlights
    document.querySelectorAll("[data-itpscope]").forEach(t=>{
      t.classList.toggle("sel", t.dataset.itpscope===scope);
    });
    // Show/hide the Scope row in the Add form (only applies to Tables)
    if(itpAddScopeRow) itpAddScopeRow.style.display = (scope==="table") ? "" : "none";

    const arr = Store._itpArr(scope) || [];
    if(!arr.length){
      itpListWrap.innerHTML = '<div class="itp-empty">No items in this scope. Use the form below to add one.</div>';
      return;
    }
    // Group by category, preserving the original order
    const cats = [];
    const byCat = {};
    arr.forEach((it,idx)=>{
      const cat = it.cat || "Uncategorized";
      if(!byCat[cat]){ byCat[cat] = []; cats.push(cat); }
      byCat[cat].push({it, idx});
    });
    let html = "";
    cats.forEach(cat=>{
      html += `<div class="itp-cat-header">${_itpEsc(cat)}</div>`;
      byCat[cat].forEach(({it,idx})=>{
        const isEditing = window._itpView.editing === idx;
        const scopeTag = (scope==="table" && it.scope) ?
          `<span class="itp-item-tag ${it.scope==="electrical"?"elec":"mech"}">${it.scope==="electrical"?"⚡ ELEC":"⚙ MECH"}</span>` : "";
        const codeTag = it.code ? `<span class="itp-item-tag">${_itpEsc(it.code)}</span>` : "";
        if(isEditing){
          html += `<div class="itp-item"><div class="itp-item-num">#${String(idx+1).padStart(2,'0')}</div>
            <div class="itp-item-main">
              <div class="itp-edit-form">
                <div class="itp-edit-grid">
                  ${scope==="table" ? `<div>
                    <label class="itp-edit-l">Scope</label>
                    <select class="itp-input" data-itpedit-scope="${idx}">
                      <option value="mechanical" ${it.scope==="mechanical"?"selected":""}>⚙ Mechanical</option>
                      <option value="electrical" ${it.scope==="electrical"?"selected":""}>⚡ Electrical</option>
                    </select>
                  </div>` : ""}
                  <div>
                    <label class="itp-edit-l">Category</label>
                    <input class="itp-input" type="text" value="${_itpEsc(it.cat)}" data-itpedit-cat="${idx}" maxlength="80"/>
                  </div>
                  <div>
                    <label class="itp-edit-l">Code</label>
                    <input class="itp-input" type="text" value="${_itpEsc(it.code)}" data-itpedit-code="${idx}" maxlength="6"/>
                  </div>
                </div>
                <div style="margin-bottom:8px">
                  <label class="itp-edit-l">Item name</label>
                  <input class="itp-input" type="text" value="${_itpEsc(it.item)}" data-itpedit-item="${idx}" maxlength="120"/>
                </div>
                <div>
                  <label class="itp-edit-l">Acceptance criteria</label>
                  <textarea class="itp-input itp-crit" data-itpedit-crit="${idx}" rows="5" maxlength="1500">${_itpEsc(it.crit)}</textarea>
                </div>
                <div class="itp-actions">
                  <button class="obtn ok" data-itpedit-save="${idx}">Save changes</button>
                  <button class="obtn" data-itpedit-cancel="${idx}">Cancel</button>
                </div>
              </div>
            </div></div>`;
        } else {
          html += `<div class="itp-item">
            <div class="itp-item-num">#${String(idx+1).padStart(2,'0')}</div>
            <div class="itp-item-main">
              <div class="itp-item-head">
                ${scopeTag}${codeTag}
                <span class="itp-item-name">${_itpEsc(it.item)}</span>
              </div>
              ${it.crit ? `<div class="itp-item-crit">${_itpEsc(it.crit)}</div>` : ""}
            </div>
            <div class="itp-item-actions">
              <button class="itp-iconbtn" data-itpedit="${idx}" title="Edit">
                <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
              </button>
              <button class="itp-iconbtn del" data-itpdel="${idx}" title="Remove">
                <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
              </button>
            </div>
          </div>`;
        }
      });
    });
    itpListWrap.innerHTML = html;
    _itpRewire();
  }

  function _itpRewire(){
    // Edit buttons
    document.querySelectorAll("[data-itpedit]").forEach(el=>el.onclick=()=>{
      window._itpView.editing = +el.dataset.itpedit;
      _itpRender();
    });
    document.querySelectorAll("[data-itpedit-cancel]").forEach(el=>el.onclick=()=>{
      window._itpView.editing = -1;
      _itpRender();
    });
    document.querySelectorAll("[data-itpedit-save]").forEach(el=>el.onclick=()=>{
      const idx = +el.dataset.itpedit_save || +el.dataset["itpeditSave"];
      const i = parseInt(el.dataset.itpeditSave, 10);
      const scope = window._itpView.scope;
      const get = (k)=>{
        const inp = document.querySelector(`[data-itpedit-${k}="${i}"]`);
        return inp ? inp.value : undefined;
      };
      const patch = {
        cat:  get("cat"),
        code: get("code"),
        item: get("item"),
        crit: get("crit"),
      };
      if(scope==="table"){
        patch.scope = get("scope");
      }
      if(!patch.item || !patch.cat){
        toast("Category and Item name are required","warn");
        return;
      }
      pushHistory();
      Store.updateItp(scope, i, patch);
      saveToStorage();
      window._itpView.editing = -1;
      rerenderView();
      const m = document.getElementById("itpModal");
      if(m) m.style.display = "flex";
      _itpRender();
      toast("Item updated","success");
    });
    // Delete buttons
    document.querySelectorAll("[data-itpdel]").forEach(el=>el.onclick=()=>{
      const idx = parseInt(el.dataset.itpdel, 10);
      const scope = window._itpView.scope;
      const used = Store._countItpUsage(scope, idx);
      const arr = Store._itpArr(scope);
      const it = arr[idx];
      let msg = `Remove "${it.item}"?`;
      if(used>0){
        msg += `\n\n${used} inspection record${used===1?"":"s"} ${used===1?"has":"have"} results for this item. The recorded results will be removed.`;
      }
      if(!confirm(msg)) return;
      pushHistory();
      Store.deleteItp(scope, idx);
      saveToStorage();
      rerenderView();
      const m = document.getElementById("itpModal");
      if(m) m.style.display = "flex";
      _itpRender();
      toast(`Item removed${used?` · ${used} result${used===1?"":"s"} cleared`:""}`,"info");
    });
  }

  if(itpBtn && itpModal){
    itpBtn.onclick = ()=>{
      itpModal.style.display = "flex";
      const m=document.getElementById("gear-menu"); if(m) m.classList.remove("open");
      window._itpView.editing = -1;
      _itpRender();
    };
  }
  if(itpClose) itpClose.onclick = ()=>{ itpModal.style.display="none"; };
  if(itpModal) itpModal.onclick = (e)=>{ if(e.target===itpModal) itpModal.style.display="none"; };

  // Tab clicks
  document.querySelectorAll("[data-itpscope]").forEach(t=>t.onclick=()=>{
    window._itpView.scope = t.dataset.itpscope;
    window._itpView.editing = -1;
    _itpRender();
  });

  // Add submit
  const itpAddSubmit = document.getElementById("itpAddSubmit");
  if(itpAddSubmit) itpAddSubmit.onclick = ()=>{
    const scope = window._itpView.scope;
    const cat  = (document.getElementById("itpAddCat")||{}).value || "";
    const code = (document.getElementById("itpAddCode")||{}).value || "";
    const item = (document.getElementById("itpAddItem")||{}).value || "";
    const crit = (document.getElementById("itpAddCrit")||{}).value || "";
    const sub  = (itpAddScope||{}).value || "mechanical";
    if(!cat.trim() || !item.trim()){
      toast("Category and Item name are required","warn"); return;
    }
    pushHistory();
    const newIdx = Store.addItp(scope, {
      cat:cat.trim(), code:code.trim(), item:item.trim(), crit:crit.trim(),
      scope: scope==="table" ? sub : undefined,
    });
    if(newIdx<0){ toast("Could not add item","error"); return; }
    saveToStorage();
    // Reset the form
    ["itpAddCat","itpAddCode","itpAddItem","itpAddCrit"].forEach(id=>{
      const el = document.getElementById(id); if(el) el.value = "";
    });
    // Refresh QC views first (they consume D.tableItp etc.), then re-show the modal.
    rerenderView();
    const m = document.getElementById("itpModal");
    if(m) m.style.display = "flex";
    _itpRender();
    toast("Item added","success");
  };

  // -- RFI register ---------------------------------------------------------
  document.querySelectorAll("[data-rfifilter]").forEach(el=>el.onclick=()=>{
    state.rfiFilter=el.dataset.rfifilter; rerenderRFI();
  });
  document.querySelectorAll("[data-rfi-sel]").forEach(el=>el.onclick=()=>{
    state.rfiSelected=el.dataset.rfiSel; state.rfiNew=false; rerenderRFI();
  });
  const rfiNewBtn=document.getElementById("rfi-new-btn");
  if(rfiNewBtn) rfiNewBtn.onclick=()=>{
    state.rfiNew=true; state.rfiSelected=null;
    state.rfiNewScope=state.rfiNewScope||"table";
    rerenderRFI();
  };
  const rfiCancelNew=document.getElementById("rfi-cancel-new");
  if(rfiCancelNew) rfiCancelNew.onclick=()=>{ state.rfiNew=false; rerenderRFI(); };
  document.querySelectorAll("[data-rfi-newscope]").forEach(el=>el.onclick=()=>{
    state.rfiNewScope=el.dataset.rfiNewscope; rerenderRFI();
  });
  const rfiSubmit=document.getElementById("rfi-submit");
  if(rfiSubmit) rfiSubmit.onclick=()=>{
    const sc=state.rfiNewScope||"table";
    const title=(document.getElementById("rfi-title")||{}).value || "";
    const notes=(document.getElementById("rfi-notes")||{}).value || "";
    const by=(document.getElementById("rfi-by")||{}).value || "Conecon";
    const forV=(document.getElementById("rfi-for")||{}).value || "";
    const requestedFor = forV ? new Date(forV).toISOString() : null;
    if(!title.trim()){ toast("Title is required","warn"); return; }
    let target=null;
    if(sc==="table"){
      const fid=(document.getElementById("rfi-field")||{}).value;
      const row=parseInt((document.getElementById("rfi-row")||{}).value||"1",10);
      const t=parseInt((document.getElementById("rfi-table")||{}).value||"1",10);
      target={fid,row,t};
    } else if(sc==="station"){
      const stationId=(document.getElementById("rfi-station")||{}).value;
      const invStr=(document.getElementById("rfi-invs")||{}).value || "1";
      // Parse "1-4" or "1,3,5" -> zero-indexed array
      const invIdx=[];
      invStr.split(",").forEach(piece=>{
        const m=piece.trim().match(/^(\d+)\s*-\s*(\d+)$/);
        if(m){ const a=+m[1],b=+m[2]; for(let i=Math.min(a,b);i<=Math.max(a,b);i++) invIdx.push(i-1); }
        else { const n=parseInt(piece,10); if(!isNaN(n)) invIdx.push(n-1); }
      });
      target={stationId, invIdx:[...new Set(invIdx)].sort((a,b)=>a-b)};
    }
    pushHistory();
    const id=Store.createRfi({scope:sc, target, title:title.trim(), notes:notes.trim(), requestedBy:by, requestedFor});
    state.rfiNew=false; state.rfiSelected=id;
    rerenderRFI();
    toast(`${id} raised`,"success");
  };
  document.querySelectorAll("[data-rfi-schedule]").forEach(el=>el.onclick=()=>{
    const id=el.dataset.rfiSchedule;
    const assignedTo=(document.getElementById("rfi-assign")||{}).value;
    const schedV=(document.getElementById("rfi-sched-for")||{}).value;
    const scheduledFor=schedV?new Date(schedV).toISOString():null;
    pushHistory();
    Store.scheduleRfi(id, assignedTo, scheduledFor);
    rerenderRFI();
    toast(`${id} scheduled · ${assignedTo}`,"success");
  });
  document.querySelectorAll("[data-rfi-start]").forEach(el=>el.onclick=()=>{
    const id=el.dataset.rfiStart;
    rfiOpenInspection(id);
  });
  document.querySelectorAll("[data-rfi-close]").forEach(el=>el.onclick=()=>{
    const [id,outcome]=el.dataset.rfiClose.split(":");
    const label = RFI_OUTCOME[outcome]?.label || outcome;
    if(!confirm(`Close ${id} as "${label}"?`)) return;
    pushHistory();
    Store.closeRfi(id, outcome);
    rerenderRFI();
    toast(`${id} closed · ${label}`, outcome==="rejected"?"warn":"success");
  });
  document.querySelectorAll("[data-rfi-reopen]").forEach(el=>el.onclick=()=>{
    const id=el.dataset.rfiReopen;
    if(!confirm(`Re-open ${id}?`)) return;
    pushHistory();
    Store.reopenRfi(id);
    rerenderRFI();
    toast(`${id} re-opened`,"info");
  });
  document.querySelectorAll("[data-rfi-delete]").forEach(el=>el.onclick=()=>{
    const id=el.dataset.rfiDelete;
    if(!confirm(`Cancel and delete ${id}? This cannot be undone via the gear menu.`)) return;
    pushHistory();
    Store.deleteRfi(id);
    state.rfiSelected=null;
    rerenderRFI();
    toast(`${id} cancelled`,"warn");
  });
}
let theme = "dark";
function applyTheme(t){
  theme=t;
  if(t==="light") document.documentElement.setAttribute("data-theme","light");
  else document.documentElement.removeAttribute("data-theme");
  refreshThemeColors();
  try{ localStorage.setItem("tt-theme",t); }catch(_){}
}
function toggleTheme(){
  applyTheme(theme==="dark"?"light":"dark");
  // re-render so SVG/canvas colors (donut, compass, schematic, charts) pick up the new theme
  render();
}

/* ---- React/Supabase mount seam (added) --------------------------------- */
function boot(){
let _saved="dark"; try{ _saved=localStorage.getItem("tt-theme")||"dark"; }catch(_){}
applyTheme(_saved);

// Load persisted data and seed QC records on first run
const hadData = loadFromStorage();
if(!hadData){
  // Seed the table-level QC data from D.seed on first load
  const ins = getInsp("Field 1", 1);
  Object.entries(D.seed).forEach(([i,[status,note,by,at,photo,ncr]]) => {
    ins.items[+i] = {status,note,photo:!!photo,by,at,ncr:ncr||"",comments:[],photos:[]};
  });
}
// Always show login so role can be confirmed each session.
// Last-used role is pre-selected (restored from localStorage above).
isLoggedIn = false;
render();
showLogin();
}
// Headless boot for component mode: load data + theme, NO DOM render.
function bootHeadless(){
  let _saved="dark"; try{ _saved=localStorage.getItem("tt-theme")||"dark"; }catch(_){}
  applyTheme(_saved);
  const hadData = loadFromStorage();
  if(!hadData){
    const ins = getInsp("Field 1", 1);
    Object.entries(D.seed).forEach(([i,[status,note,by,at,photo,ncr]]) => {
      ins.items[+i] = {status,note,photo:!!photo,by,at,ncr:ncr||"",comments:[],photos:[]};
    });
  }
  isLoggedIn = false;
}
if (typeof window !== "undefined") {
  window.__gpBoot = boot;
  window.__gpBootHeadless = bootHeadless;
  window.__gpRender = render;
  window.__gpEngine = {
    // --- mutable data stores ---
    get inspections(){ return inspections; }, set inspections(v){ inspections = v; },
    get tableStatus(){ return tableStatus; }, set tableStatus(v){ tableStatus = v; },
    get stationInspections(){ return stationInspections; }, set stationInspections(v){ stationInspections = v; },
    get siteInspection(){ return siteInspection; }, set siteInspection(v){ siteInspection = v; },
    get rfis(){ return rfis; }, set rfis(v){ rfis = v; },
    get rfiSeq(){ return rfiSeq; }, set rfiSeq(v){ rfiSeq = v; },
    get ncrSeq(){ return ncrSeq; }, set ncrSeq(v){ ncrSeq = v; },
    ncrRef,
    get tddDocs(){ return tddDocs; }, set tddDocs(v){ tddDocs = v; },
    get controlsData(){ return controlsData; },
    // --- session / view state ---
    get state(){ return state; },
    get currentRole(){ return currentRole; }, set currentRole(v){ currentRole = v; },
    get isLoggedIn(){ return isLoggedIn; }, set isLoggedIn(v){ isLoggedIn = v; },
    get theme(){ return theme; },
    setRole(r){ currentRole = r; }, login(){ isLoggedIn = true; },
    // --- static reference data + maps ---
    D, get records(){ return records; }, STATUS, RFI_STATUS, RFI_OUTCOME, C,
    // --- formatting / utils ---
    esc, fmt, fmtDate, fmtDateTime, fmtTime, toast,
    // --- computed / roll-ups (DO NOT reimplement in TS) ---
    qcCounts, allResults, fieldStats, siteCounts,
    punchItems, punchByCat, punchByLocation, punchLocKey, punchCounts, punchPinsForMap, pinColorFor,
    tableEffectiveStatus, recStarted, itemStarted: _itemStarted, tableRoll, moduleRoll, moduleTableRoll,
    pileRoll, pileTableRoll, pileInfo, stationInvRoll, stationRoll, siteRoll,
    rowsForField, tablesInRow, tableTypeFor, applyTopology, applyInverterTopology, invLabel, invShort,
    getInsp, itemResult, getModule, modItemResult, getPile, pileItemResult,
    getStationInv, stationInvItemResult, siteItemResult,
    rfiList, rfiCounts, rfiTargetLabel, rfiSuggestedOutcome, scopeBadge,
    storageUsageKB, checkStorageHealth,
    // --- mutations / actions ---
    Store, setItemStatus, setTableAll, updItem, setSiteItem, setStationInvItem,
    pushHistory, undo, redo, applyTheme, toggleTheme, saveToStorage,
    loadFromStorage, exportSnapshot, importSnapshot, processImage, rfiOpenInspection,
    exportReport, exportFieldReport, exportStationReport, exportSiteReport, exportExecutiveReport, exportPunchPDF, exportPunchExcel,
    // --- legacy view renderers + event binding (for not-yet-converted views) ---
    chrome, navTabsHTML, vOverview, vRFI, vSiteMap, vQC, vPunch, vTDD,
    wire, refreshBadges, rerenderView, rerenderQC, rerenderRFI, setView, showLogin,
  };
}
export { boot, bootHeadless };
